export const DE = {
  AactivityOnboarding: {
    SUMMARY: {
      ACTIVITY_TEXT: 'Häufigkeit des Auslaufs'
    }
  },
  CANCEL_SUBSCRIPTION: {
    FIRST_SCREEN_XSXTmention: '*Nur für die Tracker XS und XT'
  },
  HipayPayments: {
    CARDNUMBER: 'Kartennummer',
    EXPIRYDATE: 'Ablaufdatum',
    FULLNAME: 'Vollständiger Name',
    GOCARDLESS_LINK: 'Durch Bankeinzug zahlen',
    YOURNAME: 'Ihr Name'
  },
  Slider: {
    GPS_INTERVAL: 'GPS-Intervall',
    GPS_POSITION_REPORT_ENABLED: 'GPS-Positionsübertragung aktiviert',
    TRACKER_INTERVAL_TEXT_WARNING: 'Wenn Sie die automatische Übertragung von GPS-Positionen ausschalten, erhöhen Sie die Lebensdauer des Akkus. Sie können zwar manuell einen neuen Standort abfragen, aber die Sicherheitszonen und der Verlauf werden nicht mehr angezeigt.'
  },
  TypeSwitch: {
    ANIMAL_SUBTITLE: 'Wählen Sie das Tier, für das Sie den Tracker gekauft haben:',
    CAT_TYPE: 'Katzen-Tracker',
    DOG_TYPE: 'Hunde-Tracker',
    FAMILY_SUBTITLE: 'Für wen haben Sie den Tracker gekauft?',
    KID_TYPE: 'Ein Kind',
    SILVER_TYPE: 'Ein Senior',
    TITLE: 'Für wen ist der Tracker?'
  },
  account: {
    LANGUAGE: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Sprache erfolgreich aktualisiert'
      }
    },
    NAV: {
      LANGUAGE: 'Sprache',
      PASSWORD: 'Passwort',
      PAYMENTS: 'Rechnungsstellung',
      USER_PREFERENCES: 'Voreinstellungen',
      USER_PROFILE: 'Benutzerprofil'
    },
    PASSWORD: {
      HEADLINE: 'Passwortänderung',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_ERROR_WRONG_PASSWORD: 'Sie haben ein falsches altes Passwort eingegeben.',
        UPDATE_SUCCESS: 'Das Passwort wurde geändert.'
      }
    },
    PAYMENTS: {
      HISTORY_HEADLINE: 'Zahlungsverlauf',
      MAIN_HEADLINE: 'Rechnungsstellung'
    },
    USER_PREFERENCES: {
      EMAIL_PREFERENCES_HEADLINE: 'E-Mail-Voreinstellungen',
      EMAIL_PREFERENCES_USER_INFO: 'Die Einstellungen werden auf die E-Mail-Adresse angewendet {{user_email}}',
      MAIN_HEADLINE: 'Voreinstellungen',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Beim Speichern der Voreinstellungen ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Voreinstellungen wurden erfolgreich aktualisiert.'
      },
      METRIC_PREFERENCES_DESCRIPTION: 'Wählen Sie die für Ihren Tracker verwendete Entfernungseinheit.',
      METRIC_PREFERENCES_HEADLINE: 'Präferenz für das metrische System'
    },
    USER_PROFILE: {
      BASIC_INFO_HEADLINE: 'Basisinformationen',
      BILLING_HEADLINE: 'Rechnungsadresse',
      MAIN_HEADLINE: 'Benutzerprofil',
      MARKETING_AGREEMENT_TEXT: 'Ich bin damit einverstanden, Angebote und Werbeaktionen von Weenect-Partnern zu erhalten.',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Daten erfolgreich aktualisiert'
      },
      METRIC_KM: 'Kilometer',
      METRIC_MILES: 'Meilen',
      PREFERRED_METRIC: 'Zu verwendende Maβeinheit:'
    }
  },
  accounttab: {
    CANCEL_CTA: 'Abbrechen',
    ERROR_EMAIL_ALREADY_USED: 'Diese E-Mail-Adresse ist bereits mit einem Konto verknüpft',
    ERROR_FORMAT: 'Entschuldigung, dieses Format ist ungültig',
    ERROR_INVALID_CREDENTIALS: 'Ungültiges Passwort.',
    ERROR_NETWORK: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    PASSWORD_CHANGE_SUBTITLE: 'Passwort ändern',
    PASSWORD_LENGTH_ERROR: 'Das Passwort muss mindestens 8 Zeichen enthalten',
    PASSWORD_LENGTH_HELPER: 'Mindestlänge: 8 Zeichen',
    PASSWORD_NEW_LABEL: 'Neues Passwort',
    PASSWORD_OLD_LABEL: 'Altes Passwort',
    PASSWORD_SECTION_TITLE: 'Passwort',
    PASSWORD_SECURITY_NOTE: 'Aus Sicherheitsgründen werden Sie nach dem Ändern des Passworts von allen Geräten abgemeldet. Sie müssen sich mit dem neuen Passwort erneut anmelden.',
    PREF_DISPLAY_THEME_DARK: 'Dunkel',
    PREF_DISPLAY_THEME_DESCRIPTION: 'Wählen Sie das Anzeige-Thema Ihres Weenect-Bereichs.',
    PREF_DISPLAY_THEME_LIGHT: 'Hell',
    PREF_DISPLAY_THEME_SYSTEM: 'System',
    PREF_DISPLAY_THEME_TITLE: 'Thema',
    PREF_EMAILS_COMPANY_NEWS: 'Unternehmensnachrichten',
    PREF_EMAILS_DESCRIPTION: 'Wählen Sie die Art der E-Mails, die Sie erhalten möchten. Wir senden Ihnen nur die, die Ihren Auswahl entsprechen. Die Einstellungen gelten für die E-Mail-Adresse {{email}}',
    PREF_EMAILS_NEW_FEATURES: 'Neue Funktionen',
    PREF_EMAILS_OFFERS: 'Werbeangebote',
    PREF_EMAILS_PARTNERS_CONSENT: 'Ich akzeptiere den Erhalt von Angeboten und Werbeaktionen von Weenect-Partnern',
    PREF_EMAILS_SUBTITLE: 'E-Mail-Einstellungen',
    PREF_EMAILS_SURVEYS_BETA: 'Umfragen und Beta-Tests',
    PREF_METRIC_DESCRIPTION: 'Wählen Sie die Entfernungseinheit für Ihren Tracker.',
    PREF_METRIC_KM: 'Kilometer',
    PREF_METRIC_MILES: 'Meilen',
    PREF_METRIC_SUBTITLE: 'Maßeinheit-Einstellung',
    PREF_SECTION_TITLE: 'Einstellungen',
    PREF_TRACKING_CONSENT: 'Ich akzeptiere das Tracking der Öffnung meiner E-Mails',
    PREF_TRACKING_DESCRIPTION: 'Das Tracking der Öffnungen hilft uns, die Effektivität unserer Kommunikation zu messen und die Häufigkeit sowie den Inhalt unserer E-Mails anzupassen.',
    PREF_TRACKING_SUBTITLE: 'E-Mail-Öffnungs-Tracking',
    PREF_WEENECT_ANGELS_DISTANCE_DESCRIPTION: 'Wählen Sie die Entfernung um Ihren Tracker, in der verlorene Tiere angezeigt werden.',
    PREF_WEENECT_ANGELS_DISTANCE_VALUE: '{{km}} km',
    PREF_WEENECT_ANGELS_NOTIF_CONSENT: 'Ich akzeptiere den Erhalt von Benachrichtigungen für Weenect Angels',
    PREF_WEENECT_ANGELS_NOTIF_DESCRIPTION: 'Möchten Sie Benachrichtigungen zu dieser Funktion erhalten?',
    PREF_WEENECT_ANGELS_TITLE: 'Weenect Angels',
    PROFIL_ADDRESS_PLACEHOLDER: 'Adresse',
    PROFIL_BASIC_INFO_SUBTITLE: 'Basisinformationen',
    PROFIL_BILLING_ADDRESS_SUBTITLE: 'Rechnungsadresse',
    PROFIL_CITY_PLACEHOLDER: 'Stadt',
    PROFIL_COUNTRY_PLACEHOLDER: 'Land',
    PROFIL_EMAIL_PLACEHOLDER: 'E-Mail-Adresse',
    PROFIL_FIRSTNAME_PLACEHOLDER: 'Vorname',
    PROFIL_LASTNAME_PLACEHOLDER: 'Nachname',
    PROFIL_PHONE_PLACEHOLDER: 'Telefonnummer',
    PROFIL_POSTAL_CODE_PLACEHOLDER: 'Postleitzahl',
    PROFIL_SECTION_TITLE: 'Benutzerprofil',
    SAVE_CTA: 'Speichern'
  },
  activity: {
    AVERAGE_SPEED: 'Durchschnittsgeschwindigkeit',
    CONTROLS: {
      PAUSE_PLAYING_TITLE: 'Verlaufs Video anhalten',
      RESUME_PLAYING_TITLE: 'Verlaufs Video erneut abspielen',
      START_PLAYING: 'Starten',
      START_PLAYING_TITLE: 'Verlaufs Video abspielen',
      STOP_PLAYING: 'Stopp',
      STOP_PLAYING_TITLE: 'Verlaufs Video anhalten',
      TOGGLE_HEATMAP: 'Thermokarte',
      TOGGLE_HEATMAP_TITLE: 'Thermokarte anzeigen',
      TOGGLE_PATH: 'Standortverlauf',
      TOGGLE_PATH_TITLE: 'Standortverlauf anzeigen'
    },
    DETAIL_TITLE: 'Aktivitätendetails',
    EMPTY_LIST: 'Keine Benachrichtigungen vorhanden. Ändern Sie den ausgewählten Zeitraum oder überprüfen Sie, dass der Tracker richtig eingeschaltet ist.',
    EVENTS: {
      ALERT: 'Seitentaste betätigt',
      BATTERY: 'Akku schwach – {{battery}}% verbleiben',
      CALL_END: 'SOS-Anruf beendet',
      CALL_REQ: 'SOS-Anruf angefordert',
      ENTERS_GEOFENCE: 'Eintritt in die Zone',
      EXIT_GEOFENCE: 'Verlassen der Zone',
      FLASH_REQ: 'Blitz gefragt',
      FREQ_CHANGE: 'Das Zeitintervall wurde geändert.',
      RING: 'Klingeln durchgeführt',
      RING_REQ: 'Klingelanfrage gesendet',
      SOS: 'SOS-Alarm',
      TRACKER_OFF: 'Tracker ausgeschaltet',
      TRACKER_ON: 'Tracker eingeschaltet',
      VIBRATE: 'Vibration durchgeführt',
      VIBRATE_REQ: 'Vibrationsanfrage gesendet'
    },
    FEEDBACKTEXT: {
      FIRST: '',
      SECOND: ''
    },
    HISTORY_TITLE: 'Benachrichtigungsverlauf',
    LAST_TIME_PERIOD: 'Letzte (...) anzeigen',
    LOADING: 'Wird geladen ...',
    MAXIMUM_SPEED: 'Max. Geschwindigkeit',
    OBJECTIVE: {
      CONTENT: 'Setzen Sie sich ein Ziel für die intensive Aktivität, das Sie täglich erreichen wollen.',
      DAILY_REACHED: '{{name}} hat ihr Tagesziel erreicht!',
      HELPTEXT: 'Bei der Messung des Tagesziels wird nur die intensive Aktivität berücksichtigt. Zum Beispiel ein Lauf oder ein aktives Spiel.',
      RECOMENDED_VALUE: 'Empfohlenes Ziel: 1 Stunde',
      SUBTEXT: 'Unser Algorithmus zeichnet jede Bewegung Ihres Trackers auf und klassifiziert die Ergebnisse dann nach Intensitätsgrad. Auf diese Weise können wir feststellen, ob es sich um eine intensive, moderate oder geringe Aktivität handelt.',
      TITLE: 'Tägliches Ziel'
    },
    ONBOARDING: {
      FIRST_SUBTEXT: 'Mit diesem Tool können Sie die täglichen Aktivitäten Ihres Vierbeiners verfolgen.',
      SECOND_SUBTEXT: 'Wie lange hat er geschlafen? Wie viele Schritte hat er heute gemacht?',
      START: 'Starten',
      THIRD_SUBTEXT: 'Sie können sich sogar ein Ziel für die Rasse Ihres Haustiers setzen, damit es die tägliche Aktivität bekommt, die es braucht.',
      TITLE: 'Willkommen bei der Weenect-Aktivitätsüberwachung!'
    },
    PROGRESSBAR: {
      TITLE: 'Tägliches Ziel'
    },
    REPARTION: {
      DAY: 'Am heutigen Tag.',
      MONTH: 'in den letzten 30 Tagen',
      WEEK: 'in den letzten 7 Tagen'
    },
    SELECT_DAY: 'Einen Tag auswählen',
    SELECT_TIME: 'Benutzen Sie ihre Maus, um den Zeitraum auszuwählen, der angezeigt werden soll',
    SUMMARY: {
      ACTIVITY: 'Intensiv',
      AWAKENING: 'Moderat',
      DATEINTERVAL: '',
      DAY_INDEX: 't',
      DISTRIBUTIONTEXT: 'Übersicht',
      HOUR_INDEX: 's',
      LASTWEEK: '',
      MENU_TITLE: 'Tätigkeitsbericht',
      MIN_INDEX: 'min',
      MODIFY_PERIOD: 'Zeitraum ändern',
      PREVIOUS_DAY: '',
      PREVIOUS_MONTH: '',
      PREVIOUS_WEEK: '',
      REGISTERED_ACTIVITY: 'Schritte',
      REPORT: 'Bericht anzeigen ',
      REST: 'Gering',
      SUBTEXT: 'Noch {{time}} intensive Aktivität, bevor {{name}}s Ziel erreicht ist.',
      TEXT_OBJECTIVE_COMPLETED: '{{name}} hat ihr Tagesziel erreicht!',
      TEXT_OBJECTIVE_COMPLETED_TREAT: 'Herzlichen Glückwunsch, {{name}} hat ihr Ziel erreicht! Vielleicht verdient sie ein kleines Leckerli?',
      TEXT_OBJECTIVE_NONE: '{{name}} hat noch keine Daten für diesen Zeitraum.',
      TEXT_OBJECTIVE_NONE_VERIFY_TRACKER: '{{name}} hat noch keine Bewegungen aufgezeichnet. Vergewissern Sie sich, dass Ihr Tracker eingeschaltet und der Akku geladen ist!',
      TITTLE: '{{name}} Fortschritte',
      TODAY: 'Heute,',
      TOTAL: 'Gesamt',
      YESTERDAY: 'gestern'
    },
    TIME_ELAPSED: 'Dauer',
    TOTAL_DISTANCE: 'Gesamtentfernung'
  },
  activityGeneral: {
    BEHAVIOR: 'Aktivität',
    STANDARD_MORPHOLOGY: 'Morphologie ',
    STERILIZED: 'Kastriert?'
  },
  activityOnboarding: {
    COMMON: {
      STEP: 'Schritt',
      TRACKER_PROFIL: 'Tracker-Profil'
    },
    MONTH: {
      APRIL: 'April',
      AUGUST: 'August',
      DECEMBER: 'Dezember',
      FEBRUARY: 'Februar',
      JANUARY: 'Januar',
      JULY: 'Juli',
      JUNE: 'Juni',
      MARCH: 'März',
      MAY: 'Mai',
      NOVEMBER: 'November',
      OCTOBER: 'Oktober',
      SEPTEMBER: 'September'
    },
    PET_ACTIVITY: {
      FIRST_BUTTON: 'Inaktiv (minimale Aktivität)',
      FIRST_BUTTON_CAT: 'Ausnahmsweise (Urlaub, unvorhergesehene Ereignisse...)',
      FIRST_BUTTON_DOG: 'Nur für ihre Bedürfnisse',
      FOURTH_BUTTON: 'Sehr aktiv (zwei bis drei Spaziergänge pro Tag)',
      FOURTH_BUTTON_CAT: 'Regelmäßig, sowohl tagsüber als auch nachts',
      FOURTH_BUTTON_DOG: '2 bis 3 Spaziergänge/Tag',
      SECOND_BUTTON: 'Normal (zwei bis drei Spaziergänge pro Woche)',
      SECOND_BUTTON_CAT: 'Gelegentlich, auf eigenen Wunsch\n',
      SECOND_BUTTON_DOG: '2 bis 3 Spaziergänge pro Woche',
      SELECT_ACTIVITY: 'Wie oft geht es nach draußen?',
      THIRD_BUTTON: 'Aktiv (ein Spaziergang pro Tag)',
      THIRD_BUTTON_CAT: 'Regelmäßig, tagsüber',
      THIRD_BUTTON_DOG: 'Ein Spaziergang pro Tag',
      TITLE: 'Wie würden Sie das sportliche Profil Ihres Tieres beschreiben?'
    },
    PET_AGE: {
      FIRST_COMMON_TEXT: 'Jahr(e) und ',
      SECOND_COMMON_TEXT: 'Monat(e)',
      TITLE: 'Wie lautet das Geburtsdatum?'
    },
    PET_GENDER: {
      FEMALE: 'Weiblich',
      FIRST_TITLE: 'Ist Ihr Haustier weiblich oder männlich?',
      MALE: 'Männlich',
      SECOND_TITLE: 'Ist Ihr Haustier kastriert?'
    },
    PET_HEALTH: {
      LAST_VACINATION: 'Wie war seine letzte Impfung?',
      LAST_VET_VISIT: 'Wann war er zuletzt beim Tierarzt?',
      TITLE: 'Gesundheitspunkt'
    },
    PET_IDENTIFICATION: {
      CHIP: 'Gechippt',
      NONE: 'Mein Tier ist nicht gekennzeichnet',
      SELECT_IDENTIFICATION: 'Wie wird er identifiziert?',
      TATTOO: 'Tätowiert'
    },
    PET_INFO: {
      GET_STARTED: 'Los geht\'s!',
      NEED_TO_KNOW: 'Es ist wichtig für uns, dass wir  {{name}} kennenlernen.',
      PETS_DETAILS: 'Füllen Sie die Informationen über Ihr Haustier aus!',
      PETS_GENDER: {
        MIXED_BREED: 'Er ist ein Mischling'
      },
      PET_GENDER_COMMON: 'Zu Beginn ist Ihr Haustier: ',
      SECOND_PETS_DETAILS: 'Füllen Sie die Daten Ihres Haustiers aus'
    },
    PET_MORPH: {
      AVERAGE: 'Normal',
      COMMON_TEXT: 'Circa',
      FIRST_TITLE: 'Wie würden Sie den Körperbau Ihres Tieres beschreiben?',
      HELP_TEXT: 'Wie kann ich den Körperbau meines Tieres bestimmen?\n',
      LEAN: 'Mager',
      OBESE: 'Übergewichtig',
      OVERWEIGHT: 'Übergewichtig',
      SECOND_TITLE: 'Wie viel wiegt Ihr Tier?',
      WEIGH_TEXT: 'Wie viel wiegt Ihr Tier?\n'
    },
    PET_NAME: {
      COMMON_TEXT: 'Zunächst möchten wir Ihr Haustier gern kennenlernen.\u2028 Anschließend können Sie diese Angaben in den Einstellungen ändern. ',
      PLACEHOLDER: 'Name Ihres Tieres',
      TITLE: 'Wie heißt er/sie?'
    },
    PET_RACE: {
      COMMON_TEXT: 'Rasse unbekannt',
      PLACEHOLDER: 'Rasse Ihres Hundes',
      SELECT_BREED: 'Wählen Sie die Rasse aus',
      TITLE: 'Welcher Rasse gehört Ihr Tier an?'
    },
    PET_TYPE: {
      CAT: 'Eine Katze',
      DOG: 'Ein Hund'
    },
    SUMMARY: {
      BIRTH_DATE: 'Geburtsdatum',
      BREED: 'Rasse',
      CONDITION: 'Zustand',
      DAILY_EXERCISE: 'Tägliche Bewegung',
      DELETE: 'Das Profil zurücksetzen.',
      HEALTH: 'Gesundheit',
      IDENTIFICATION: 'Kennzeichnung',
      MODAL: {
        NO: 'Nein, abbrechen',
        SUBTEXT: 'Dann müssen Sie den Vorgang noch einmal von vorne beginnen.',
        TITLE: 'Sind Sie sicher, dass Sie die Informationen Ihres Haustiers zurücksetzen möchten?',
        YES: 'Ja, ich bin sicher'
      },
      MORPHOLOGY: 'Körperbau',
      NAME: 'Namen',
      RECAPTEXT: 'Hier sind die Informationen über Ihren Begleiter.',
      SEX: 'Geschlecht',
      SPECIES: 'Spezies',
      SUBMIT: 'Profil bestätigen',
      UNSPECIFIED: 'felder',
      VALIDATION: 'Validierung des Profils',
      VALIDATION_TEXT: 'Bitte bestätigen Sie Ihre Angaben, bevor Sie fortfahren. ',
      WEIGHT: 'Gewicht'
    }
  },
  activityTracking: {
    ACTIVITY: 'Aktivität',
    ACTIVITY_DISTRIBUTION: {
      DATA_COMPARATOR: {
        ACTIVITY_INTENSE: 'Intensive Aktivität',
        ACTIVITY_INTENSE_LEGEND: 'intensive Aktivität {{day}}',
        ACTIVITY_INTENSE_LEGEND1_DAY: 'intensive Aktivität gestern',
        ACTIVITY_INTENSE_LEGEND1_MONTH: 'intensive Aktivität in diesem Monat',
        ACTIVITY_INTENSE_LEGEND1_WEEK: 'intensive Aktivität diese Woche',
        ACTIVITY_INTENSE_LEGEND2_DAY: 'intensive Aktivität vorgestern',
        ACTIVITY_INTENSE_LEGEND2_MONTH: 'intensive Aktivität im letzten Monat',
        ACTIVITY_INTENSE_LEGEND2_WEEK: 'intensive Aktivität letzte Woche',
        ACTIVITY_LOW_LEGEND1_DAY: 'geringe Aktivität gestern',
        ACTIVITY_LOW_LEGEND1_MONTH: 'geringe Aktivität in diesem Monat',
        ACTIVITY_LOW_LEGEND1_WEEK: 'geringe Aktivität diese Woche',
        ACTIVITY_LOW_LEGEND2_DAY: 'geringe Aktivität vorgestern',
        ACTIVITY_LOW_LEGEND2_MONTH: 'geringe Aktivität im letzten Monat',
        ACTIVITY_LOW_LEGEND2_WEEK: 'geringe Aktivität letzte Woche',
        ACTIVITY_MODERATE: 'Moderate Aktivität',
        ACTIVITY_MODERATE_LEGEND: 'moderate Aktivität {{day}}',
        ACTIVITY_MODERATE_LEGEND1_DAY: 'moderate Aktivität gestern',
        ACTIVITY_MODERATE_LEGEND1_MONTH: 'moderate Aktivität in diesem Monat',
        ACTIVITY_MODERATE_LEGEND1_WEEK: 'moderate Aktivität diese Woche',
        ACTIVITY_MODERATE_LEGEND2_DAY: 'moderate Aktivität vorgestern',
        ACTIVITY_MODERATE_LEGEND2_MONTH: 'moderate Aktivität im letzten Monat',
        ACTIVITY_MODERATE_LEGEND2_WEEK: 'moderate Aktivität letzte Woche',
        ACTIVITY_WEAK: 'Niedrige Aktivität',
        ACTIVITY_WEAK_LEGEND: 'niedrige Aktivität {{day}}',
        TEXT: '{{petName}}s {{activity}}e Aktivitätsdauer war gestern {{comparator}} {{day}}.'
      }
    },
    ACTIVITY_REPORT: {
      DATA_COMPARATOR: {
        LEGEND: {
          KM_MONTHLY: 'Kilometer im Durchschnitt pro Tag in diesem Monat',
          KM_WEEKLY: 'Kilometer im Durchschnitt pro Tag in dieser Woche',
          KM_YESTERDAY: 'Kilometer gestern zurückgelegt',
          STEP_MONTHLY: 'Schritte im Durchschnitt pro Tag in diesem Monat',
          STEP_WEEKLY: 'Schritte im Durchschnitt pro Tag in dieser Woche',
          STEP_YESTERDAY: 'Schritte gestern geschafft'
        },
        LEGEND1: {
          STEP_DAY: 'Schritte am gestrigen Tag',
          STEP_MONTH: 'durchschnittliche tägliche Schritte diese Woche',
          STEP_WEEK: 'Gestern zurückgelegte Schritte'
        },
        LEGEND2: {
          STEP_DAY: 'Schritte vorgestern',
          STEP_MONTH: 'Durchschnittliche tägliche Schritte in diesem Monat',
          STEP_WEEK: 'durchschnittliche tägliche Schritte der letzten 7 Tage'
        },
        TEXT_INF: 'kleiner als ',
        TEXT_KM_DAILY: 'Die Anzahl der gestern von {{petName}} zurückgelegten Kilometer ist {{comparator}} vorgestern.',
        TEXT_KM_MONTHLY: 'Die durchschnittliche Anzahl der in dieser Woche von {{petName}} zurückgelegten Kilometer ist {{comparator}} der aktuelle monatliche Durchschnitt. ',
        TEXT_KM_WEEKLY: 'Die Anzahl der gestern von {{petName}} zurückgelegten Kilometer ist {{comparator}} der wöchentliche Durchschnitt.',
        TEXT_SIM: 'genauso hoch wie',
        TEXT_STEP_DAILY: '{{petName}}s gestern zurückgelegte Schrittzahl ist {{comparator}} vorgestern.',
        TEXT_STEP_MONTHLY: 'Die durchschnittliche Schrittzahl, die {{petName}} diese Woche zurückgelegt hat, ist {{comparator}} der monatliche Durchschnitt.',
        TEXT_STEP_WEEKLY: '{{petName}}s gestern zurückgelegte Schrittzahl ist {{comparator}} der wöchentliche Durchschnitt.',
        TEXT_SUP: 'größer als',
        TITLE_KM_TRAVELED: 'Zurückgelegte Kilometer',
        TITLE_STEP: 'Schritte'
      },
      KM_TRAVELED: '{{step}} zurückgelegte Kilometer'
    },
    AIMED_GOAL: {
      ALERT: 'Wir empfehlen ein tägliches Ziel von mindestens 3 Stunden, um Ihr Haustier gesund zu halten.',
      TITLE: 'Setzen Sie sich ein tägliches Aktivitätsziel.'
    },
    DAILY_CHART: '{{petName}}s Aktivität',
    DAILY_GOAL: {
      NOT_RECOMMENDED: 'Ziel nicht empfohlen',
      RECOMMENDED: 'Empfohlenes Ziel',
      SECOND_TITLE: 'Tägliches Ziel',
      TITLE: 'Tägliches Ziel'
    },
    DAILY_STEP: 'Tägliche Schritte',
    DAYS: 'Tag',
    EQUAL: 'genauso lang wie',
    ERROR_PAGE: {
      BUTTON_TEXT: 'Seite schließen',
      TEXT: 'Wir können die Seite derzeit nicht laden. Bitte versuchen Sie es später noch einmal.',
      TITLE: 'Oops, wir haben ein Problem festgestellt...'
    },
    HEADER: {
      ACTIVITY_DISTRIBUTION: {
        TITLE: 'Aktivitätsaufteilung'
      },
      ACTIVITY_REPORT: {
        TITLE: 'Aktivitätsbericht'
      },
      GOAL: {
        TITLE: 'Tägliches Ziel'
      }
    },
    HOME: {
      ACTIVITY_DISTRIBUTION: {
        INTENSE: 'Intensiv',
        MODERATE: 'Moderat',
        WEAK: 'Niedrig'
      },
      ALERT: 'Um zuverlässige Daten zu gewährleisten, muss das Aktivitätstracking mehrere Tage genutzt werden. Während dieser Zeit sammelt und analysiert der Algorithmus Ihre Daten, um die Aktivitätsgewohnheiten und -muster Ihres Tieres zu verstehen. Mit der Zeit werden die Ergebnisse immer genauer und an das Profil Ihres Vierbeiners angepasst.',
      FIRST_SECTION: {
        TITLE: 'Tägliches Ziel'
      },
      INSURANCE: {
        BUTTON: 'Weenect Versicherung - Mehr erfahren',
        TEXT: 'Ein Besuch beim Tierarzt ist erforderlich. Keine Sorge - Unsere Weenect Versicherung kümmert sich um die Kostenrückerstattung der Tierarztkosten. '
      },
      MODIFY: 'Ändern',
      PROFILE: {
        SUBTITLE: 'Behalten Sie die tägliche Aktivität Ihres Tieres im Blick, um es fit zu halten. '
      },
      SECOND_SECTION: {
        SUBTITLE: 'Am heutigen Tag',
        TITLE: 'Aktivitätsaufteilung'
      },
      SEE_MORE: 'Mehr',
      THIRD_SECTION: {
        TITLE: 'Highlights'
      }
    },
    HOUR: '{{count}} h',
    HOURS: 'Stunden',
    INTERVAL: {
      TEXT: 'Verschieben Sie die Ränder des Diagramms, um den angezeigten Zeitraum zu ändern.',
      TITLE: 'Zeitraum auswählen'
    },
    KEY_POINTS: 'Highlights',
    KILOMETERS: 'Kilometer',
    LESS: 'kürzer als',
    MIN: 'Minuten',
    MINUTE_ACTIVITY_one: '{{count}} Minute Aktivität',
    MINUTE_ACTIVITY_other: '{{count}} Minuten Aktivität',
    MINUTE_one: '{{count}} Minute',
    MINUTE_other: '{{count}} Minuten',
    MIN_one: '{{count}} min',
    MIN_other: '{{count}} min',
    MONTHLY_STEP: 'Monatliche Schritte',
    ONBOARDING: {
      FIRST_STEP: {
        ALERT: 'Im Flugzeugmodus wird das Aktivitätstracking weiterhin aufgezeichnet. Sobald Sie die WLAN-Zone verlassen, wird es im Dashboard angezeigt.',
        BUTTON: 'Starten',
        MESSAGE: 'Mit diesem Tool können Sie die täglichen Aktivitäten Ihres Vierbeiners verfolgen.  Wie lange hat er geschlafen? Wie viele Schritte hat er heute gemacht? All das wird schon bald kein Geheimnis mehr für Sie sein!',
        TITLE: 'Willkommen beim Aktivitätstracking Ihres Haustiers!'
      },
      SECONDE_STEP: {
        BUTTON: 'Speichern',
        PROFILE: {
          SUBTITLE: 'Behalten Sie die tägliche Aktivität Ihres Tieres im Blick, um es fit zu halten. ',
          TITLE: '{{petName}}s Aktivität'
        },
        TITLE: 'Setzen Sie sich ein tägliches Ziel für die Aktivität.'
      }
    },
    PERIOD: {
      DAY: 'Tag',
      MONTH: 'Monat',
      TITLE: 'Zeitraum auswählen',
      WEEK: 'Woche',
      YEAR: 'Jahr'
    },
    PLUS: 'länger als',
    RETURN_HOME: 'Zurück zur Startseite',
    STEP: 'Schritte',
    STEP_SAVED: '{{step}} Schritte',
    TEXT: 'Anhand dieser Grafik können Sie die Aktivität Ihres Tieres verfolgen. Die Messung dieser Aktivität erfolgt über ein Intervall, das bei 0 beginnt und keine Höchstgrenze hat. Jeder Aktivitätspunkt steht für eine Beschleunigung, das heißt: für eine Bewegung, die Ihr Tier ausführt.',
    TITLE_DAY: 'Heute, {{DATE}}',
    TITLE_MONTH: 'Monat vom {{DAY1}} bis {{DAY2}} ',
    TITLE_WEEK: 'Woche vom {{DAY1}} bis {{DAY2}}',
    TOTAL: 'Gesamt',
    WEEKDAYS: {
      FRIDAY: 'Freitag',
      FRIDAY_COMPARATIVE: 'am Freitag',
      MONDAY: 'Montag',
      MONDAY_COMPARATIVE: 'am Montag',
      SATURDAY: 'Samstag',
      SATURDAY_COMPARATIVE: 'am Samstag',
      SUNDAY: 'Sonntag',
      SUNDAY_COMPARATIVE: 'am Sonntag',
      THURSDAY: 'Donnerstag',
      THURSDAY_COMPARATIVE: 'am Donnerstag',
      TUESDAY: 'Dienstag',
      TUESDAY_COMPARATIVE: 'am Dienstag',
      WEDNESDAY: 'Mittwoch',
      WEDNESDAY_COMPARATIVE: 'am Mittwoch'
    },
    WEEKLY_STEP: 'Wöchentliche Schritte',
    YESTERDAY: 'gestern'
  },
  address: {
    CITY_PLACEHOLDER: 'Stadt',
    COUNTRY_PLACEHOLDER: 'Land',
    LANGUAGE_PLACEHOLDER: 'Sprache',
    POSTAL_CODE_PLACEHOLDER: 'Postleitzahl',
    STREET_PLACEHOLDER: 'Nr. und Straße',
    SUBMIT_CTA: 'Weiter',
    TITLE: 'Wie lautet Ihre Adresse?'
  },
  alertCustomer: {
    BODY0: 'unser SIM-Kartenanbieter wartet seine Systeme derzeit.',
    BODY1: '<1>Während dieser Wartung wird die Aktivierungszeit der SIM-Karte auf 24 Stunden verlängert</1>.',
    BODY2: 'Wir entschuldigen uns für die daraus entstehenden Unannehmlichkeiten und für diese Situation, auf die wir leider keinen Einfluss haben.\n\nFür weitere Informationen können Sie unseren Support unter <1>family@weenect.com</1> oder telefonisch unter +49.32.212.29.33.36  kontaktieren.',
    FOOTER: 'Das Weenect Team'
  },
  animalInfo: {
    ERROR: 'Fehler',
    LANDING_PAGE: {
      BUTTON: 'Starten',
      TEXT: 'Stellen Sie uns Ihren Vierbeiner vor. Sie können diese Informationen später in den Einstellungen ändern. ',
      TITLE: 'Geben Sie die Informationen Ihres Haustieres ein!',
      WARNING: 'Diese Informationen sind notwendig für das genaueste Aktivitäts-Tracking und um Ihre Weenect-Erfahrung zu personalisieren.'
    },
    NEXT_BUTTON: 'Weiter',
    PROFIL_VALIDATION: {
      ACTIVITY: 'Aktivität und Verhalten',
      BUTTON: 'Profil bestätigen',
      ERROR: 'Error',
      INDENTIFICATION_INFOS: 'Identifikationsinfos',
      MEDICAL_HISTORY: 'Medizinische Geschichte',
      PERSONAL_INFOS: 'Persönliche Infos',
      PHYSICAL: 'Physische Merkmale',
      SEX: 'Geschlecht',
      SPECIES: 'Tierart',
      TITLE: 'Profilvalidierung',
      UNIQUE_IDENTIFICATION: 'Eindeutige Identifikation'
    },
    QUESTION: 'Frage',
    QUESTION_EIGHT: {
      NO: 'Nein',
      NOT_STERILIZED: 'Nicht kastriert',
      QUESTION: 'Ist Ihr Haustier sterilisiert?',
      STERILIZATION_STATUS: 'Kastrationsstatus',
      STERILIZED: 'Kastriert',
      YES: 'Ja'
    },
    QUESTION_ELEVEN: {
      EVERYTIME: 'Oft',
      EXIT_FREQUENCY: 'Häufigkeit der Ausgänge',
      MOSTLY: 'Ab und zu',
      OFTEN: 'Regelmäßig',
      QUESTION: 'Wie oft geht Ihr Vierbeiner nach draußen?',
      RARELY: 'Nur ausnahmsweise'
    },
    QUESTION_FIVE: {
      QUESTION: 'Wie viel wiegt Ihr Haustier?',
      WEIGHT: 'Gewicht'
    },
    QUESTION_FOUR: {
      FEMALE: 'Weiblich',
      MALE: 'Männlich',
      QUESTION: 'Was ist das Geschlecht Ihres Tieres?'
    },
    QUESTION_NINE: {
      LAST_VISIT: 'Letzter Besuch',
      QUESTION: 'Wann war Ihr Tier das letzte Mal beim Tierarzt?'
    },
    QUESTION_ONE: {
      CAT: 'Eine Katze',
      DOG: 'Ein Hund',
      QUESTION: 'Welches Profil hat Ihr Tier?'
    },
    QUESTION_SEVEN: {
      CHIPED: 'Gechipt',
      IDENTIFICATION: 'Identifikation',
      NOT_IDENTIFIED: 'Mein Tier ist nicht identifiziert',
      QUESTION: 'Wie ist Ihr Haustier gekennzeichnet?',
      TATTOED: 'Tätowiert'
    },
    QUESTION_SIX: {
      QUESTION: 'Was ist die Rasse Ihres Tieres?',
      RACE: 'Rasse'
    },
    QUESTION_TEN: {
      LAST_VACCIN: 'Letzte Impfung',
      QUESTION: 'Wann war die letzte Impfung?'
    },
    QUESTION_THREE: {
      BIRTHDATE: 'Geburtsdatum',
      QUESTION: 'Wann ist Ihre Fellnase geboren?'
    },
    QUESTION_TWO: {
      NAME: 'Name',
      QUESTION: 'Wie heißt es?'
    },
    santevet: {
      description: 'Schützen Sie {{animal_name}} mit der Nummer 1 unter den Krankenversicherungen für Hunde und Katzen.',
      optin: 'Ich bin damit einverstanden, von Santévet kontaktiert zu werden, um meine ersten 3 Monate gratis zu erhalten.',
      title: '3 Monate gratis !'
    }
  },
  animalinfo: {
    AUTO_ADVANCE_HINT: 'Klicken Sie auf eine Antwort: Sie gelangen direkt zur nächsten Frage.',
    BACK: 'Zurück',
    BIRTH_AGE_MONTHS: 'also {{count}} Monate',
    BIRTH_AGE_YEAR: 'also {{count}} Jahr',
    BIRTH_AGE_YEARS: 'also {{count}} Jahre',
    BIRTH_APPROX_1_3: '1 bis 3 Jahre',
    BIRTH_APPROX_4_7: '4 bis 7 Jahre',
    BIRTH_APPROX_8_PLUS: '8 Jahre oder älter',
    BIRTH_APPROX_LESS_1: 'Weniger als 1 Jahr',
    BIRTH_APPROX_SUBTITLE: 'Geben Sie das ungefähre Alter an:',
    BIRTH_APPROX_TITLE: 'Sie kennen das genaue Datum nicht?',
    BIRTH_DAY: 'Tag',
    BIRTH_DAY_PLACEHOLDER: 'TT',
    BIRTH_ERROR_FUTURE: 'Das Geburtsdatum darf nicht in der Zukunft liegen.',
    BIRTH_ERROR_INVALID: 'Dieses Datum existiert nicht.',
    BIRTH_MONTH: 'Monat',
    BIRTH_MONTH_PLACEHOLDER: 'MM',
    BIRTH_TITLE_FEMALE: 'Wann wurde {{name}} geboren?',
    BIRTH_TITLE_MALE: 'Wann wurde {{name}} geboren?',
    BIRTH_YEAR: 'Jahr',
    BIRTH_YEAR_PLACEHOLDER: 'JJJJ',
    BREED_MIXED: 'Mischling',
    BREED_NO_PRECISE: 'Keine genaue Rasse?',
    BREED_NO_RESULT: 'Keine Rasse gefunden. Versuchen Sie einen anderen Namen oder wählen Sie „Mischling“.',
    BREED_SEARCH_PLACEHOLDER: 'Rasse suchen',
    BREED_TITLE: 'Welche Rasse hat er/sie?',
    BREED_UNKNOWN: 'Ich weiß nicht',
    CLOSE: 'Schließen',
    CONTINUE: 'Weiter',
    ERROR_GENERIC: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    GENDER_FEMALE: 'Ein Weibchen',
    GENDER_MALE: 'Ein Männchen',
    GENDER_TITLE: '{{name}} ist…',
    HEADER_TITLE: 'Profil von {{name}}',
    IDENTIFICATION_CHIP_DESC: 'Mikrochip unter der Haut',
    IDENTIFICATION_CHIP_FEMALE: 'Gechipt',
    IDENTIFICATION_CHIP_MALE: 'Gechipt',
    IDENTIFICATION_CHIP_NUMBER_HELP_FEMALE: 'Hilfreich zur schnelleren Identifikation, falls sie verloren geht. 15 Ziffern, im Gesundheitsheft oder auf der Identifikationskarte.',
    IDENTIFICATION_CHIP_NUMBER_HELP_MALE: 'Hilfreich zur schnelleren Identifikation, falls er verloren geht. 15 Ziffern, im Gesundheitsheft oder auf der Identifikationskarte.',
    IDENTIFICATION_CHIP_NUMBER_LABEL: 'Chipnummer (optional)',
    IDENTIFICATION_NONE: 'Keines von beiden',
    IDENTIFICATION_NONE_DESC: 'Oder ich weiß es nicht',
    IDENTIFICATION_TATTOO_DESC: 'Tätowierung am Ohr oder Oberschenkel',
    IDENTIFICATION_TATTOO_FEMALE: 'Tätowiert',
    IDENTIFICATION_TATTOO_MALE: 'Tätowiert',
    IDENTIFICATION_TATTOO_NUMBER_HELP_FEMALE: 'Hilfreich zur schnelleren Identifikation, falls sie verloren geht. So wie auf ihrer Identifikationskarte vermerkt.',
    IDENTIFICATION_TATTOO_NUMBER_HELP_MALE: 'Hilfreich zur schnelleren Identifikation, falls er verloren geht. So wie auf seiner Identifikationskarte vermerkt.',
    IDENTIFICATION_TATTOO_NUMBER_LABEL: 'Tätowierungsnummer (optional)',
    IDENTIFICATION_TATTOO_NUMBER_PLACEHOLDER: 'Buchstaben und Zahlen',
    IDENTIFICATION_TITLE_FEMALE: 'Ist {{name}} gechippt?',
    IDENTIFICATION_TITLE_MALE: 'Ist {{name}} gechipt?',
    INTRO_CTA: 'Los geht\'s',
    INTRO_INFO: 'Diese Informationen machen das Aktivitätstracking von {{name}} genauer und personalisieren Ihre Weenect-Erfahrung.',
    INTRO_SUBTITLE: '6 schnelle Fragen. Alles kann später im Profil geändert werden.',
    INTRO_TITLE: 'Lernen wir {{name}} kennen',
    NEUTERING_TITLE_FEMALE: 'Ist {{name}} sterilisiert?',
    NEUTERING_TITLE_MALE: 'Ist {{name}} sterilisiert?',
    NO: 'Nein',
    PROGRESS: 'Frage {{current}} von {{total}}',
    RECAP_BIRTH_APPROX: 'Ungefähres Alter: {{range}}',
    RECAP_BREED_UNKNOWN: 'Unbekannt',
    RECAP_CTA: 'Profil bestätigen',
    RECAP_EDIT: 'Bearbeiten',
    RECAP_FEMALE: 'Weiblich',
    RECAP_HEADER: 'Überprüfung',
    RECAP_IDENTIFICATION_NONE: 'Keine',
    RECAP_LABEL_BIRTH: 'Geburtsdatum',
    RECAP_LABEL_BREED: 'Rasse',
    RECAP_LABEL_GENDER: 'Geschlecht',
    RECAP_LABEL_IDENTIFICATION: 'Identifikation',
    RECAP_LABEL_NEUTERING_FEMALE: 'Sterilisiert',
    RECAP_LABEL_NEUTERING_MALE: 'Sterilisiert',
    RECAP_LABEL_VET: 'Letzter Tierarztbesuch',
    RECAP_MALE: 'Männlich',
    RECAP_SUBTITLE: 'Bitte überprüfen Sie die Angaben, bevor Sie bestätigen.',
    RECAP_TITLE: 'Ist alles für {{name}} korrekt?',
    RECAP_VET_UNKNOWN: 'Nicht angegeben',
    VET_ERROR_BEFORE_BIRTH: 'Dieses Datum liegt vor seiner Geburt.',
    VET_ERROR_FUTURE: 'Dieses Datum kann nicht in der Zukunft liegen.',
    VET_MONTH: 'Monat',
    VET_TITLE_FEMALE: 'Wann war sie zuletzt beim Tierarzt?',
    VET_TITLE_MALE: 'Wann war er zuletzt beim Tierarzt?',
    VET_UNKNOWN: 'Ich erinnere mich nicht mehr',
    VET_YEAR: 'Jahr',
    YES: 'Ja'
  },
  breed: {
    CAT: {
      ABYSSINIAN: 'Abessinier',
      AMERICAN_BOBTAIL: 'American Bobtail',
      AMERICAN_CURL: 'American Curl',
      AMERICAN_SHORTHAIR: 'American Shorthair',
      AMERICAN_WIREHAIR: 'American Wirehair',
      BALINESE: 'Balinesenkatze',
      BENGAL: 'Bengalkatze',
      BIRMAN: 'Birma-Katze',
      BOMBAY: 'Bombay-Katze',
      BURMESE: 'Burma-Katze',
      BURMILLA: 'Burmilla',
      CALIFORNIA_SPANGLED_CAT: 'California Spangled',
      CHANTILLYTIFFANY: 'Tiffanie',
      CHARTREUX: 'Kartäuser-Katze',
      CORNISH_REX: 'Cornish Rex',
      CYMRIC: 'Cymric',
      DEVON_REX: 'Devon Rex',
      EGYPTIAN_MAU: 'Ägyptische Mau',
      EUROPEAN: 'Europäer',
      EXOTIC_SHORTHAIR: 'Exotische Kurzhaarkatze',
      HAVANA: 'Havana-Katze',
      JAPANESE_BOBTAIL: 'Japanese Bobtail',
      JAVANESE: 'Javanese-Katze',
      KORAT: 'Korat-Katze',
      MAINE_COON: 'Maine Coon-Katze',
      MALAYAN: 'Asian Katze (Malayan)',
      MANX: 'Manx',
      MUNCHKIN: 'Munchkin',
      NEBELUNG: 'Nebelung',
      NORWEGIAN: 'Norwegisch',
      NORWEGIAN_FOREST_CAT: 'Norwegische Waldkatze',
      OCICAT: 'Ocicat',
      ORIENTAL_LONGHAIR: 'Mandarin-Katze',
      ORIENTAL_SHORTHAIR: 'Orientalisch Kurzhaar',
      PERSIAN: 'Perserkatze',
      RAGDOLL: 'Ragdoll-Katze',
      RUSSIAN_BLUE: 'Russisch Blau',
      SAFARI_CAT: 'Safari-Katze',
      SCOTTISH_FOLD: 'Schottische Faltohrkatze',
      SELKIRK: 'Selkirk Rex',
      SIAMESE: 'Siamkatze',
      SIBERIAN: 'Sibirische Katze',
      SINGAPURA: 'Singapura',
      SNOWSHOE: 'Snowshoe',
      SOMALI: 'Somalikatze',
      SPHYNX: 'Sphynx-Katze',
      THAI: 'Thaikatze',
      TONKINESE: 'Tonkinese',
      TURKISH_ANGORA: 'Türkisch Angora',
      TURKISH_VAN: 'Türkisch Van'
    },
    DOG: {
      AFFENPINSCHER: 'Affenpinscher',
      AFGHAN_HOUND: 'Afghanischer Windhund',
      AIREDALE_TERRIER: 'Airedale Terrier',
      AKITA: 'Akita',
      AKITA_INU_GREAT_JAPANESE_DOG: 'Großer Japanischer Hund',
      ALASKAN_MALAMUTE: 'Alaskischer Malamute',
      ALPINE_DACHSBRACKE: 'Alpenländische Dachsbracke',
      AMERICAN_BULLDOG: 'Amerikanische Bulldogge',
      AMERICAN_COCKER_SPANIEL: 'Amerikanischer Cocker Spaniel',
      AMERICAN_FOXHOUND: 'Amerikanischer Foxhound (Foxhound)',
      AMERICAN_STAFFORDSHIRE_TERRIER: 'American Staffordshire Terrier',
      AMERICAN_WATER_SPANIEL: 'American Water Spaniel (Amerikanischer Wasserhund)',
      ANATOLIAN_SHEPHERD_DOG: 'Anatolischer Schäferhund',
      APPENZELLER_SENNENHUND: 'Appenzeller Sennenhund',
      ARDENNES_CATTLE_DOG: 'Ardennen-Bouvier',
      ARGENTINE_DOGO: 'Argentinische Dogge',
      ARIEGEOIS: 'Ariégeois',
      ARIEGE_POINTER: 'Braque de l\'Ariège ',
      ARTOIS_HOUND: 'Artois-Hund',
      ATLAS_SHEPHERD_DOG_AIDI: 'Atlashund (Aïdi - Berger de l\'Atlas)',
      AUSTRALIAN_CATTLE_DOG: 'Australische Bulldogge',
      AUSTRALIAN_KELPIE: 'Australian Kelpie',
      AUSTRALIAN_SHEPHERD: 'Australian Shepherd',
      AUSTRALIAN_TERRIER: 'Australischer Terrier',
      AUSTRIAN_BLACK_AND_TAN_HOUND: 'Brandlbracke',
      AUSTRIAN_SHORTHAIRED_PINSCHER: 'Österreichischer Kurzhaar Pinscher',
      AZAWAKH: 'Azawakh',
      BALKAN_HOUND: 'Balkanischer Laufhund',
      BARBET: 'Barbet',
      BASENJI: 'Basenji',
      BASSET_ARTESIEN_NORMAND: 'Basset Artésien Normand',
      BASSET_BLEU_DE_GASCOGNE: 'Basset bleu de Gascogne',
      BASSET_FAUVE_DE_BRETAGNE: 'Basset Fauve de Bretagne',
      BASSET_HOUND: 'Basset Hound',
      BAVARIAN_MOUNTAIN_SCENTHOUND: 'Bayerischer Gebirgsschweißhund',
      BEAGLE: 'Beagle',
      BEARDED_COLLIE: 'Bearded Collie',
      BEAUCERON: 'Beauceron ',
      BEDLINGTON_TERRIER: 'Bedlington Terrier',
      BELGIAN_GRIFFON: 'Belgischer Griffon',
      BELGIAN_SHEPHERD_DOG_GROENENDAEL: 'Belgischer Schäferhund Groenendael',
      BELGIAN_SHEPHERD_DOG_LAEKENOIS: 'Belgischer Schäferhund Laekenois',
      BELGIAN_SHEPHERD_DOG_MALINOIS: 'Belgischer Schäferhund Malinois',
      BELGIAN_SHEPHERD_DOG_TERVUREN: 'Belgischer Schäferhund Tervueren',
      BERGAMASCO_SHEPHERD: 'Bergamasker Hirtenhund',
      BERNER_NIEDERLAUFHUND: 'Schweizerischer Niederlaufhund',
      BERNESE_HOUND: 'Schweizer Laufhund',
      BERNESE_MOUNTAIN_DOG: 'Berner Sennenhund',
      BICHON_FRISE: 'Bichon Frisé (Kraushaar)',
      BILLY_DOG: 'Billy',
      BLACK_AND_TAN_COONHOUND: 'Black and Tan Coonhound',
      BLOODHOUND_SAINTHUBERT_DOG: 'Bloodhound',
      BLUE_PICARDY_SPANIEL: 'Epagneul bleu de Picardie',
      BOHEMIAN_WIREHAIRED_POINTING_GRIFFON: 'Tschechischer Griffon d\'arrêt',
      BOLOGNESE_DOG: 'Bologneser Bichon',
      BORDEAUX_MASTIFF_FRENCH_MASTIFF: 'Bordeauxdogge',
      BORDER_COLLIE: 'Border Collie',
      BORDER_TERRIER: 'Border Terrier',
      BORZOI: 'Barzoi (Russischer Windhund)',
      BOSNIAN_COARSEHAIRED_HOUND: 'Bosnischer Laufhund',
      BOSTON_TERRIER: 'Boston Terrier',
      BOURBONNAIS_POINTER: 'Bracke aus dem Bourbonnais',
      BOUVIER_DES_FLANDRES: 'Flandrischer Sennenhund',
      BOXER_DOG: 'Boxer',
      BRAQUE_D_AUVERGNE: 'Auvergne-Bracke',
      BRAZILIAN_TERRIER: 'Brasilianischer Terrier',
      BRIARD: 'Briard ',
      BRIQUET_GRIFFON_VENDEEN: 'Briquet Griffon Vendéen',
      BRITTANY_SPANIEL: 'Epagneul Breton',
      BROHOLMER: 'Broholmer',
      BRUNO_JURA_HOUND: 'Kleiner Laufhund aus dem Jura',
      BRUNO_JURA_HOUND_BRUNO_TYPE: 'Bruno du Jura Typ Bruno',
      BRUNO_JURA_HOUND_ST_HUBERT_TYPE: 'Bruno du Jura Typ Saint Hubert',
      BRUSSELS_GRIFFON: 'Brüsseler Griffon',
      BULLMASTIFF: 'Bullmastiff',
      BULL_TERRIER_ENGLISH_BULL_TERRIER: 'Bull Terrier (English Bull Terrier)',
      BURGOS_POINTER: 'Bracke von Burgos (Perdiguero de Burgos)',
      CAIRN_TERRIER: 'Cairn Terrier',
      CANAAN_DOG: 'Hund von Kanaan',
      CANARY_ISLAND_PODENCO: 'Podenco Canario',
      CANE_CORSO: 'Cane Corso',
      CAO_DE_CASTRO_LABOREIRO: 'Cao de Castro Laboreiro',
      CAO_FILA_DE_SAO_MIGUEL: 'Cao Fila de Sao Miguel',
      CATAHOULA_LEOPARD_DOG: 'Hund Leopard Catahoula (Louisiana Catahoula Leopard Dog)',
      CATALAN_SHEEPDOG: 'Katalanischer Schäferhund',
      CAUCASIAN_SHEPHERD_DOG: 'Kaukasischer Schäferhund',
      CAVALIER_KING_CHARLES_SPANIEL: 'Cavalier King Charles',
      CA_DE_BOU_PERRO_DE_PRESA: 'Perro de Presa Mallorquin',
      CENTRAL_ASIAN_SHEPHERD_DOG: 'Zentralasiatischer Owtscharka',
      CESKY_TERRIER: 'Tschechischer Terrier',
      CHESAPEAKE_BAY_RETRIEVER: 'Chesapeake Bay Retriever',
      CHIHUAHUA: 'Chihuahua',
      CHINESE_CRESTED_DOG: 'Chinesischer Schopfhund',
      CHOW_CHOW: 'Chow Chow',
      CIRNECO_DELL_ETNA: 'Cirneco dell’ Etna ',
      CLUMBER_SPANIEL: 'Clumber',
      CONTINENTAL_TOY_SPANIEL: 'Kontinentaler Zwergspaniel',
      CORSICAN_DOG: 'Korsischer Hund',
      COTON_DE_TULEAR: 'Coton de Tulear',
      CROATIAN_SHEEPDOG: 'Kroatischer Schäferhund',
      CURLYCOATED_RETRIEVER: 'Retriever Curly Coated ',
      CZECHOSLOVAKIAN_WOLFDOG: 'Tschechischer Wolfshund',
      DACHSHUND_LONGHAIRED: 'Langhaar Dackel',
      DACHSHUND_LONGHAIRED_RABBIT: 'Dackel für die Kaninchenjagd (Langhaar)',
      DACHSHUND_SMOOTHHAIRED: 'Kurzhaar Dackel',
      DACHSHUND_SMOOTHHAIRED_RABBIT: 'Dackel für die Kaninchenjagd (Kurzhaar)',
      DACHSHUND_WIREHAIRED: 'Rauhhaariger Dackel',
      DACHSHUND_WIREHAIRED_RABBIT: 'Dackel für die Kaninchenjagd (Rauhaar)',
      DALMATIAN: 'Dalmatiner',
      DANDIE_DINMONT_TERRIER: 'Dandie Dinmont Terrier',
      DOBERMAN_PINSCHER: 'Dobermann',
      DOGO_CANARIO: 'Dogo Canario',
      DOGUE_DE_BORDEAUX: 'Okzitanischer Löwe (Leonberger)',
      DRENTSE_PARTRIDGE_DOG: 'Drentscher Hühnerhund',
      DREVER: 'Drever',
      DUNKER: 'Dunker',
      DUPUY_POINTER: 'Dupuy-Bracke',
      DUTCH_SHEPHERD_LONGHAIRED_VARIETY: 'Holländischer Schäferhund Langhaar',
      DUTCH_SHEPHERD_ROUGHHAIRED_VARIETY: 'Holländischer Schäferhund Rauhaar',
      DUTCH_SHEPHERD_SHORTHAIRED_VARIETY: 'Kurzhaariger Holländischer Schäferhund',
      DUTCH_SMOUSHOND: 'Kleiner Holländischer Jagdhund',
      EAST_SIBERIAN_LAIKA: 'Laika aus Ostsibirien',
      ENGLISH_BULLDOG: 'Englische Bulldogge',
      ENGLISH_COCKER_SPANIEL: 'Englischer Cocker Spaniel',
      ENGLISH_POINTER: 'Englischer Pointer',
      ENGLISH_SETTER: 'Englischer Setter',
      ENGLISH_SPRINGER_SPANIEL: 'Englischer Springer Spaniel',
      ENGLISH_TOY_TERRIER: 'Toy Terrier Schwarz und Feuer',
      ENTLEBUCHER_MOUNTAIN_DOG: 'Entlebucher Sennenhund',
      EURASIER: 'Eurasier',
      FAWN_BRITTANY_BASSET: 'Griffon Fauve de Bretagne',
      FIELD_SPANIEL: 'Field Spaniel',
      FILA_BRASILEIRO: 'Fila Brasileiro',
      FINNISH_HOUND: 'Finnischer Laufhund',
      FINNISH_LAPPHUND: 'Finnischer Lapphund',
      FINNISH_SPITZ: 'Finnischer Spitz',
      FLATCOATED_RETRIEVER: 'Retriever Flat Coated ',
      FOXHOUND_ENGLISH_FOXHOUND: 'Foxhound (Englischer Foxhound)',
      FRENCH_BULLDOG: 'Französische Bulldogge',
      FRENCH_SPANIEL: 'Französischer Spaniel',
      FRENCH_WHITE_AND_BLACK_HOUND: 'Französischer Laufhund weiß und schwarz',
      FRENCH_WHITE_AND_ORANGE_HOUND: 'Französisch Laufhund weiß und orange',
      FRISIAN_WATER_DOG: 'Friesischer Wasserhund',
      GASCONY_POINTER: 'Französische Bracke Typ Gascogne',
      GERMAN_LONGHAIRED_POINTER: 'Deutsch Langhaar',
      GERMAN_PINSCHER: 'Pinscher Mittelgroß',
      GERMAN_SHEPHERD: 'Deutscher Schäferhund',
      GERMAN_SHORTHAIRED_POINTER: 'Deutsche Kurzhaar Bracke',
      GERMAN_SPITZ: 'Deutscher Spitz (Groß)',
      GERMAN_WIREHAIRED_POINTER: 'Deutsche Rauhaarbracke',
      GIANT_SCHNAUZER: 'Riesenschnauzer',
      GLEN_OF_IMAAL_TERRIER: 'Irischer Terrier Glen of Imaal',
      GOLDEN_RETRIEVER: 'Golden Retriever',
      GORDON_SETTER: 'Gordon Setter',
      GOTH_SHEPHERD_DOG: 'Gotenhund (Västgötaspets)',
      GRAND_ANGLOFRANCAIS_BLANC_ET_NOIR: 'Grand Anglo-Français Weiß und Schwarz',
      GRAND_ANGLOFRANCAIS_BLANC_ET_ORANGE: 'Grand Anglo-Français Weiß und Orange',
      GRAND_ANGLOFRANCAIS_TRICOLORE: 'Grand Anglo-Français Dreifarbig',
      GRAND_BASSET_GRIFFON_VENDEEN: 'Grand Basset Griffon Vendéen',
      GRAND_BLEU_DE_GASCOGNE: 'Großer Blauer Gascogne-Laufhund',
      GRAND_GASCONSAINTONGEOIS_HOUND: 'Großer Saintongeois Gascon',
      GRAND_GRIFFON_VENDEEN: 'Großer Griffon Vendéen',
      GRAND_SPANISH_HOUND: 'Spanischer Laufhund (groß)',
      GREATER_SWISS_MOUNTAIN_DOG: 'Großer Schweizer Sennenhund',
      GREAT_DANE: 'Deutsche Dogge',
      GREAT_PYRENEES: 'Pyrenäenberghund ',
      GREENLAND_DOG: 'Grönland-Eskimo',
      GREYHOUND: 'Greyhound',
      HALDEN_HOUND: 'Haldenstøver Halden-Laufhund',
      HAMILTONSTOVARE: 'Hamilton Stovare',
      HANOVERIAN_SCENTHOUND: 'Hannoverscher Schweisshund',
      HANOVER_HOUND: 'Deutsche Kurzhaar-Bracke',
      HARRIER: 'Beagle Harrier',
      HAVANESE_DOG: 'Havaneser-Bichon',
      HELLENIC_HOUND: 'Griechischer Laufhund',
      HOKKAIDO: 'Hokkaido',
      HOVAWART: 'Hovawart',
      HUNGARIAN_GREYHOUND: 'Ungarischer Windhund',
      HUNGARIAN_KUVASZ: 'Kuvasz (Ungarischer Schäferhund)',
      HYGEN_HOUND: 'Hygenhund',
      IBIZAN_HOUND_SHORT_HAIRED: 'Podenco Ibicenco de pelo corto (Ibizenkischer Kurzhaarteckel)',
      IBIZAN_HOUND_WIRE_HAIRED: 'Podenco Ibicenco de pelo duro',
      ICELANDIC_SHEEPDOG: 'Isländischer Schäferhund',
      IRISH_RED_AND_WHITE_SETTER: 'Roter Irischer Setter',
      IRISH_SETTER: 'Irischer Setter Rot und Weiß',
      IRISH_TERRIER: 'Irischer Terrier',
      IRISH_WATER_SPANIEL: 'Irischer Wasserhund',
      IRISH_WOLFHOUND: 'Irischer Windhund',
      ISTRIAN_COARSEHAIRED_HOUND: 'Istrischer Laufhund Rauhaar',
      ISTRIAN_SHORTHAIRED_HOUND: 'Istrischer Kurzhaar-Laufhund',
      ITALIAN_GREYHOUND: 'Kleiner Italienischer Windhund',
      ITALIAN_POINTING_DOG: 'Italienische Bracke',
      ITALIAN_SHORTHAIRED_HOUND: 'Italienischer Laufhund, kurzhaarig',
      ITALIAN_SPITZ: 'Italienischer Spitz',
      ITALIAN_WIREHAIRED_HOUND: 'Italienischer Laufhund, Rauhaar',
      JACK_RUSSELL_TERRIER: 'Jack Russell Terrier',
      JAGDTERRIER: 'Jagd Terrier',
      JAPANESE_SPANIEL_CHIN: 'Japanischer Spaniel',
      JAPANESE_SPITZ: 'Japanischer Spitz',
      JAPANESE_TERRIER: 'Japanischer Terrier',
      KAI_KEN: 'Kai',
      KARELIAN_BEAR_DOG: 'Karelischer Bärenhund',
      KARST_SHEPHERD: 'Karst-Schäferhund ',
      KERRY_BLUE_TERRIER: 'Kerry Blue Terrier',
      KISHU_KEN: 'Kishu',
      KOMONDOR: 'Komondor',
      KOREAN_JINDO_DOG: 'Korea Jindo Dog',
      KROMFOHRLANDER: 'Kromfohrländer',
      KYILEO: 'Kyi Leo',
      LABRADOR: 'Labrador',
      LAKELAND_TERRIER: 'Lakeland Terrier',
      LANDSEER: 'Landseer',
      LAPPONIAN_HERDER: 'Finnischer Lapplandschäferhund',
      LARGE_MUNSTERLANDER: 'Großer Münsterländer',
      LEONBERGER: 'Leonberger (Leos)',
      LHASA_APSO: 'Lhasa Apso',
      LOWCHEN_LITTLE_LION_DOG: 'Löwchen',
      LUCERNE_HOUND: 'Luzerner Laufhund',
      LUZERNER_LAUFHUND: 'Kleiner Laufender Luzerner Hund',
      MAJORCA_SHEPHERD_DOG: 'Spanischer Schäferhund von Mallorca (Ca de Bestiar)',
      MALTESE_DOG: 'Malteser Bichon',
      MANCHESTER_TERRIER: 'Manchester Terrier',
      MAREMMA_SHEEPDOG: 'Maremmen-Abruzzen-Schäferhund',
      MASTIFF_FRENCH_MASTIFF: 'LOF-registrierter Mastiff',
      MEDIUM_POODLE: 'Pudel (Mittel)',
      MEXICAN_HAIRLESS_DOG: 'Mexikanischer Nackthund ',
      MINIATURE_BULL_TERRIER: 'Bullterrier Miniatur',
      MINIATURE_DACHSHUND_LONGHAIRED: 'Zwergdackel mit langem Fell',
      MINIATURE_DACHSHUND_SMOOTHHAIRED: 'Zwergdackel mit kurzem Haar',
      MINIATURE_DACHSHUND_WIREHAIRED: 'Zwergdackel Rauhhaar',
      MINIATURE_PINSCHER: 'Zwergpinscher',
      MINIATURE_POODLE: 'Pudel (Zwerg)',
      MINIATURE_SCHNAUZER: 'Zwergschnauzer',
      MIXED_BREED_CROSSBREED: 'Mischling',
      MUDI: 'Mudi (Ungarischer Schäferhund)',
      NEAPOLITAN_MASTIFF: 'Neapolitanischer Mastiff (Mastino Napoletano)',
      NEWFOUNDLAND: 'Neufundländer',
      NORFOLK_TERRIER: 'Norfolk Terrier',
      NORRBOTTENSPETS: 'Norrbottenspitz',
      NORWEGIAN_BUHUND: 'Norwegischer Buhund',
      NORWEGIAN_ELKHOUND_BLACK: 'Norwegischer Elchhund schwarz',
      NORWEGIAN_ELKHOUND_GRAY: 'Norwegischer Elchhund grau',
      NORWEGIAN_LUNDEHUND: 'Norwegischer Lundehund',
      NORWICH_TERRIER: 'Norwich Terrier',
      NOVA_SCOTIA_DUCK_TOLLING_RETRIEVER: 'Neu-Schottland-Retriever',
      OLD_DANISH_POINTER: 'Altdänischer Vorstehhund',
      OLD_ENGLISH_SHEEPDOG: 'Bobtail',
      OTTERHOUND: 'Otter-Hund',
      PARSON_RUSSELL_TERRIER: 'Parson Jack Russell Terrier',
      PEKINGESE: 'Pekinese',
      PERUVIAN_HAIRLESS_DOG_LARGE: 'Peruanischer Nackthund (groß)',
      PERUVIAN_HAIRLESS_DOG_MEDIUM: 'Peruanischer Nackthund (mittelgroß)',
      PERUVIAN_HAIRLESS_DOG_SMALL: 'Peruanischer Nackthund (klein)',
      PETIT_BASSET_GRIFFON_VENDEEN: 'Anglo Français de Petite Vénerie',
      PETIT_BRABANCON: 'Kleiner Brabanter',
      PETIT_GASCON_SAINTONGEOIS: 'Kleiner Gascogner Saintongeois',
      PHARAOH_HOUND: 'Pharaonenhund',
      PICARDY_SHEPHERD: 'Picardischer Schäferhund (Berger de Picardie)',
      PICARDY_SPANIEL: 'Picard Spaniel',
      POITEVIN: 'Poitevin',
      POLISH_HOUND: 'Polnischer Bracke',
      POLISH_LOWLAND_SHEEPDOG: 'Polnischer Niederungshütehund',
      PONTAUDEMER_SPANIEL: 'Epagneul Pont Audemer',
      PORCELAINE: 'Porcelaine',
      PORTUGUESE_PODENGO_GRANDE: 'Portugiesischer Podengo Grande',
      PORTUGUESE_PODENGO_MEDIO: 'Portugiesischer Podengo Medio',
      PORTUGUESE_PODENGO_PEQUENO: 'Portugiesischer Podengo Pequeno',
      PORTUGUESE_POINTER: 'Portugiesische Bracke',
      PORTUGUESE_SHEEPDOG: 'Portugiesischer Schäferhund',
      PORTUGUESE_SHEEPDOG_LONGHAIRED: 'Serra da Estrela Berghund Langhaar ',
      PORTUGUESE_SHEEPDOG_SHORTHAIRED: 'Serra da Estrela Berghund Kurzhaar ',
      PORTUGUESE_WATER_DOG: 'Portugiesischer Wasserhund',
      POSAVAC_HOUND: 'Posavatzer Laufhund',
      PRAGUE_RATTER: 'Prager Rattler',
      PUDEL_POINTER: 'Pudel Pointer',
      PUG: 'Mops',
      PULI_HUNGARIAN_SHEPHERD: 'Puli (Ungarischer Schäferhund)',
      PUMI_HUNGARIAN_SHEPHERD: 'Pumi (Ungarischer Schäferhund)',
      PYRENEAN_MOUNTAIN_DOG: 'Mastiff der Pyrenäen',
      PYRENEAN_POINTER: 'Französische Bracke Typ Pyrenäen',
      PYRENEAN_SHEEPDOG_LONGFACED_VARIETY: 'Langhaariger Pyrenäen-Schäferhund',
      PYRENEAN_SHEEPDOG_SMOOTHFACED_VARIETY: 'Pyrenäenschäferhund mit kurzem Gesicht',
      RAFEIRO_DE_ALENTEJO: 'Rafeiro de Alentejo',
      REDBONE_COONHOUND: 'Redbone Coonhound',
      REDTICK_COONHOUND: 'Redtick Coonhound',
      RHODESIAN_RIDGEBACK: 'Rhodesian Ridgeback',
      ROMAGNA_WATER_DOG: 'Romagnolischer Wasserhund',
      ROTTWEILER: 'Rottweiler',
      ROUGH_COLLIE: 'Langhaar-Collie',
      RUSSIAN_BLACK_TERRIER: 'Russischer Schwarzer Terrier',
      RUSSOEUROPEAN_LAIKA: 'Europäischer Laika Russo',
      SAARLOOSWOLFHOND: 'Saarlooswolfhund',
      SAINTUSUGE_SPANIEL: 'Epagneul de Saint-Usuge',
      SAINT_BERNARD: 'Bernhardiner',
      SALUKI: 'Saluki',
      SAMOYED: 'Samojede',
      SANSHU: 'Sanshu',
      SCHAPENDOES: 'Schapendoes',
      SCHILLERSTOVARE: 'Schiller Stovare',
      SCHIPPERKE: 'Schipperke',
      SCHWEIZER_LAUFHUND: 'Schwyz Laufhund',
      SCOTTISH_DEERHOUND: 'Schottischer Windhund',
      SCOTTISH_TERRIER: 'Schottischer Terrier',
      SEALYHAM_TERRIER: 'Sealyham Terrier',
      SHAR_PEI: 'Shar Peï (Shar Peï)',
      SHETLAND_SHEEPDOG: 'Shetland-Schäferhund',
      SHIBA_INU: 'Shiba (Shiba Inu)',
      SHIH_TZU: 'Shih Tzu',
      SHIKOKU: 'Sikoku',
      SHORTHAIRED_HUNGARIAN_POINTER: 'Ungarische Kurzhaar-Bracke',
      SIBERIAN_HUSKY: 'Sibirischer Husky',
      SILKY_TERRIER: 'Silky Terrier (Sydney Silky)',
      SKYE_TERRIER: 'Skye Terrier (Skye Terrier)',
      SLOUGHI: 'Sloughi',
      SLOVAKIAN_WIREHAIRED_POINTER: 'Slowakische Rauhhaarbracke',
      SLOVAK_CUVAC: 'Slowakischer Schäferhund',
      SLOVAK_HOUND: 'Slowakischer Laufhund',
      SMALAND_HOUND: 'Smalandsstovare',
      SMALL_MUNSTERLANDER: 'Kleiner Münsterländer',
      SMALL_SPANISH_HOUND: 'Spanischer Laufhund (klein)',
      SMOOTH_COLLIE: 'Kurzhaar-Collie',
      SMOOTH_FOX_TERRIER_ENGLISH_FOX_TERRIER: 'Foxterrier Glatthaar (Englischer Fox)',
      SOFTCOATED_WHEATEN_TERRIER: 'Irischer Terrier mit weichem Fell',
      SOUTH_RUSSIAN_OVCHARKA: 'Südrussische Owtscharka',
      SPANISH_GREYHOUND_GALGO_ESPANOL: 'Spanischer Galgo',
      SPANISH_MASTIFF: 'Spanischer Mastiff',
      SPANISH_WATER_DOG: 'Spanischer Wasserhund',
      SPINONE_ITALIANO: 'Spinone Italiano',
      STABYHOUN: 'Stabyhoun (Friesischer Vorstehhund)',
      STAFFORDSHIRE_BULL_TERRIER: 'StaffordShire Bull Terrier LOF',
      STANDARD_POODLE: 'Pudel (Groß)',
      STANDARD_SCHNAUZER: 'Mittelgroßer Schnauzer',
      STICHELHAAR: 'Stichelhaar',
      STYRIAN_COARSEHAIRED_HOUND: 'Steirische Rauhhaarbracke',
      ST_GERMAIN_POINTING_DOG: 'Bracke Saint Germain',
      SUSSEX_SPANIEL: 'Sussex Spaniel',
      SWEDISH_ELKHOUND: 'Schwedischer Elchhund',
      SWEDISH_LAPPHUND: 'Schwedischer Lapphund',
      TATRA_MOUNTAIN_SHEEPDOG: 'Polnischer Podhale-Tatra-Schäferhund',
      TECKEL_DE_CHASSE_AU_LAPIN_POIL_DUR: 'Transsylvanischer Laufhund',
      TIBETAN_MASTIFF: 'Tibetanische Dogge',
      TIBETAN_SPANIEL: 'Tibet-Spaniel',
      TIBETAN_TERRIER: 'Tibetanischer Terrier',
      TOSA: 'Tosa eingetragen LOF',
      TOY_POODLE: 'Pudel (Toy) (Miniaturpudel)',
      TRICOLOUR_HOUND: 'Französisch Laufhund Dreifarbig',
      TYROLEAN_HOUND: 'Tiroler Bracke',
      WACHTELHUND: 'Oysel-Hund (Wachtelhund)',
      WEIMARANER_LONGHAIRED: 'Weimaraner Langhaar Bracke',
      WEIMARANER_SHORTHAIRED: 'Weimaraner Kurzhaar',
      WELSH_CORGI_CARDIGAN: 'Welsh Corgi Cardigan',
      WELSH_CORGI_PEMBROKE: 'Welsh Corgi Pembroke',
      WELSH_SPRINGER_SPANIEL: 'Walisischer Springer Spaniel',
      WELSH_TERRIER: 'Welsh Terrier',
      WESTPHALIAN_DACHSBRACKE: 'Westfälische Dachsbracke',
      WEST_HIGHLAND_WHITE_TERRIER: 'West Highland White Terrier',
      WEST_SIBERIAN_LAIKA: 'Laika aus Westsibirien',
      WHIPPET: 'Whippet',
      WHITE_SWISS_SHEPHERD_DOG: 'Weißer Schweizer Schäferhund',
      WIREHAIRED_HUNGARIAN_POINTER: 'Ungarische Rauhhaarbracke',
      WIREHAIRED_POINTING_GRIFFON: 'Griffon mit Wollhaar',
      WIRE_FOX_TERRIER: 'Foxterrier Rauhaar',
      YORKSHIRE_TERRIER: 'Yorkshire Terrier',
      YUGOSLAVIAN_MOUNTAIN_HOUND: 'Montenegrinischer Gebirgslaufhund',
      YUGOSLAVIAN_SHEPHERD_DOG: 'Jugoslawischer Schäferhund',
      YUGOSLAVIAN_TRICOLOUR_HOUND: 'Montenegrinischer Gebirgslaufhund Dreifarbig'
    }
  },
  cancellation: {
    no_use_transfer_cta_primary: 'Ich verschenke meinen Tracker',
    no_use_transfer_cta_secondary: 'Trotzdem kündigen',
    no_use_transfer_info: 'Ihr Angehöriger muss zuerst ein Weenect-Konto erstellen. Es ist kostenlos, ohne Abonnement oder Tracker-Kauf. Informieren Sie ihn, um die Übertragung zu beschleunigen.',
    no_use_transfer_subtitle: 'Ein anderes Tier könnte davon profitieren! Verschenken Sie es an eine nahestehende Person: Diese erhält einen kostenlosen Abonnementmonat. Ihr Abonnement wird gekündigt und es erfolgt keine weitere Abbuchung.',
    no_use_transfer_title: 'Und wenn Sie Ihren Tracker einem Angehörigen schenken würden?'
  },
  changePaymentMean: {
    ADD_BANK_ACCOUNT: 'Hinzufügen eines zu belastenden Kontos',
    ADD_BANK_CARD: 'Zur Zahlung per Kreditkarte wechseln',
    BANK_ACCOUNT_ERROR: 'Bei der Änderung Ihrer Bankverbindung ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Kundenservice.',
    BANK_ACCOUNT_EXPLANATION: 'Wir weisen Sie darauf hin, dass Ihre Bankdaten von unseren Servern nicht gespeichert werden.',
    BANK_ACCOUNT_SUCCESS: 'Bankverbindung aktualisiert',
    BANK_CARD_ERRORED: 'Problem bei der Änderung der Zahlungsmethode. Bitte wenden Sie sich an unseren <1>Kundenservice</1>.',
    BANK_CARD_UPDATED: 'Kreditkarte aktualisiert',
    CAPTATION: 'Für die Aktualisierung Ihrer Bankinformationen autorisieren wir auf Ihrer Karte eine Gebühr von {{ amount }}.',
    CAPTATION_EXPLANATION1: 'Diese Summe wird nicht abgebucht. Die Transaktion wird automatisch storniert.',
    CAPTATION_EXPLANATION2: 'Dieses Verfahren ermöglicht uns, die Zahlungsstandards des Internets einzuhalten und die Sicherheit Ihrer Bankverbindung zu gewährleisten. Diese Informationen werden nicht über unsere Server geleitet.',
    CAPTATION_EXPLANATION3: 'ACHTUNG: Das Abbuchungsformular trägt den Namen "Hareau" und nicht "Weenect". Das ist normal, es ist der Name unseres Unternehmens. "Weenect" ist unser Markenname.',
    CAPTATION_EXPLANATION4: 'Ändern Sie Ihre Bankverbindung unter Beibehaltung desselben Abonnements.',
    CARD_AUTHORIZED: 'Die zulässigen Zahlungsmittel sind:',
    CHANGE_PAYMENT_MEAN: 'Meine Kreditkarteninformationen aktualisieren',
    CURRENT_CHOICE_CB: 'Sie haben sich für die Zahlung per Kreditkarte entschieden.',
    CURRENT_CHOICE_IBAN: 'Sie haben sich für die Zahlung per IBAN entschieden',
    CURRENT_MEAN: 'Aktuelle Zahlungsmethode',
    CURRENT_MEAN_PHRASE: 'Sie haben sich für die Zahlung per Kreditkarte entschieden',
    CURRENT_MEAN_PHRASE_GOCARDLESS: 'Sie haben sich für die Zahlung per Bankeinzug entschieden ',
    DEFAULT_MEAN: 'Art der Standardzahlung:',
    GO_TO_SEPA: 'Zum Lastschriftverfahren wechseln',
    MODIFY: 'Mein Zahlungsmittel ändern',
    TITLE: 'Zahlungsmittel',
    UPDATE_BANK_ACCOUNT: 'Meine IBAN aktualisieren',
    UPDATE_BANK_CARD: 'Meine Kreditkarteninformationen aktualisieren',
    USED_PAYMENT_EXPLANATION: 'Diese Zahlungsmethode wird verwendet, um Ihre Abonnements und Optionen zu bezahlen.'
  },
  change_password: {
    warning_logout_all: 'Zu Ihrer Sicherheit werden Sie durch das Ändern Ihres Passworts von allen Geräten abgemeldet. Sie müssen sich mit dem neuen Passwort erneut anmelden.'
  },
  commonActions: {
    ACTIVATE: 'Aktivieren',
    BACK: 'Zurück',
    CANCEL: 'Abbrechen',
    CAN_BE_CANCELED: 'Eine Kündigung ist jederzeit möglich.',
    CHANGE: 'Speichern',
    CONFIGURE: 'Konfigurieren',
    DEACTIVATE: '',
    GO_MAP: 'Zur Karte',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.'
    },
    NEXT: 'Weiter',
    NO: 'Nein',
    OK: 'O. K.',
    REGISTER: 'Aktivieren',
    SAVE: 'Speichern',
    SELECT_ALL: 'Alles auswählen',
    SEND: 'Abschicken',
    SUBSCRIBE: 'Abonnieren',
    THEN: 'dann',
    UNSELECT_ALL: 'Alles abwählen',
    UPDATE: 'Speichern',
    VALIDATE: 'Bestätigen',
    YES: 'Ja'
  },
  creditCardAlert: {
    AUTO_RENEWAL_ADVICE: 'Wenn Sie Ihren Tracker weiterhin nutzen möchten, fügen Sie bitte jetzt ein neues Zahlungsmittel hinzu.',
    AUTO_RENEWAL_NOTICE: '<1>Achtung!</1> Ihr Abonnement läuft bald ab und Ihre Kreditkarte ist abgelaufen.'
  },
  emailPreferences: {
    EMAIL_LISTS: {
      COMPANY_NEWS: 'Neuigkeiten aus dem Unternehmen',
      NEW_FEATURES: 'Neue Funktionen',
      OFFERS: 'Werbeangebote',
      SERVICE_STATUS: 'Störungen des Dienstes und Updates',
      SURVEYS_AND_TESTS: 'Umfragen und Betatests',
      TUTORIALS: 'Tutorials'
    },
    EMAIL_LISTS_HEADER: 'Liste der E-Mails',
    EMAIL_LISTS_INFO: {
      SERVICE_STATUS: 'Für den reibungslosen Betrieb des Dienstes erforderlich.'
    },
    ENGAGEMENT_NOTIFICATIONS_CHECKBOX: 'Ich möchte Benachrichtigungen mit Nutzungstipps für die mobile App erhalten',
    ENGAGEMENT_NOTIFICATIONS_DESCRIPTION: 'Diese Benachrichtigungen helfen Ihnen, sich mit der mobilen App vertraut zu machen, indem sie Ihnen Nutzungstipps geben.',
    ENGAGEMENT_NOTIFICATIONS_TITLE: 'Nutzungstipps',
    LANGUAGE_PREFERENCES_DESCRIPTION: 'Wählen Sie die Sprache, in der Sie die E-Mails erhalten möchten :',
    OPEN_TRACKING_CHECKBOX_TEXT: 'Ich akzeptiere die Nachverfolgung der Öffnung meiner E-Mails',
    OPEN_TRACKING_DESCRIPTION: 'Die Verfolgung der Öffnungen hilft uns, die Wirksamkeit unserer Kommunikation zu messen und die Häufigkeit sowie den Inhalt unserer E-Mails anzupassen.',
    OPEN_TRACKING_HEADLINE: 'Verfolgung der E-Mail-Öffnungen',
    PREFERENCES_DECRIPTION: 'Wählen Sie die Art der E-Mails, die Sie erhalten möchten. Wir werden Ihnen nur diejenigen schicken, die Ihren Einstellungen entsprechen. '
  },
  error: {
    TITLE: 'Es ist ein Problem aufgetreten '
  },
  errors: {
    DEFAULT: 'Feld ungültig',
    FIELD_REQUIRED: 'Dies ist ein Pflichtfeld.',
    GENERAL: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
    IMEI: 'Geben Sie eine gültige IMEI-Nummer an.',
    MAIL_FORMAT: 'Die Form der E-Mail-Adresse ist ungültig.',
    MAX_LENGTH: 'Das Feld darf höchstens 15 Zeichen enthalten.',
    PASSWORD_FORMAT: 'Ihr Passwort muss mindestens eine Ziffer, einen Großbuchstaben, und einen Kleinbuchstaben enthalten.',
    PHONE_FORMAT: 'Die Telefonnummer muss die Landesvorwahl enthalten.',
    PROMO_CODE: 'Rabattcode nicht gültig'
  },
  forgotPassword: {
    FORGOT_PASSWORD_BUTTON: 'Link anfordern um ihr Passwort zurückzusetzen',
    FORGOT_PASSWORD_CANCEL: 'Zurück zur Anmeldung',
    FORGOT_PASSWORD_ERRORS: {
      UNKNOWN: 'Ein Fehler ist aufgetreten. Bitte nutzen Sie für die Kontaktaufnahme das vorgesehene Formular.'
    },
    FORGOT_PASSWORD_EXPIRED: 'Ihr Passwort-Zurücksetzen-Link ist abgelaufen.',
    FORGOT_PASSWORD_RETRY: 'Link anfordern, um Ihr Passwort zurückzusetzen.',
    FORGOT_PASSWORD_SUCCESS: 'Wenn ein Konto mit der E-Mail-Adresse {{mail}} verknüpft ist, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.'
  },
  forgotpassword: {
    BACK_TO_LOGIN_CTA: 'Zurück zur Anmeldung',
    CONFIRMATION_SUBTITLE: 'Wenn ein Konto mit der E-Mail-Adresse {{email}} verknüpft ist, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.',
    CONFIRMATION_TITLE: 'E-Mail gesendet!',
    EMAIL_CONFIRM_PLACEHOLDER: 'E-Mail-Adresse bestätigen',
    EMAIL_PLACEHOLDER: 'E-Mail-Adresse',
    SUBMIT_CTA: 'Link zum Zurücksetzen des Passworts erhalten',
    SUBTITLE: 'Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten.',
    TITLE: 'Passwort vergessen?'
  },
  forms: {
    CITY: {
      LABEL: 'Stadt',
      PLACEHOLDER: 'Ihr Stadt'
    },
    CONFIRM_PASSWORD: {
      LABEL: 'Passwortbestätigung',
      PLACEHOLDER: 'Bestätigen'
    },
    COUNTRY: {
      LABEL: 'Land'
    },
    EMAIL: {
      LABEL: 'E-Mail-Adresse',
      PLACEHOLDER: 'ihre@email.com'
    },
    FIRST_NAME: {
      LABEL: 'Vorname',
      PLACEHOLDER: 'Ihr Vorname'
    },
    LANGUAGE: {
      LABEL: 'Sprache'
    },
    LAST_NAME: {
      LABEL: 'Nachname',
      PLACEHOLDER: 'Ihr Nachname'
    },
    NEW_PASSWORD: {
      LABEL: 'Neues Passwort',
      PLACEHOLDER: 'Ihr neues Passwort'
    },
    OLD_PASSWORD: {
      LABEL: 'Altes Passwort',
      PLACEHOLDER: 'Ihr altes Passwort'
    },
    PASSWORD: {
      LABEL: 'Passwort',
      PLACEHOLDER: 'Passwort',
      VALIDATION: 'Ihr Passwort muss aus mindestens 8 Zeichen bestehen',
      WARNING: 'Warnung: "qwertzuiopü" und "123456789" sind KEINE sicheren Passwörter.\nTesten Sie die Sicherheit Ihres Passworts hier: <1>https://howsecureismypassword.net</1>'
    },
    PHONE: {
      LABEL: 'Telefon',
      PLACEHOLDER: '+4900000000'
    },
    POSTAL_CODE: {
      LABEL: 'Postleitzahl',
      PLACEHOLDER: 'Ihre Postleitzahl',
      STREET_NUMBER: 'Straße und Hausnummer'
    },
    STREET: {
      LABEL: 'Anschrift',
      PLACEHOLDER: 'Straße und Hausnummer'
    }
  },
  general: {
    ALERT_ZONES: 'Alarmzonen',
    BACK_BUTTON: 'Zurück',
    DISABLED: 'Deaktiviert',
    EMAIL: 'E-Mail',
    ENABLED: 'Aktiviert',
    ENERGY_SAVING_ZONES: 'Energiesparzonen',
    ERROR_FORMAT: 'Entschuldigung, dieses Format ist ungültig',
    ERROR_MISMATCH: 'Beide Felder müssen identisch sein',
    ERROR_NETWORK: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    ERROR_PAGE_TITLE: 'Ups, es ist ein Problem aufgetreten.',
    FROM: 'Von',
    HISTORY: 'Verlauf',
    LOGOUT_MENU_DISCONNECT: 'Abmelden',
    MOBILE_ONLY_SETTINGS_NOTE: 'Sie können diese Einstellungen jederzeit in der Weenect Mobile App ändern.',
    NONE: 'Keine',
    NOTIFICATIONS: 'Benachrichtigungen',
    OPEN: 'Öffnen',
    PUSH: 'Push',
    SAFETY_ZONES: 'Sicherheitszonen',
    SMS: 'SMS',
    TO: 'Bis',
    TRACKER_PROFILE: 'Tracker-Profil',
    password_length: 'Ihr Passwort muss mindestens 8 Zeichen lang sein.',
    save_button: 'Speichern'
  },
  general_password_length: 'Ihr Passwort muss mindestens 8 Zeichen lang sein.',
  geofences: {
    CREATE: {
      HEADLINE: 'Zone erstellen'
    },
    EDIT: {
      DELETE_GEOFENCE: 'Zone löschen',
      ENTRANCE_NOTIFICATION: 'In-Zone-Benachrichtigung',
      EXIT_NOTIFICATION: 'Aus-Zone-Benachrichtigung',
      GEOCODE_LABEL: 'Eine Adresse verwenden',
      GEOCODE_PLACEHOLDER: 'Geben Sie hier die Adresse ein.',
      LOCATION: 'Standort des Zentrums der Zone',
      NAME_INPUT: {
        LABEL: 'Name der Zone',
        PLACRHOLDER: 'Den Namen der Zone eingeben'
      },
      OUTDOORS: 'Außenzone (Park, Wald)',
      OUTDOORS_TOOLTIP: 'Da GPS-Tracker im Freien genauer sind, sind die Regeln für die Benachrichtigung einer Ein- oder Ausgangsmeldung in einer Innen- oder Außenzonen unterschiedlich.',
      POINT_ON_THE_MAP_TEXT: 'oder direkt auf der Karte auswählen',
      RADIUS: 'Größe der Zone (Radius)',
      TRACKER_LAST_POSITION_BUTTON: 'Den Standort des Trackers verwenden',
      UNKNOWN_ADDRESS: 'Unbekannte Adresse '
    }
  },
  header: {
    ALL_TRACKERS: 'Alle Tracker',
    AVAILABLE_PLURAL: 'verfügbar',
    NAV: {
      ACCOUNT: 'Konto',
      INSURANCE: 'Versicherung',
      LOGOUT: 'Abmelden',
      SUPPORT: 'Support',
      TRACKERS: 'Karte'
    },
    SEARCHBAR_RESULT: 'Tracker gefunden',
    SEARCHBAR_TITLE: 'Einen Tracker suchen:',
    TRACKERS: 'Tracker',
    WHITE_LABEL: {
      IN_PARTERNSHIP_WITH: 'In Partnerschaft mit'
    }
  },
  history: {
    DATE_SELECTOR_LABEL: 'Einen anzuzeigenden Tag wählen',
    MARKER_END: 'Ende',
    MARKER_START: 'Start',
    PLAYBACK_BUTTON: 'Pause',
    PLAYBACK_POSITION: 'Position {{index}} / {{total}}',
    PLAYBACK_TIME_LABEL: 'Dauer',
    PLAY_CTA: 'Starten',
    POINT_BATTERY_LABEL: 'Akku:',
    POINT_POSITION_LABEL: 'Position:',
    POINT_TIME_LABEL: 'Uhrzeit:',
    RANGE_SLIDER_LABEL: 'Schieben Sie den Regler, um den anzuzeigenden Zeitraum auszuwählen:',
    STATS_DISTANCE_LABEL: 'Gesamte Entfernung',
    STATS_DURATION_LABEL: 'Dauer',
    STATS_SPEED_AVG_LABEL: 'Ø Geschwindigkeit',
    STATS_SPEED_MAX_LABEL: 'Max. Geschwindigkeit',
    STATS_TITLE: 'Aktivitätsdetails',
    STOP_CTA: 'STOP',
    TIMEFRAME_12H: '12 Std.',
    TIMEFRAME_1H: '1 Std.',
    TIMEFRAME_24H: '24 Std.',
    TIMEFRAME_3H: '3 Std.',
    TIMEFRAME_6H: '6 Std.',
    TIMEFRAME_LABEL: 'Die letzten anzeigen'
  },
  home: {
    ACCOUNT_CARD_TITLE: 'Mein Konto',
    ADD_TRACKER_CTA: 'Tracker hinzufügen',
    AI_ASSISTANT_ITEM: 'KI-Assistent',
    ALERT_ZONES_ITEM: 'Alarmzonen',
    CONTACT_FORM_ITEM: 'Kontaktformular',
    ENERGY_ZONES_ITEM: 'Energiesparzonen',
    GREETING: 'Hallo {{firstname}}',
    HELP_CARD_TITLE: 'Brauchen Sie Hilfe?',
    HELP_CENTER_ITEM: 'Hilfezentrum',
    HISTORY_CARD_TITLE: 'Verlauf',
    MANAGE_SUBSCRIPTION_CTA: 'Mein Abonnement verwalten',
    MAP_CARD_TITLE: 'Karte',
    NOTIFICATIONS_ITEM: 'Benachrichtigungen',
    PASSWORD_ITEM: 'Passwort',
    PAYMENT_METHOD_CTA: 'Zahlungsmethode und Rechnungen',
    PREFERENCES_ITEM: 'Einstellungen',
    SUBSCRIPTION_BANNER_LABEL: 'ABONNEMENT FÜR TRACKER {{name}}',
    SUBSCRIPTION_LABEL: 'Abonnement {{duration}}',
    SUBSCRIPTION_LABEL_NO_SUBSCRIPTION: 'Kein Abonnement',
    SUB_GREETING: 'Willkommen in Ihrem Weenect-Bereich',
    TRACKER_PROFILE_ITEM: 'Tracker-Profil',
    TRACKER_SELECTOR_LABEL: 'Meine Tracker',
    TRACKER_SETTINGS_CARD_TITLE: 'Tracker-Einstellungen',
    USER_PROFILE_ITEM: 'Benutzerprofil'
  },
  imeiInfo: {
    HINT: 'Sie finden die IMEI-Nummer auf der Rückseite Ihres Trackers.',
    IMAGE_ALT: 'Foto vom Tracker',
    TITLE: 'IMEI-Nummer'
  },
  login: {
    EMAIL_PLACEHOLDER: 'E-Mail-Adresse',
    ERROR_INVALID_CREDENTIALS: 'Ungültiges Passwort.',
    FORGOT_PASSWORD: 'Passwort vergessen?',
    FORGOT_PASSWORD_LINK: 'Passwort vergessen?',
    LOGIN_ERRORS: {
      UNKNOWN: 'Die Anmeldung ist fehlgeschlagen.'
    },
    PASSWORD_PLACEHOLDER: 'Passwort',
    REGISTER_CTA: 'Kostenloses Konto erstellen',
    REGISTER_PROMPT_TITLE: 'Noch kein Konto?',
    SIGN_IN_BUTTON: 'Anmelden',
    SIGN_IN_HEADLINE: 'Anmelden',
    SIGN_UP_BUTTON: 'Konto erstellen',
    SIGN_UP_HEADLINE: 'Sie haben noch kein Konto?',
    SUBMIT_CTA: 'Anmelden',
    TERMS_LINK: 'Nutzungsbedingungen',
    TERMS_LINK_URL: 'https://www.weenect.com/common/pdf/en/cgv-weenect.pdf',
    TITLE: 'Anmelden'
  },
  manageSubscription: {
    CANCEL: {
      DESCRIBE_YOUR_PROBLEMS: 'Könnten Sie uns bitte den Grund für Ihre Kündigung verraten?',
      GIVE_US_DETAILS: 'Grund für Ihre Kündigung',
      REASONS: {
        AFTER_SALES_SERVICE: 'Schlechte Erfahrungen mit dem Kundenservice',
        BATTERY: 'Akkulaufzeit nicht ausreichend',
        LOST_BROKEN: 'Ich habe es verloren / kaputtgemacht',
        MOBILE_APPLICATION: 'Die App funktioniert nicht.',
        NOT_SATISFIED: 'Ich bin mit Weenect nicht zufrieden',
        NO_USE: 'Ich brauche es nicht mehr',
        TOO_EXPENSIVE: 'Das Abonnement ist zu teuer',
        TRACKER_FORMAT: 'Format des Trackers verbesserungsbedürftig (Größe und Gewicht)',
        WILL_REACTIVATE_LATER: 'Ich werde das Abo später reaktivieren.'
      },
      SAD_TO_SEE_YOU_LEAVE: 'Wir sind traurig, dass Sie uns verlassen!',
      WHY_DO_YOU_RESIGN: 'Warum möchten Sie Ihr Abo kündigen?'
    },
    CANCEL_EXPIRE: 'Die automatische Verlängerung ist aufgehoben. Das Abo läuft am {{date}} ab.',
    CANCEL_QUESTION: 'Möchten Sie das Abo nicht fortsetzen?',
    CANCEL_RENEWAL: 'Automatische Verlängerung aufheben',
    CANCEL_RENEWAL_BIS: 'Abo kündigen',
    CANT_RESIGN_UNDER_EXTENDED_NOTICE: 'Möchten Sie Ihr Abo kündigen oder nur die automatische Verlängerung Ihres Abos deaktivieren?\nRufen Sie uns an unter +33 (0) 1 87 66 98 71 (montags bis freitags von 9:30 bis 16:00 Uhr).',
    CANT_RESIGN_UNDER_NOTICE: 'Es ist nicht möglich, Ihr Abonnement innerhalb der letzten 30 Tage zu kündigen. Bitte wenden Sie sich an das Kundendienstteam.',
    CANT_RESIGN_UNTIL: 'Sie können Ihr Abo bis zum {{date}} nicht kündigen.',
    CANT_RESIGN_WHILE_COMMITED: 'Sie sind für 3 Monate gebunden, die Kündigung Ihres Abonnements wird erst zum Ende der laufenden Periode wirksam, d.h. am {{date}}',
    CURRENT_PLAN: 'Aktuelles Abo',
    HEADLINE: 'Abo verwalten',
    MESSAGES: {
      UPDATE_SUCCESS: 'Das Abo wurde aktualisiert.'
    },
    RENEW_SUBSCRIPTION: 'Abo verlängern',
    RESIGN_DATE: 'Die Kündigung Ihres Abonnements wird zum Ende des aktuellen Zeitraums wirksam, also zum {{date}}',
    RESUMPTION_DATE: 'Ein Wiederaufnahmedatum wählen',
    RETURN_TO_TRACKERS: 'Zurück zur Karte'
  },
  map: {
    ERROR_BANNER_MESSAGE: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    FLASHLIGHT_DURATION_10_MIN: '10 Min',
    FLASHLIGHT_DURATION_1_MIN: '1 Min',
    FLASHLIGHT_DURATION_2_MIN: '2 Min',
    FLASHLIGHT_DURATION_30_MIN: '30 Min',
    FLASHLIGHT_DURATION_5_MIN: '5 Min',
    FLASHLIGHT_MODE_FLASHING: 'Blinkend',
    FLASHLIGHT_MODE_STEADY: 'Dauerhaft',
    FLASHLIGHT_TITLE: 'Taschenlampe',
    GPS_IN_WIFI_ZONE: 'In einem WLAN-Bereich',
    IMMOBILE_FOR_DAY: 'Seit 1 Tag unbewegt',
    IMMOBILE_FOR_DAYS: 'Seit {{time}} Tagen unbewegt',
    IMMOBILE_FOR_HOUR: 'Seit 1 Stunde unbewegt',
    IMMOBILE_FOR_HOURS: 'Seit {{time}} Stunden unbewegt',
    IMMOBILE_FOR_MINUTE: 'Seit 1 Minute unbewegt',
    IMMOBILE_FOR_MINUTES: 'Seit {{time}} Minuten unbewegt',
    IMMOBILE_SINCE: 'Seit {{date}} unbewegt',
    LAST_COMMUNICATION_AGO: 'Letzte Kommunikation vor {{time}}',
    LAST_COMMUNICATION_ON: 'Letzte Kommunikation am {{date}}',
    MAP_SELECTOR_MAP: 'Karte',
    MAP_SELECTOR_MAP_3D: '3D-Karte',
    MAP_SELECTOR_MAP_HD: 'HD-Karte',
    MAP_SELECTOR_PREMIUM_MAPS_TITLE: 'Premium-Karten',
    MAP_SELECTOR_SATELLITE: 'Satellit',
    MAP_SELECTOR_SATELLITE_3D: '3D-Satellit',
    MAP_SELECTOR_SATELLITE_HD: 'HD-Satellit',
    MAP_SELECTOR_STANDARD_MAPS_TITLE: 'Standardkarten',
    MAP_SELECTOR_TERRAIN: 'Gelände',
    MAP_SELECTOR_TRAILS: 'Wege und Pfade',
    NO_GPS_MARKER_TITLE: 'Kein GPS Signal',
    NO_POSITION: 'Keine bekannte Position',
    ON_DATE: 'am {{date}}',
    POSITION: 'Position',
    POSITION_RECEIVED_DAYS_AGO: 'Position vor {{time}} Tagen empfangen',
    POSITION_RECEIVED_DAY_AGO: 'Position vor 1 Tag empfangen',
    POSITION_RECEIVED_HOURS_AGO: 'Position vor {{time}} Stunden empfangen',
    POSITION_RECEIVED_HOUR_AGO: 'Position vor 1 Stunde empfangen',
    POSITION_RECEIVED_MINUTES_AGO: 'Position vor {{time}} Minuten empfangen',
    POSITION_RECEIVED_MINUTE_AGO: 'Position vor 1 Minute empfangen',
    POSITION_RECEIVED_ON: 'Position am {{date}} empfangen',
    POSITION_RECEIVED_SECONDS_AGO: 'Position vor {{time}} Sekunden empfangen',
    POSITION_RECEIVED_SECOND_AGO: 'Position vor {{time}} Sekunde erhalten',
    REFRESH_FAILED: 'Positionsaktualisierung fehlgeschlagen.',
    REFRESH_MULTI_TRACKER_SENT: 'Positionsaktualisierungsanfragen gesendet.',
    REFRESH_SINGLE_TRACKER_SENT: 'Positionsaktualisierungsanfrage gesendet.',
    REFRESH_SUCCEEDED: 'Position wurde aktualisiert.',
    RING_DURATION_10_SECONDS: '10 s',
    RING_DURATION_1_SECOND: '1 s',
    RING_DURATION_30_SECONDS: '30 s',
    RING_DURATION_3_SECONDS: '3 s',
    RING_DURATION_5_SECONDS: '5 s',
    RING_TITLE: 'Klingelton',
    STATUS_GOOD: 'Gut',
    STATUS_LOW: 'Gering',
    STATUS_MEDIUM: 'Mittel',
    SUPERLIVE_DURATION_10_MIN: '10 Min',
    SUPERLIVE_DURATION_1_MIN: '1 Min',
    SUPERLIVE_DURATION_2_MIN: '2 Min',
    SUPERLIVE_DURATION_30_MIN: '30 Min',
    SUPERLIVE_DURATION_5_MIN: '5 Min',
    SUPERLIVE_INFO: 'Gut zu wissen: Die tatsächliche Position des Trackers wird sich einige Sekunden nach dem Start des Superlive aktualisieren.',
    SUPERLIVE_STOP: 'STOP',
    SUPERLIVE_TIMER_LABEL: 'Zeit',
    SUPERLIVE_TITLE: 'Superlive',
    TIME_AGO_DAY: 'vor 1 Tag',
    TIME_AGO_DAYS: 'vor {{time}} Tagen',
    TIME_AGO_HOUR: 'vor 1 Stunde',
    TIME_AGO_HOURS: 'vor {{time}} Stunden',
    TIME_AGO_MINUTE: 'vor 1 Minute',
    TIME_AGO_MINUTES: 'vor {{time}} Minuten',
    TIME_AGO_SECOND: 'vor {{time}} Sekunde',
    TIME_AGO_SECONDS: 'vor {{time}} Sekunden',
    TRACKER_MODE_ACTIVE_GPS_REPORT: 'GPS-Übertragung: 30 s',
    TRACKER_MODE_ACTIVE_LABEL: 'Active',
    TRACKER_MODE_ACTIVE_PLUS_GPS_REPORT: 'GPS-Übertragung: 10 s',
    TRACKER_MODE_ACTIVE_PLUS_LABEL: 'Active Plus',
    TRACKER_MODE_ECO_GPS_REPORT: 'GPS-Übertragung: 5 Min.',
    TRACKER_MODE_ECO_LABEL: 'Eco',
    TRACKER_MODE_ECO_PLUS_GPS_REPORT: 'GPS-Übertragung: deaktiviert',
    TRACKER_MODE_ECO_PLUS_LABEL: 'Eco Plus',
    TRACKER_MODE_EDIT_ON_MOBILE_NOTICE: 'Die Änderung des Trackermodus erfolgt direkt in der Weenect-App.',
    TRACKER_MODE_SMART_GPS_REPORT: 'GPS-Übertragung: 1 Min.',
    TRACKER_MODE_SMART_LABEL: 'Smart',
    TRACKER_MODE_TITLE: 'Trackermodus',
    TRACKER_SIDEBAR_AVAILABLE_TRACKERS_COUNT: '{{number}} Tracker verfügbar',
    TRACKER_SIDEBAR_BATTERY_LABEL: 'Akku',
    TRACKER_SIDEBAR_GPS_SIGNAL_LABEL: 'GPS-Signal',
    TRACKER_SIDEBAR_LAST_COMMUNICATION_LABEL: 'Letzte Kommunikation',
    TRACKER_SIDEBAR_MULTI_TRACKER_VIEW: 'Mehrfach-Tracker-Ansicht',
    TRACKER_SIDEBAR_NETWORK_LABEL: 'Netz',
    TRACKER_SIDEBAR_NO_KNOWN_POSITION: 'Keine bekannte Position',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_CTA: 'Abonnement abschließen',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_STATE: 'Kein aktives Abonnement',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_TITLE: 'Sie haben kein aktives Abonnement für diesen Tracker',
    TRACKER_SIDEBAR_OTHER_TRACKERS_TITLE: 'Andere Tracker',
    TRACKER_SIDEBAR_POWER_UP_NEXT: 'Weiter',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BODY: 'Der Tracker muss sich während der Inbetriebnahme im Freien oder in Fensternähe befinden.',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BUTTON: 'Ich habe meinen Tracker eingeschaltet',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_TITLE: 'Drücken Sie 3 Sekunden lang die mittlere Taste, um Ihren Tracker einzuschalten.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_BODY: 'Die erste Verbindung kann bis zu 5 Minuten dauern. Sie müssen nichts tun.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_HINT: 'Warten Sie, bis die grüne LED dauerhaft leuchtet und dann erlischt.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_TITLE: 'Ihr Tracker versucht jetzt, sich mit dem Netz zu verbinden.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_BODY: 'Legen Sie den Tracker nach oben zum Himmel gerichtet im Freien ab, um die GPS-Positionssuche zu erleichtern.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_HINT: 'Bitte warten, der Tracker sucht seine Position.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_TITLE: 'Jetzt, da er verbunden ist, sucht Ihr Tracker nach GPS-Signalen.',
    TRACKER_SIDEBAR_TITLE: 'Meine Tracker',
    TRACKER_SIDEBAR_TRACKER_STATE_LABEL: 'Status des Trackers',
    TRACKER_STATE_AIRPLANE_MODE: 'Im Flugzeugmodus',
    TRACKER_STATE_BATTERY_EMPTY: 'Kein Akku mehr',
    TRACKER_STATE_CONNECTED: 'Tracker verbunden',
    TRACKER_STATE_DISCONNECTED: 'Tracker getrennt',
    TRACKER_STATE_GSM_UNREACHABLE: 'Außerhalb des GSM-Netzes',
    TRACKER_STATE_MANUALLY_OFF: 'Manuell ausgeschaltet',
    TRACKER_STATE_POWER_SAVING_AREA: 'Im Energiesparmodus',
    TRACKER_STATE_SUBSCRIPTION_EXPIRED: 'Sie haben kein Abonnement',
    VIBRATION_DURATION_10_SECONDS: '10 s',
    VIBRATION_DURATION_1_SECOND: '1 s',
    VIBRATION_DURATION_30_SECONDS: '30 s',
    VIBRATION_DURATION_3_SECONDS: '3 s',
    VIBRATION_DURATION_5_SECONDS: '5 s',
    VIBRATION_RING_INFO: 'Gut zu wissen: Gewöhnen Sie Ihr Tier mit Klingelton oder Vibration an das Zuruftraining, indem Sie es mit der Mahlzeit verbinden.',
    VIBRATION_TITLE: 'Vibration'
  },
  mapControls: {
    MAP_TYPE: 'Kartentyp',
    REFRESH_POSITION: 'Position aktualisieren',
    SUPER_LIVE: 'Superlive',
    ZOOM_IN: 'Zoom +',
    ZOOM_OUT: 'Zoom -'
  },
  mapLayers: {
    CLASSIC_MAPS: 'Standardkarten',
    DONT_SUBSCRIBE: 'Weiterhin die Standardkarten benutzen',
    FOREST_PATH: 'Wege und Pfade',
    GOOGLE_STREET: 'Google Maps',
    GRAY: 'Schwarz-weiß',
    PLAN: 'Karte',
    PREMIUM_MAPS: 'Premium-Karten',
    PREMIUM_SUBSCRIBE: 'Sich für der Premium-Kartenoption abonnieren',
    PREMIUM_WARNING_MSG: 'Achtung! Sie haben für die Premium-Kartenoption noch kein Abonnement.\n\nDank dieser Option können Sie von besonders umfassenden und regelmäßig aktualisierten Karten profitieren und dabei die Nachfolgung Ihres Trackers optimieren. \u2028Mit den Varianten „HD-Satellitenkarte“, „Reliefkarte“ oder „Waldwege“ können Sie Ihren Tracker sofort mit einem Blick orten.\n\nAbonnement für nur {{mapOptionPrice}}/Monat!',
    RELIEF: 'Reliefkarte',
    SATELLITE: 'Satellit',
    STREET: 'Klassisch',
    UNLOCK_MAPS: 'Schalten Sie zusätzliche Karten frei, indem Sie sie anklicken!'
  },
  misc: {
    LANGUAGE: {
      DE: 'Deutsch',
      EN: 'Englisch',
      ES: 'Spanisch',
      FR: 'Französisch',
      IT: 'Italienisch',
      NL: 'Niederländisch'
    },
    NO_DATE: 'Kein bekannter Standort',
    ROTATE_DEVICE: 'Weenect ist für die Verwendung im Hochformat bestimmt. Bitte drehen Sie Ihr Gerät, um unsere Dienste optimal nutzen zu können. ',
    locale: 'de-DE'
  },
  newpassword: {
    EXPIRED_LINK_LINK: 'Neuen Link für vergessenes Passwort anfordern',
    EXPIRED_LINK_TEXT: 'Dieser Link ist abgelaufen. Bitte fordern Sie eine neue Passwortzurücksetzung an.',
    NEWPASSWORD_CONFIRMATION_PLACEHOLDER: 'Passwortbestätigung',
    NEWPASSWORD_PLACEHOLDER: 'Neues Passwort',
    SCREEN_TITLE: 'Neues Passwort'
  },
  onboarding: {
    ACTIVATING_HINT: 'Durchschnittliche Aktivierungsdauer: 5 Minuten',
    ACTIVATING_INDICATOR: 'Aktivierung läuft',
    GREET: {
      BUTTON: 'Ihr Tracker ist eingeschaltet.',
      COMMON_TEXT: 'Für einen optimalen Start empfehlen wir Ihnen, diesem Tutorial zu folgen. So wird Ihnen die Bedienung Ihres Tracker noch leichter fallen.\n\\In wenigen Schritten wird Ihr Gerät einsatzbereit sein. Bitte befolgen Sie die untenstehenden Anweisungen, um es einzuschalten:',
      MAIN_TITLE: 'Kontaktinformationen',
      RED_TEXT: 'Der Tracker muss sich im Freien befinden, um eine GPS-Position zu empfangen.'
    },
    MAP_INTERACTIONS: {
      COMMON_TEXT: {
        PET: 'Mit diesen Buttons können Sie Ihren Tracker klingeln (Button oben) oder vibrieren (Button unten) lassen. Diese Features ermöglichen es Ihnen, mit Ihrem Haustier das Rückrufkommando zu trainieren.',
        SILVER: 'Mit diesen Buttons  können Sie Ihren Tracker klingeln (Button oben) oder vibrieren (Button unten) lassen. '
      },
      TITLE: 'Buttons zur Interaktion mit dem Tracker'
    },
    MAP_INTERVAL: {
      COMMON_TEXT: 'Mit diesem Button können Sie auswählen, wie oft Sie eine aktuelle GPS-Position von Ihrem Tracker erhalten möchten. Bitte beachten Sie: Je kürzer das festgelegte Zeitintervall, desto geringer ist auch die Akkulaufzeit des Trackers.',
      TITLE: 'Button zur Festlegung des Zeitintervalls für den Positionsverlauf'
    },
    MAP_OPTIONS: {
      COMMON_TEXT: 'Mit diesen Buttons können Sie festlegen, welcher Kartentyp zur Darstellung verwendet werden soll. Zudem können Sie in die Karte hinein- oder herauszoomen.',
      TITLE: 'Button zur Festlegung der Kartenvariante'
    },
    MAP_UPDATE: {
      COMMON_TEXT: 'Mit diesem Button können Sie die GPS-Position Ihres Trackers aktualisieren (um eine neue Position zu erhalten, muss Ihr Tracker mit dem Server verbunden sein und ein gültiges GPS-Signal empfangen).',
      TITLE: 'Button zur Aktualisierung der GPS-Position'
    },
    MODAL: {
      BUTTON_HINT: 'Halten Sie die Taste 3 Sekunden lang gedrückt, bis der Tracker vibriert.',
      HEADLINE: 'Schalten Sie Ihren Tracker im Freien oder auf einer Fensterbank an.',
      IMAGE_ALT: 'Foto vom Tracker',
      MAP_HINT: 'Wenn der Tracker eingeschaltet ist, zeigt er im Durchschnitt nach 5 Minuten die Karte an.'
    },
    REMOTE_ASSISTANCE: {
      ASSISTANCE: {
        COMMON_TEXT: 'Reagiert niemand innerhalb dieses Zeitraums, so wird der Alarm an die Plattform weitergeleitet.'
      },
      EXPLANATION: 'Dort wird der Anruf entgegengenommen und sich um das Anliegen Ihres Angehörigen gekümmert. Je nach Situation kann der Mitarbeiter dort <1>Familienmitglieder kontaktieren oder den Rettungsdienst verständigen</1>.',
      PRICE: 'Die Option kostet 9,99 € pro Monat und kann jederzeit deaktiviert werden.',
      SOS: {
        COMMON_TEXT: 'Ihr Angehöriger drückt die SOS-Taste auf seinem Tracker.'
      },
      TIME: {
        COMMON_TEXT: 'Sie werden benachrichtigt und haben dann 30 Sekunden Zeit, um auf den Alarm zu reagieren.'
      },
      TITLE: 'Lernen Sie unsere neue Option kennen: die Fernunterstützung',
      USE_CASE: 'Ist diese Option aktiviert, kann der Träger des Trackers mit einer speziellen Plattform verbunden werden, über die täglich und rund um die Uhr Fernunterstützung angeboten wird.'
    },
    SIDE_PAGES: {
      COMMON_TEXT: {
        PET: 'Links finden Sie verschiedene Tabs zur Verwaltung und Verwendung Ihres Trackers. Im Tab Historie können Sie den Positionsverlauf und im Tab Aktivitätsverfolgung den Energieaufwand Ihres Haustiers einsehen. Sicherheitszonen können Sie im Tab Zonen definieren. Im Tab Einstellungen finden Sie Informationen zum Profil Ihres Haustiers und im Tab Abonnement können Sie dieses sowie Ihre Abo-Optionen mit wenigen Klicks verwalten.',
        SILVER: 'Links finden Sie verschiedene Tabs zur Verwaltung und Verwendung Ihres Trackers. Im Tab Historie können Sie den Positionsverlauf Ihres geliebten Menschen einsehen und im Tab Zonen können Sie Sicherheitszonen definieren.\n Die Telefonnummern, die im Falle eines abgesetzten SOS-Alarms angerufen werden sollen, sowie die Nachrichten, die beim Drücken der einzelnen seitlichen Knöpfe gesendet werden sollen, können Sie im Tab Einstellungen festlegen. Ihr Abonnement und Ihre Abo-Optionen können Sie im Tab Abonnement mit wenigen Klicks verwalten.'
      },
      TITLE: 'Zusätzliche Tabs'
    },
    SKIP: 'Tutorial überspringen',
    SUPERLIVE: {
      COMMON_TEXT: 'Mit diesem Button können Sie den "Superlive"-Modus aktivieren: So erhalten Sie fünf Minuten lang alle zehn Sekunden eine aktuelle GPS-Position.',
      TITLE: '"Superlive"-Button'
    },
    TUTORIAL_START: {
      BUTTON: 'Tutorial fortsetzen',
      COMMON_TEXT: 'Sehr gut, Ihr Tracker ist nun einsatzbereit. Lassen Sie uns mit einer kurzen Übersicht über Ihren persönlichen MyWeenect-Bereich fortfahren.'
    },
    WAITING_GPS_POSITION: 'GPS-Position wird gesucht.',
    WAITING_GPS_POSITION_HINT: 'Schalten Sie Ihren Tracker im Freien ein.'
  },
  optionCardExpired: {
    PROPOSAL: 'Bitte aktualisieren Sie Ihre Kreditkarteninformationen, um unseren Service weiterhin nutzen zu können.',
    UPDATE_CARD: 'Jetzt aktualisieren',
    WARNING: '<1>Achtung!</1> Leider können Sie diese Abonnenment-Option nicht wählen, da <1>Ihre Kreditkarte abgelaufen ist</1>.'
  },
  optioncancellation: {
    OFFER_ACCEPT_BUTTON: 'Einen kostenlosen Monat nutzen',
    OFFER_CONFIRMATION_BUTTON: 'Zurück zur App',
    OFFER_CONFIRMATION_TEXT: 'Ihre Option bleibt aktiv und die nächste Abbuchung erfolgt am {date}.',
    OFFER_CONFIRMATION_TITLE: 'Option aktualisiert!',
    OFFER_PREMIUM_TEXT: 'Bleiben Sie einen Monat länger und genießen Sie Ihr Premium-Paket kostenlos!',
    OFFER_REFUSE_BUTTON: 'Trotzdem deaktivieren',
    OFFER_SERENITY_TEXT: 'Bleiben Sie einen Monat länger und genießen Sie Ihr Sorglos-Paket kostenlos!',
    OFFER_TITLE: 'Wie wäre es mit 1 Monat kostenlos?',
    PREMIUM_BUTTON: 'Premium-Paket deaktivieren',
    PREMIUM_HEADER: 'Premium-Paket',
    PREMIUM_QUESTION: 'Warum möchten Sie das Premium-Paket deaktivieren?',
    PREMIUM_TITLE: 'Premium-Paket deaktivieren',
    REASON_NOT_MATCHING_NEED: 'Die Garantie entspricht nicht meinem Bedarf',
    REASON_NO_NEED_FEATURES: 'Ich benötige diese Funktionen nicht',
    REASON_NO_USE: 'Ich benutze den Tracker nicht mehr',
    REASON_OTHER: 'Andere',
    REASON_OTHER_PLACEHOLDER: 'Erzählen Sie uns mehr...',
    REASON_SUBSCRIBED_BY_MISTAKE: 'Ich habe es versehentlich abonniert',
    REASON_TOO_EXPENSIVE: 'Die Option ist zu teuer',
    SERENITY_BUTTON: 'Sorglos-Paket deaktivieren',
    SERENITY_HEADER: 'Sorglos-Paket',
    SERENITY_QUESTION: 'Warum möchten Sie das Sorglos-Paket deaktivieren?',
    SERENITY_TITLE: 'Sorglos-Paket deaktivieren'
  },
  payment: {
    ADD_NEW_PAYMENT_REGULARISE: 'Bitte registrieren Sie eine neue Zahlungsmethode oder regeln Sie Ihre Situation.',
    EXPIRACY_CREDIT_CARD_TEXT: 'Bitte fügen Sie eine neue Zahlungsmethode hinzu, um Ihre Situation zu bereinigen.',
    NO_PAYMENT_MEAN_YET: 'Zurzeit keine Zahlungsmöglichkeiten',
    NO_PAYMENT_YET: 'Derzeit sind keine Zahlungen möglich.',
    UPDATE_PAYMENT_REGULARISE: 'Wenn Sie Ihren Tracker weiterhin verwenden möchten, aktualisieren Sie bitte jetzt Ihr Zahlungsmittel oder wählen Sie ein anderes.',
    WARNING_ERROR: 'Es scheint ein Problem mit Ihrem Zahlungsmittel zu geben.',
    WARNING_EXPIRACY_CREDIT_CARD: 'Attention, your credit card has expired.',
    WARNING_NOT_ENOUGH_FOUNDS: 'Bitte beachten Sie, dass auf Ihrem Konto nicht genügend Guthaben vorhanden ist.'
  },
  payments: {
    CARD: {
      ACCEPTED: '(EC-Karte, VISA, Mastercard, American Express)',
      DESCRIPTION: '30 Tage Zufriedenheitsgarantie oder Geld zurück',
      NAME: 'Kreditkarte'
    },
    STATUS: {
      CANCELED: 'Abgebrochen',
      ERROR: 'Fehlgeschlagen',
      NEW: 'In Bearbeitung',
      PAYMENT_ERROR: 'Zahlung fehlgeschlagen',
      PAYMENT_ERROR_EXPLAIN_TEXT: 'Bei Ihrer Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es in Kürze erneut oder wenden Sie sich',
      PAYMENT_RETRY: 'Erneut versuchen',
      PAYMENT_SAV: 'Kundendienst.',
      PAYMENT_SUCCESS: 'Zahlung erfolgreich!',
      PAYMENT_SUCCESS_TEXT: 'Ihre Zahlung ist eingegangen. Sie können nun Ihre Weenect-Erfahrung starten!',
      PAYMENT_SUCCESS_TEXT_APP: 'Ihre Zahlung ist eingegangen.',
      PENDING: 'In Bearbeitung',
      REFUNDED: 'Erstattet',
      SUCCESS: 'Bestätigt'
    },
    TRANSFER: {
      DESCRIPTION: '15 zusätzliche Tage Bedenkzeit, somit eine 30-tägige Geld-zurück-Garantie bei Nichtzufriedenheit.',
      NAME: 'Bankeinzug'
    }
  },
  periods: {
    ALT: {
      MONTH: '1 Monat',
      YEAR: '1 Jahr',
      YEAR_plural: '{{count}} Jahre'
    },
    BASE: {
      MONTH: 'Monate',
      YEAR: 'Jahr'
    }
  },
  popinpremium: {
    BADGE_PREMIUM: 'PREMIUM',
    CARDSBLOCK_3D_DESCRIPTION: 'Eine immersive 3D-Ansicht Ihres Verlaufs, um jede Fahrt nachzuerleben, als wären Sie dabei.',
    CARDSBLOCK_3D_TITLE: '3D-Wiedergabe',
    CARDSBLOCK_ACTIVEPLUS_DESCRIPTION: 'Eine sehr häufige Positionsbestimmung, um keine Bewegung zu verpassen.',
    CARDSBLOCK_ACTIVEPLUS_TITLE: 'Active Plus Modus',
    CARDSBLOCK_ALERTS_DESCRIPTION: 'Erhalten Sie Ihre Benachrichtigungen per SMS.',
    CARDSBLOCK_ALERTS_TITLE: 'SMS-Benachrichtigungen',
    CARDSBLOCK_CONTACTS_DESCRIPTION: 'Teilen Sie die Verfolgung mit bis zu 10 Angehörigen.',
    CARDSBLOCK_CONTACTS_TITLE: '10 vertrauenswürdige Kontakte',
    CARDSBLOCK_HEATMAP_DESCRIPTION: 'Sehen Sie seine Lieblingszonen und häufige Routen.',
    CARDSBLOCK_HEATMAP_TITLE: 'Bewegungs-Heatmap',
    CARDSBLOCK_MAPS_DESCRIPTION: 'Leicht finden, auch im Gelände: Satellitenansicht, Gelände und Wege.',
    CARDSBLOCK_MAPS_TITLE: 'Satelliten- & 3D-Karten',
    CARDSBLOCK_SHARE_DESCRIPTION: 'Laden Sie Ihre Angehörigen sicher ein, ohne Ihr Passwort preiszugeben.',
    CARDSBLOCK_SHARE_TITLE: 'Zugriff auf Ihr Konto teilen',
    CARDSBLOCK_SUPERLIVE_DESCRIPTION: 'Ortung Ihres Tieres jede Sekunde, länger.\nStandardfunktion: bis zu 2 Min.',
    CARDSBLOCK_SUPERLIVE_TITLE: 'Superlive bis zu 30 Min.',
    CARDSBLOCK_TITLE: 'Was Sie freischalten',
    CTA: '1 Monat kostenlos testen',
    DESCRIPTION: 'Genießen Sie alle Premium-Funktionen - 1 Monat lang kostenlos.\nOhne Verpflichtung, mit einem Klick kündbar.',
    REASSURANCEBLOCK_1MONTHFREE: '1 Monat gratis',
    REASSURANCEBLOCK_BADGE: 'OHNE VERPFLICHTUNG',
    REASSURANCEBLOCK_CANCELABLE: 'Mit einem Klick kündbar',
    REASSURANCEBLOCK_FREETODAY: 'Heute {{value}}',
    REASSURANCEBLOCK_PERMONTH: 'danach {{value}}/Monat',
    REASSURANCEBLOCK_REMINDER: 'Erinnerung vor Ablauf',
    SUBTITLE_CTA: 'Dann {{value}} /Monat · ohne Verpflichtung · Angebot nicht gültig, wenn Sie es bereits genutzt haben',
    TITLE: 'Schalten Sie das Premium-GPS-Erlebnis frei'
  },
  popinserenity: {
    ASSISTANCEBLOCK_FOOTER: 'Menschliche Unterstützung in jeder Phase',
    ASSISTANCEBLOCK_GUIDE: 'Suchleitfaden je nach Land',
    ASSISTANCEBLOCK_INTRO: 'Und wenn Ihr Tier verschwindet, handeln wir an Ihrer Seite:',
    ASSISTANCEBLOCK_ONLINEAD: 'Online-Anzeigenschaltung',
    ASSISTANCEBLOCK_OVERLINE: 'PRIORITÄRER SUPPORT',
    ASSISTANCEBLOCK_PHONEFOLLOWUP: 'Telefonische Begleitung durch unsere Berater',
    ASSISTANCEBLOCK_POSTER: 'Personalisierbares Plakat zum Ausdrucken',
    ASSISTANCEBLOCK_PRIORITYSUPPORT: 'Priorisierter Kundendienst bei Notfällen',
    ASSISTANCEBLOCK_TITLE: 'Ein Team zur Wiederfindung',
    BADGE_NOCOMMITMENT: 'Ohne Vertragsbindung',
    BADGE_SERENITY: 'Sorglos-Paket',
    CTA: 'Sorglos-Paket aktivieren',
    DESCRIPTION: 'Umfassender Schutz für Ihren Tracker und ein Team, das Sie aktiv unterstützt, falls Ihr Tier verloren geht.',
    PRICE_PERMONTH: '{{price}} /Monat',
    PRICE_PREFIX: 'Für',
    PROTECTIONBLOCK_BREAKAGE: 'Unfallbedingter Bruch',
    PROTECTIONBLOCK_DESCRIPTION: 'Verlust, Diebstahl oder Bruch: Wir senden Ihnen einen neuen Tracker zu.',
    PROTECTIONBLOCK_FOOTER: 'Bis zu 3 Ersatzgeräte · {{shipping_price}} Versandkosten',
    PROTECTIONBLOCK_LOSS: 'Tracker-Verlust',
    PROTECTIONBLOCK_OVERLINE: 'SCHUTZ',
    PROTECTIONBLOCK_THEFT: 'Tracker-Diebstahl',
    PROTECTIONBLOCK_TITLE: 'Ihr Tracker wird innerhalb von 24 Stunden ersetzt',
    REASSURANCEBLOCK_CANCELABLE: 'Mit einem Klick aktivieren oder kündigen',
    REASSURANCEBLOCK_NOCOMMITMENT: 'Ohne Vertragsbindung',
    TITLE: 'Behalten Sie die Ruhe, egal was passiert.'
  },
  popup: {
    premium_pack_popup_flash_description_1_web: 'Dauerlicht, zusätzlich zu bereits enthaltenem Blinken.',
    premium_pack_popup_flash_description_2_web: 'Und eine Beleuchtung bis zu 30 Minuten ohne Unterbrechung.',
    premium_pack_popup_flash_title_web: 'Eine andere Art von Taschenlampe für noch mehr Sicherheit (*nur auf Tracker XS und XT)',
    premium_pack_popup_map_description_1_web: 'HD-Satellitenansicht, Gelände, Waldwege und Wanderwege',
    premium_pack_popup_map_title_web: 'Zusätzliche Karten, um sich an alle Gelände anzupassen',
    premium_pack_popup_notifications_description_1_web: 'Fügen Sie bis zu 10 Kontakte hinzu',
    premium_pack_popup_notifications_description_2_web: '40 SMS-Guthaben pro Monat.',
    premium_pack_popup_notifications_description_3_web: 'Zusätzlich zu Push-Benachrichtigungen und E-Mails, die bereits enthalten sind.',
    premium_pack_popup_notifications_title_web: 'Alle Warnungen auf Ihrem Telefon, auch ohne Internetverbindung',
    premium_pack_popup_ring_vibrate_description_1_web: 'Statt 10 Sekunden ohne das Premium-Paket.',
    premium_pack_popup_ring_vibrate_title_web: 'Klingelton und Vibration bis zu 30 Sekunden',
    premium_pack_popup_superlive_description_1_web: 'Statt 2 Minuten ohne das Premium-Paket.',
    premium_pack_popup_superlive_title_simplified_web: 'Superlive bis zu 30 Minuten ohne Unterbrechung'
  },
  powersavingarea: {
    ACTIVE_STATE: 'Aktiv',
    AIRPLANE_MODE: 'Flugzeugmodus',
    AIRPLANE_MODE_STATE_DISABLED: 'Deaktiviert',
    AIRPLANE_MODE_STATE_ENABLED: 'Aktiviert',
    INACTIVE_STATE: 'Inaktiv',
    REDIRECT_APPLICATION: 'Das Ändern und Erstellen von Zonen sowie das Aktivieren des Flugmodus erfolgen direkt über die Weenect-Mobile-App.'
  },
  premium_pack_popup_flash_description_1: 'Dauerlicht, zusätzlich zu bereits enthaltenem Blinken.',
  premium_pack_popup_flash_description_2: 'Und eine Beleuchtung bis zu 30 Minuten ohne Unterbrechung.',
  premium_pack_popup_flash_title: 'Eine andere Art von Taschenlampe für noch mehr Sicherheit (*nur auf Tracker XS und XT)',
  premium_pack_popup_map_description_1: 'HD-Satellitenansicht, Gelände, Waldwege und Wanderwege',
  premium_pack_popup_map_title: 'Zusätzliche Karten, um sich an alle Gelände anzupassen',
  premium_pack_popup_notifications_description_1: 'Fügen Sie bis zu 10 Kontakte hinzu',
  premium_pack_popup_notifications_description_2: '40 SMS-Guthaben pro Monat.',
  premium_pack_popup_notifications_description_3: 'Zusätzlich zu Push-Benachrichtigungen und E-Mails, die bereits enthalten sind.',
  premium_pack_popup_notifications_title: 'Alle Warnungen auf Ihrem Telefon, auch ohne Internetverbindung',
  premium_pack_popup_ring_vibrate_description_1: 'Statt 10 Sekunden ohne das Premium-Paket.',
  premium_pack_popup_ring_vibrate_title: 'Klingelton und Vibration bis zu 30 Sekunden',
  premium_pack_popup_superlive_description_1: 'Statt 2 Minuten ohne das Premium-Paket.',
  premium_pack_popup_superlive_title_simplified: 'Superlive bis zu 30 Minuten ohne Unterbrechung',
  premium_pack_popup_title: '<strong>Greifen Sie kostenlos</strong> auf das Premium-Paket zu',
  register: {
    EMAIL_PLACEHOLDER: 'E-Mail-Adresse',
    ERROR_EMAIL_ALREADY_USED: 'Diese E-Mail-Adresse ist bereits mit einem Konto verknüpft',
    FAILED_DESCRIPTION: 'Bitte melden Sie sich erneut mit Ihren Zugangsdaten an.',
    FAILED_TITLE: 'Ihr Konto wurde erstellt!',
    FIRSTNAME_PLACEHOLDER: 'Vorname',
    LASTNAME_PLACEHOLDER: 'Nachname',
    LOGIN_CTA: 'Anmelden',
    LOGIN_PROMPT_TITLE: 'Schon Kunde?',
    PASSWORD_CONFIRM_PLACEHOLDER: 'Passwort bestätigen',
    PASSWORD_PLACEHOLDER: 'Passwort',
    PHONE_PLACEHOLDER: 'Telefonnummer',
    SUBMIT_CTA: 'Mein Konto erstellen',
    TITLE: 'Konto erstellen'
  },
  registerSummaryTable: {
    BILLED_MONTH: 'Die Zahlung erfolgt monatlich',
    BILLED_NOW: 'Sofortige Rechnungsstellung',
    BILLED_THREE_YEARS: 'Die Zahlung erfolgt alle drei Jahre',
    BILLED_TWO_YEARS: 'Wird alle zwei Jahre in Rechnung gestellt',
    BILLED_YEAR: 'Die Zahlung erfolgt jährlich',
    HINT_OPTIONS_PRICE: 'Die Optionen in Höhe von {{amount}} werden innerhalb von zwei Stunden getrennt vom Abo in Rechnung gestellt.',
    OPTION_UPGRADE: 'Die Option {{name}} hinzufügen – für nur {{price}} / {{period}}',
    PAY_HINT: 'Klicken Sie auf den Knopf „Zahlen und aktivieren“ und bezahlen Sie {{subscriptionPrice}} für das Abo.',
    SUBSCRIPTION_UPGRADE: 'Wechseln Sie zu einem 2-Jahresabo und sparen Sie jedes Jahr {{amount}}.',
    TOTAL: 'Gesamtpreis'
  },
  registerTracker: {
    BUY_LINK: 'Sie haben noch keinen Weenect-Tracker? <1>Hier können Sie einen kaufen.</1>',
    ERRORS: {
      UNKNOWN: 'Beim Aktivieren Ihres Trackers ist ein Problem aufgetreten, bitte versuchen Sie es erneut.'
    },
    HEADLINE: 'Einen neuen Tracker aktivieren',
    IMEI_INPUT: {
      LABEL: 'IMEI-Nummer',
      PLACEHOLDER: 'Sie finden die IMEI-Nummer auf der Rückseite Ihres Trackers.'
    },
    NAME_INPUT: {
      LABEL: 'Tracker-Name',
      PLACEHOLDER: 'Tracker-Name'
    }
  },
  remoteAssistance: {
    BASE: 'Support',
    FEATURES: 'Falls nach einem Drücken der SOS-Taste nicht binnen 30 Sekunden eine Antwort von Ihnen kommt, werden der SOS-Alarm und der Sprachanruf automatisch an unseren Fernsupport übermittelt, täglich und rund um die Uhr. Unsere Mitarbeiter sind befugt, Notdienste wie Polizei oder Rettungsdienst zu verständigen.',
    FORM: {
      ADDRESS_INPUT: {
        LABEL: 'Anschrift',
        PLACEHOLDER: 'Straße und Hausnummer'
      },
      BACK: 'Abbrechen',
      CITY_INPUT: {
        LABEL: 'Stadt',
        PLACEHOLDER: ''
      },
      EXTRA_PHONE: {
        LABEL: 'Zweittelefonnummer (optional)',
        PLACEHOLDER: ''
      },
      HEADLINE: 'Registrierung für den Support',
      NAME_INPUT: {
        LABEL: 'Vollständiger Name',
        PLACEHOLDER: 'Vorname NACHNAME'
      },
      PHONE: {
        LABEL: 'Telefon',
        PLACEHOLDER: ''
      },
      POSTAL_CODE_INPUT: {
        LABEL: 'Postleitzahl',
        PLACEHOLDER: ''
      },
      SAVE: 'Bestätigen',
      TERMS: 'Ich habe die <1>Nutzungsbedingungen</1> für den Dienst gelesen und akzeptiere sie.',
      TEXT: 'Geben Sie die Daten Ihres Angehörigen (der Person, die den Tracker trägt) ein. Anhand der Daten können unsere Mitarbeiter ihm/ihr bei einem SOS-Alarm zu Hilfe kommen.'
    },
    PENDING: {
      WAITING_FOR_CALL_TEST: 'Das Registrierungsformular ist bestätigt. Warte auf den Testanruf.\nSie müssen nun einen Testanruf tätigen, um die Option zu aktivieren. Entnehmen Sie die weitere Vorgehensweise bitte der E-Mail, die Ihnen gesendet wurde.',
      WAITING_FOR_RESIGN: 'Deaktivierung der aktuellen Option.\nWir haben Ihre Anfrage zur Deaktivierung der Option erhalten. Unsere Mitarbeiter kümmern sich jetzt um die Verwaltungsformalitäten. Die Deaktivierung erfolgt in Kürze.',
      WAITING_FOR_VALIDATION: 'Das Registrierungsformular wird jetzt geprüft. \nUnsere Mitarbeiter prüfen jetzt die Angaben, die Sie bei der Anmeldung für die Option gemacht haben. Sobald diese Prüfung abgeschlossen ist, kommen wir zum letzten Schritt vor der Aktivierung der Option: Es wird ein Testanruf getätigt, um zu prüfen, ob alles richtig funktioniert.'
    },
    USER_PHONE: {
      TEXT: 'Tragen Sie Ihre Angaben ein. Anhand der Angaben können unsere Mitarbeiter Sie bei einem SOS-Alarm verständigen.'
    }
  },
  replacetracker: {
    ERROR_ALREADY_LINKED: 'Dieser Tracker ist bereits mit einem Konto verbunden',
    ERROR_INVALID: 'Ungültige IMEI-Nummer',
    ERROR_TYPE_MISMATCH: 'Ein Tracker für ein Tier kann nicht durch einen Tracker für eine Person ersetzt werden und umgekehrt.',
    IMEI_PLACEHOLDER: 'IMEI-Nummer',
    NEW_IMEI_LABEL: 'Geben Sie die IMEI-Nummer des neuen Trackers ein:',
    POPIN_ADD_CTA: 'Tracker hinzufügen',
    POPIN_ADD_DESCRIPTION: 'Um ein weiteres Tier oder eine weitere nahestehende Person zu verfolgen. Ein neuer Tracker benötigt ein eigenes Abonnement, und Ihre aktuellen Tracker bleiben aktiv.',
    POPIN_ADD_TITLE: 'Tracker hinzufügen:',
    POPIN_REPLACE_CTA: 'Tracker ersetzen',
    POPIN_REPLACE_DESCRIPTION: 'Um den Tracker zu wechseln, ohne Ihr Abonnement zu ändern. Ideal, wenn Ihr Tracker verloren oder kaputt ist oder für ein neueres Modell. Der alte Tracker wird deaktiviert.',
    POPIN_REPLACE_TITLE: 'Tracker ersetzen:',
    POPIN_TITLE: 'Tracker hinzufügen oder ersetzen',
    SELECT_TRACKER_LABEL: 'Wählen Sie den zu ersetzenden Tracker aus:',
    SUBMIT_CTA: 'Ersetzen',
    SUBTITLE: 'Das aktuelle Abonnement und die Einstellungen werden nach dem Austausch auf den neuen Tracker übertragen. Der GPS-Positionsverlauf des vorherigen Trackers geht verloren.',
    TITLE: 'Tracker ersetzen',
    TRACKER_IMEI: 'IMEI-Nummer: {{imei}}'
  },
  safetyarea: {
    REDIRECT_APPLICATION: 'Das Bearbeiten und Erstellen von Zonen erfolgt direkt in der Weenect Mobile App.'
  },
  santevet: {
    ADVANTAGE: {
      FIRST: '<span>6 Monate Weenect-Abonnement kostenlos</span> bei Vertragsabschluss',
      PROMO_CODE: 'mit dem Code',
      SECOND: '<span>20 € Präventionsbonus pro Jahr kostenlos</span> zusätzlich zu dem bereits enthaltenen Paket'
    },
    FOOTER: {
      BUTTON: 'Preise ansehen',
      TEXT: 'Indem Sie fortfahren, stimmen Sie zu, von Santévet kontaktiert zu werden.'
    },
    OFFERS: {
      BILL: {
        TEXT: 'Von <span>60 % bis 100 %</span> und bis zu 2.500 €/Jahr.',
        TITLE: 'Erstattung der Kosten bei Krankheiten und Unfällen'
      },
      CROSS: {
        TEXT: 'Profitieren Sie von einer telefonischen Assistenz, <span>kostenlos</span> und <span>jederzeit</span>.',
        TITLE: '24/7 tierärztlicher Notdienst'
      },
      MONEY_PUSH: {
        TEXT: 'Santévet übernimmt Ihre Kosten <span>kostenlos</span> am Ende der Behandlung.',
        TITLE: 'Die Vorfinanzierung Ihrer Tierarztkosten mit Payvet'
      },
      SERINGE: {
        TEXT: '<span>Bis zu 150 €/Jahr</span> für präventive Pflege (Impfungen, Antiparasitika, etc).',
        TITLE: 'Präventionspaket in allen Angeboten enthalten'
      },
      TITLE: 'Die + von Santévet:'
    },
    SUBTITLE: 'und genießen Sie exklusive Vorteile',
    TITLE: 'Versichern Sie {{name}} für nur {{amount}} €/Monat',
    TITLE_WITHOUT_PRICE: 'Versichern Sie {{name}} jetzt'
  },
  share_account_link_expired_popin_text: 'Der von Ihnen verwendete Anmeldelink ist abgelaufen. Bitte erstellen Sie einen neuen, um sich anzumelden.',
  share_account_link_expired_popin_title: 'Link ist abgelaufen',
  signup: {
    ALREADY_MEMBER_TEXT: 'Haben Sie bereits ein Konto?',
    CREATE_ACCOUNT_HEADLINE: 'Ein Konto erstellen',
    LOGIN_TEXT: 'Mich einloggen',
    MARKETING_AGREEMENT_TEXT: 'Ich bin damit einverstanden, Angebote und Werbeaktionen von Weenect-Partnern zu erhalten.',
    RETRY: 'Erneut versuchen',
    SIGNUP_ERRORS: {
      EMAIL_ALREADY_EXISTS: 'Diese E-Mail-Adresse ist bereits mit einem Konto verknüpft.',
      POPIN_EMAIL_ALREADY_EXIST: 'Hoppla, diese E-Mail-Adresse scheint bereits in Gebrauch zu sein.',
      UNKNOWN: 'Die Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut.'
    },
    SIGN_IN_TEXT: 'Anmelden',
    SUBMIT_BUTTON: 'Mein Konto erstellen',
    TERMS_AGREEMENT_TEXT: 'Ich akzeptiere <1>die Nutzungsbedingungen</1> für den Dienst.'
  },
  simInfo: {
    TITLE: 'SIM-Nummer'
  },
  subOptions: {
    CANCEL: {
      EXPIRATION_DATE: 'Diese Option wird bis zum {{Datum}} aktiv bleiben.',
      HEADLINE: 'Möchten Sie die Option {{option}} kündigen?'
    },
    MAP: {
      BASE: 'Multi-Karten Paket',
      FEATURES: 'Profitieren Sie von umfassenderem Kartenmaterial und regelmäßigen Karten-Aktualisierungen, um die Bewegungen Ihres Trackers noch genauer zu verfolgen. (HD-Satellitenkarte, Reliefkarte, Waldwege)',
      TITLE: 'Premium-Karten:'
    },
    PREMIUM: {
      BASE: 'Premium-Paket',
      BUTTON: {
        FREEMONTH: '1 Monat kostenlos testen!'
      },
      DEACTIVATE: 'Wenn Sie diese Option deaktivieren, verlieren Sie Ihre Premiumvorteile.',
      FEATURE: {
        CHAT: {
          BASE: 'Online-Chat',
          TEXT: 'Chatten Sie live von Ihrer App aus mit einem Mitarbeiter von Weenect. Der Service ist 7 Tage die Woche von 9 bis 18 Uhr verfügbar.'
        },
        SMS: {
          TEXT: 'Sie erhalten alle Warnmeldungen per SMS (Guthaben für 40 SMS pro Monat) zusätzlich zu den Push- und E-Mail-Benachrichtigungen, die bereits im Abonnement enthalten sind.'
        }
      },
      FEATURE_TEXT: 'Nutzen Sie exklusive Vorteile (SMS-Benachrichtigungen, HD-Karten) innerhalb der App.',
      FREEMONTH: {
        BASE: 'Erster Monat geschenkt!',
        BASE2: 'GESCHENKT'
      },
      SUBTITLE: 'Das Premium-Paket enthält die folgenden Features:',
      SUB_LEGAL: 'Diese Mitgliedschaft wird automatisch jeden Monat erneuert, über die Zahlungsmethode, die Sie beim Abschluss Ihres Abonnements gewählt haben. Sie können die Mitgliedschaft jederzeit über Ihren persönlichen Bereich kündigen.',
      TEXT_INFO_PRICE: 'Danach {{price}}/Monat nach dem ersten Monat.',
      TITLE_DISCOVER: 'Entdecken Sie Ihre exklusiven Vorteile : ',
      TITLE_POPUP: 'Werden Sie ein Premium-Mitglied!'
    },
    SMS_PACK: {
      ALT_FEATURES: {
        one: 'Erhalten Sie alle Benachrichtigungen per SMS.',
        other: ''
      },
      BASE: 'SMS-Paket',
      FEATURES: {
        one: 'Erhalten Sie alle Benachrichtigungen per SMS (20 SMS pro Monat abrufbar). Bitte beachten Sie, dass Sie ohne diese Option Benachrichtigungen über Push-Nachrichten (App) und E-Mails erhalten.',
        other: ''
      }
    },
    UNDEFINED: {
      PAYMENTS: 'Zahlung für die Option'
    },
    WARRANTY: {
      ALT_FEATURES: {
        one: 'Erhalten Sie kostenlos einen neuen Tracker, falls Ihr jetziges Gerät kaputtgeht, verloren oder gestohlen wird.',
        other: 'Zahlung mit Debitkarte, Kündigung jederzeit möglich',
        two: 'Ihr Tracker ersetzt in 48 Stunden im Falle von Verlust, Bruch oder Diebstahl, ohne Bedingungen.'
      },
      BASE: 'Multi-Risiko-Garantie',
      EXPLAINER: 'Die Standardgarantie deckt nur Probleme bei der Fertigung des Trackers ab.',
      FEATURES: 'Sie erhalten einen kostenlosen Ersatz-Tracker bei Defekt, Verlust oder Diebstahl Ihres derzeitigen Trackers; eine entsprechende Nachweispflicht ist nicht erforderlich. Die Standardgarantie deckt nur etwaige Fabrikationsfehler des Trackers ab.'
    }
  },
  subscription: {
    ADD_A_PROMO_CODE: 'Aktionscode hinzufügen',
    CANCEL_PAGE: {
      BUTTON: 'Erneut versuchen',
      TEXT: 'Ihre Zahlung wurde storniert',
      TITLE: 'Zahlung storniert'
    },
    COMMON_TEXT: {
      MONTH: '/ Monat',
      OR: 'Oder '
    },
    FAIL_PAGE: {
      BUTTON: 'Erneut versuchen',
      TEXT: 'Ihre Zahlung war nicht erfolgreich. Bitte versuchen Sie es erneut.',
      TITLE: 'Zahlung fehlgeschlagen'
    },
    FEATURES: {
      APP_ACCESS: 'Unbegrenzter Zugriff auf die App und den Ortungsdienst.',
      REFOUND: '15-tägige Testversion: Zufrieden oder Geld zurück.',
      SAV: 'Kundenservice an 6/7 Tagen verfügbar. \nGarantierte Antwort innerhalb von 24 Stunden.',
      WARRANTY: '24 Monate Herstellergarantie.'
    },
    FIRST_PAGE: {
      BANNER_NEW_PRICES_DESCRIPTION: 'Die unten angegebenen Preise gelten bis zum Ende Ihrer Vertragslaufzeit. Bei den nächsten Verlängerungen nach dem 1. Juli 2026 wird der neue Preis angewendet.',
      BANNER_NEW_PRICES_TITLE: 'Neue Preise ab 1. Juli 2026',
      BUTTON: 'Weiter',
      BY_YEAR: 'Das sind {{price}} pro Jahr',
      DETERRENT_MONTHLY_POPIN: {
        BUTTON: {
          CHANGE: 'Angebot wechseln',
          CONTINUE: 'Trotzdem fortfahren'
        },
        DESCRIPTION: 'Dieses Angebot hat keine Widerrufsfrist und bietet keine lebenslange Garantie auf Ihren Tracker.\nWählen Sie lieber das Abonnement 1 Jahr!',
        TITLE: 'Sind Sie sicher, dass Sie das monatliche Abonnement abschließen möchten?'
      },
      FOR_YEAR: 'Das sind {{price}} für {{period}} Jahre',
      MODAL_GIFT_CARD: {
        BUTTON: 'Anwenden',
        DELETE_BUTTON: 'Remove',
        ERROR: 'Die eingegebene Geschenkkartennummer ist ungültig',
        INPUT_LABEL: 'Geschenkkarte',
        TITLE: 'Eine Geschenkkarte hinzufügen'
      },
      MODAL_INFORMATION: {
        TEXT: 'Die direkt in Ihren Tracker integrierte SIM-Karte erfordert ein Abonnement (um die Servicegebühren zu decken).',
        TITLE: 'Warum ein Abonnement wählen?'
      },
      SUBSCRIPTION_CGV: {
        FIRST_TEXT: 'Alle Abonnements werden auf einmal bezahlt und je nach gewähltem Zeitraum automatisch verlängert. Sie können diese Verlängerung jederzeit vor Ablauf des aktuellen Zeitraums kündigen.',
        INCLUDES: {
          FIRST: 'zufrieden oder geld zurück',
          FIRST_BOLD: '15 oder 30 Tage Mindest-Testzeitraum je nach Abonnement:',
          FOURTH: 'hersteller 24 Monate Mindestlaufzeit',
          FOURTH_BOLD: 'Garantie',
          SECOND: 'und zum unbegrenzten Standortdienst.',
          SECOND_BOLD: 'Zugang zur App',
          THIRD: 'verfügbar 6/7 Tage. Antwort garantiert innerhalb von 24 Stunden.',
          THIRD_BOLD: 'Kundenservice'
        },
        SECOND_TEXT: 'Um von den abonnements zu profitieren, müssen Sie gültige Bankinformationen eingeben und die akzeptieren',
        SECOND_TEXT_LINK: 'allgemeine nutzungsbedingungen des dienstes.',
        TITLE: 'Alle Abonnements beinhalten:'
      },
      SUBSCRIPTION_CHOICE: {
        CHIP_BEST_OFFER: 'Bestes Angebot',
        CHIP_ECO_OFFER: 'Günstiges Angebot',
        CHIP_ONE_MONTH: 'Flexibles Angebot',
        CHIP_ONE_YEAR: 'Beliebtes Angebot',
        CHIP_POPULAR_OFFER: 'Beliebtes Angebot',
        CHIP_THREE_YEAR: 'Sparen Sie {{count}}%',
        SEE_MORE: 'Weitere Abonnements anzeigen',
        SUBSCRIPTION_TITLE_GIFT_CARD: 'Ich habe eine Geschenkkarte',
        SUBSCRIPTION_TITLE_MONTHLY: 'Monatliches Abonnement',
        SUBSCRIPTION_TITLE_one: 'Abonnement für {{count}} Jahr',
        SUBSCRIPTION_TITLE_other: 'Abonnement für {{count}} Jahre',
        TIP_30_DAYS_WARRANTY: '🛡️ Zufrieden oder Geld zurück: Sie haben 30 Tage Zeit, Ihre Meinung zu ändern.',
        TIP_ONE_MONTH: '⚠️ Sparen Sie {{price}} mit dem Abonnement 1 Jahr.',
        TIP_ONE_MONTH_ALT: '⚠️ Das monatliche Abonnement würde Ihnen über ein Jahr {{loss}} kosten.',
        TIP_ONE_YEAR: '💡 Spare {{savings}}%, indem du das 3-Jahres-Abo wählst.',
        TIP_THREE_YEAR: '🛡️ Erweiterte "Zufrieden oder Geld zurück"-Garantie: Sie haben 30 Tage Zeit, Ihre Meinung zu ändern.',
        TIP_TWO_YEAR: '💡 Erhalte ein zusätzliches Jahr Abonnement für nur {{additional_cost}} mehr, wenn du das 3-Jahres-Abo wählst.',
        TITLE: 'Wählen Sie Ihr Abonnement'
      },
      SUBTITLE: 'Abonnements kommen mit einer „Zufrieden oder Geld zurück“-Garantie: Sie haben 15 Tage Zeit, Ihre Meinung zu ändern.'
    },
    FOR_MINUS_X_PERCENT: '{{percent}}% Rabatt',
    FREE: 'KOSTENLOS',
    HEADER: {
      STEP: 'Schritt',
      TITLE: {
        FIRST_PAGE: 'Abonnement',
        SECOND_PAGE: 'Optionen',
        THIRD_PAGE: 'Zahlung'
      }
    },
    HOME_PAGE: {
      TITLE: ''
    },
    INFO_CGU: 'Um die Abonnements zu nutzen, müssen Sie eine gültige Bankverbindung eingeben und akzeptieren.',
    INFO_CGU_BUTTON: 'die Allgemeinen Geschäftsbedingungen für die Nutzung des Dienstes.',
    INFO_OPTION: 'Die Zahlung erfolgt monatlich, eine Kündigung ist jederzeit möglich.',
    MANAGE: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Bevorzugter Support sowie Ersatz Ihres Trackers im Falle von Verlust, Beschädigung oder Diebstahl – ganz ohne Nachweis.',
        DESCRIPTION2: 'Falls Ihr Haustier trotz seines Trackers verschwindet, unterstützt Sie unser Team mit Hilfsmitteln zur Suche, damit Sie Ihr Tier wiederfinden können.',
        TITLE: 'Sorglos-Paket'
      }
    },
    MANAGE_MEAN: {
      MEAN: {
        CARD: 'Kreditkarte',
        DIRECT_DEBIT: 'Bankeinzug',
        EDIT: 'Bearbeiten',
        EXPIRED: '⚠️ Diese Zahlungsmethode ist abgelaufen.\nKlicken Sie darauf, um sie neu zu konfigurieren oder eine neue Zahlungsmethode hinzuzufügen.',
        EXPIRY_DATE: 'Ablaufdatum',
        INVALID: '⚠️ Diese Zahlungsmethode wurde nach mehreren fehlgeschlagenen Zahlungen deaktiviert.\nWählen Sie sie aus, um sie neu zu konfigurieren, oder fügen Sie eine neue Zahlungsmethode hinzu.',
        NO_MEAN: {
          BUTTON: 'Zahlungsmethode hinzufügen',
          TITLE: 'Du hast keine gespeicherte Zahlungsmethode.'
        },
        NO_REFERENCE: 'Zahlungsmethode ändern',
        SUBTITLE: 'Die unten gespeicherte Zahlungsmethode wird für die Verlängerung Ihrer Abonnements und Optionen verwendet.\nKlicken Sie darauf, um sie zu ändern.',
        TITLE: 'Zahlungsmethode verwalten'
      },
      TITLE: 'Zahlungsmethode und Rechnungen'
    },
    MANAGE_PAGE: {
      ACCOUNT_OPTIONS: {
        DESCRIPTION: 'Die Kontooptionen gelten für alle Tracker in Ihrem Konto.',
        PREMIUM_PACK: {
          DESCRIPTION: '- Superlive bis zu 30 Min\n- Zusätzliche Karten für alle Gelände\n- Bewegungs-Heatmap\n- SMS-Benachrichtigungen\n- 10 vertrauenswürdige Kontakte\n- Zugriffsteilung Ihres Kontos\n- Active Plus Modus\n- 3D-Wiedergabe',
          TITLE: 'Premium-Paket'
        },
        TITLE: 'Kontoeinstellungen',
        WARRANTY: {
          DESCRIPTION: '💡 Bevorzugter Support sowie Ersatz Ihres Trackers im Falle von Verlust, Beschädigung oder Diebstahl – ganz ohne Nachweis.\nFalls Ihr Haustier trotz seines Trackers verschwindet, unterstützt Sie unser Team mit Hilfsmitteln zur Suche, damit Sie Ihr Tier wiederfinden können.',
          TITLE: 'Sorglos-Paket'
        }
      },
      ACTIVATE: {
        BUTTON: 'Aktivieren'
      },
      ADD_SUBSCRIPTION_BUTTON: 'Ein Abonnement wählen',
      CANCEL: {
        BUTTON: 'Kündigen'
      },
      CANCEL_CONFIRM: {
        GENERIC: {
          BUTTON: {
            CONTINUE_CANCELLATION: 'Fortfahren',
            KEEP_ADVANTAGES: 'Meine Vorteile behalten'
          },
          TITLE: 'Sind Sie sicher?'
        },
        OPTION: {
          PREMIUM_PACK: {
            SUBTITLE: 'Wenn Sie die Verlängerung des Premium-Pakets deaktivieren, verlieren Sie ab dem {{date}} folgende Vorteile:'
          },
          WARRANTY: {
            SUBTITLE: 'Wenn Sie die Verlängerung Ihres Sorglos-Pakets deaktivieren, verlieren Sie ab dem {{date}} die folgenden Vorteile:'
          }
        },
        SUBSCRIPTION: {
          ADVANTAGES: {
            DESCRIPTION: '- Zugang zu den Weenect-Diensten für diesen Tracker\n- Lebenslange Herstellergarantie für Ihren Tracker'
          },
          SUBTITLE: 'Wenn Sie die Verlängerung Ihres Abonnements deaktivieren, verlieren Sie ab dem {{date}} folgende Vorteile:'
        }
      },
      EDIT: {
        BUTTON: 'Bearbeiten',
        CANCEL_REVIEW: {
          DETAILS: {
            SUBTITLE: 'Wir möchten besser verstehen, was für Sie nicht funktioniert hat. Ihr Feedback ist wertvoll und hilft uns, unseren Service zu verbessern.'
          },
          OPTION: {
            SUBTITLE: {
              PREMIUM_PACK: 'Es tut uns leid, dass Sie gehen.\nAus welchem Grund möchten Sie die Verlängerung Ihres Premium-Pakets kündigen?',
              WARRANTY: 'Es tut uns leid, dass Sie gehen.\nAus welchem Grund möchten Sie die Verlängerung Ihres Sorglos-Pakets kündigen?'
            },
            TITLE: 'Verlängerung der Option deaktivieren'
          },
          REASON: {
            AFTER_SALES_SERVICE: 'Schlechte Erfahrung mit dem Kundenservice',
            BAD_NETWORK: 'Die Netzwerkverbindung ist schlecht',
            BAD_PRECISION: 'Schlechte GPS-Positionen',
            BATTERY: 'Unzureichende Batterielebensdauer',
            LOST_BROKEN: 'Ich habe meinen Tracker verloren / kaputt gemacht',
            MISSING_FEATURES: 'Es fehlen eine oder mehrere Funktionen',
            MOBILE_APPLICATION: 'Die App funktioniert nicht',
            NOT_ENOUGH_FEATURES_PREMIUM: 'Nicht genug Funktionen (Premium-Paket)',
            NOT_SATISFIED: 'Ich bin nicht zufrieden',
            NO_USE: 'Ich benutze den Tracker nicht mehr',
            OTHER: 'Andere',
            PLACEHOLDER: 'Sag uns mehr…',
            TOO_EXPENSIVE: 'Abonnement zu teuer',
            TOO_EXPENSIVE_OPTION: 'Die Option ist zu teuer',
            TRACKER_FORMAT: 'Tracker zu groß / schwer',
            TRACKER_ISSUE: 'Probleme mit dem Tracker',
            WILL_REACTIVATE_LATER: 'Um die automatische Verlängerung zu pausieren (ich möchte den Tracker weiterhin verwenden)'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'Es tut uns leid, dass Sie gehen.\nAus welchem Grund möchten Sie die Verlängerung Ihres Abonnements kündigen?',
            TITLE: 'Verlängerung des Abonnements deaktivieren'
          }
        },
        ERROR: {
          HEADER: 'Fehler',
          SUBTITLE: 'Die Änderung Ihres Abonnements ist fehlgeschlagen. Bitte versuchen Sie es erneut.\nWenn das Problem weiterhin besteht, wenden Sie sich an unseren Kundenservice.',
          TITLE: 'Ups, es ist ein Problem aufgetreten.'
        }
      },
      EDIT_OPTION: {
        HEADER: 'Option ändern'
      },
      EDIT_RESULT: {
        BUTTON: 'Zurück zum Menü',
        CANCELLATION_SUCCESS: {
          OPTION: {
            SUBTITLE: 'Die automatische Verlängerung Ihrer Option {{option_title}} wurde erfolgreich abgebrochen.'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'Die automatische Verlängerung Ihres Abonnements wurde erfolgreich abgebrochen.'
          },
          TITLE: 'Automatische Verlängerung storniert'
        },
        CHANGE_SUBSCRIPTION: {
          SUCCESS: {
            SUBTITLE: 'Ihr Abonnement wird am <strong>{{next_charge_at}}</strong> zum Preis von <strong>{{upgrade_amount}}</strong> für das Paket <strong>{{update_offer_title}}</strong> verlängert.',
            TITLE: 'Abonnementwechsel erfolgreich!'
          }
        },
        OFFER_SUCCESS: {
          CREATE_TICKET: {
            SUBTITLE: 'Ihre Anfrage für prioritären Support wurde gespeichert.\nEiner unserer Berater wird Sie bald kontaktieren, um Ihr Problem zu lösen.',
            TITLE: 'Anfrage gespeichert'
          },
          FREE_MONTHS: {
            SUBTITLE: 'Wir freuen uns, {{tracker_name}} weiterhin zu schützen.\nIhre nächste Verlängerung erfolgt am <strong>{{next_charge_at_with_free_months}}</strong>.',
            TITLE: 'Abonnement aktualisiert!'
          },
          UPGRADE: {
            SUBTITLE: 'Wir freuen uns, {{tracker_name}} weiterhin zu schützen.\nIhr Abonnement wird am <strong>{{next_charge_at}}</strong> zum Preis von <strong>{{upgrade_amount}}</strong> für das Paket <strong>{{update_offer_title}}</strong> verlängert.',
            TITLE: 'Abonnement aktualisiert!'
          }
        }
      },
      EDIT_SUBSCRIPTION: {
        CANCEL: {
          SUBTITLE: 'Ihr Abonnement wird nicht mehr automatisch verlängert.\nSie verlieren den Zugriff auf Ihre Dienste am {{date}}.',
          TILE: 'Verlängerung deaktivieren',
          TITLE: 'Verlängerung deaktivieren?'
        },
        CHANGE: {
          SUBTITLE: 'Die Änderung des Abonnements wird am Ende des aktuellen Zeitraums wirksam.',
          SUCCESS: {
            BUTTON: 'Zurück zum Menü',
            SUBTITLE: 'Ihr Abonnement wird mit folgendem Tarif erneuert:\n<strong>{{new_offer_title}}</strong>\nDie Abrechnung und Erneuerung mit diesem Tarif erfolgt am <strong>{{date}}</strong>.',
            SUBTITLE_1: 'Ihr Abonnement wird mit folgendem Tarif verlängert:',
            SUBTITLE_2: 'Die Abrechnung und Verlängerung mit diesem Tarif erfolgen am {{date}}.',
            TITLE: 'Abonnementänderung gespeichert!'
          },
          TITLE: 'Abonnement wechseln?'
        },
        ERROR: {
          SUBTITLE: 'Die Aktion wurde nicht ausgeführt.\nBitte versuchen Sie es später erneut.',
          TITLE: 'Fehler'
        },
        HEADER: 'Abonnement ändern',
        OVERCHARGE_PER_YEAR: 'Sie verlieren {{price}} / An',
        SAVINGS_PER_YEAR: 'Sie sparen {{price}} / An'
      },
      FIRST_MONTH_FREE: 'Erster Monat kostenlos',
      INVALID_PAYMENT_MEAN_POPIN: {
        BUTTON: 'Meine Zahlungsmethode aktualisieren',
        SUBTITLE: {
          ERRORS: 'Ihre Zahlungsmethode ist ungültig.\nKlicken Sie auf die Schaltfläche unten, um sie zu aktualisieren.',
          EXPIRED: 'Ihre Zahlungsmethode ist abgelaufen.\nKlicken Sie auf die Schaltfläche unten, um sie zu aktualisieren.',
          MISSING: 'Es ist keine Zahlungsmethode in Ihrem Konto hinterlegt.\nKlicken Sie auf die Schaltfläche unten, um eine hinzuzufügen.'
        },
        TITLE: {
          OPTION: 'Ihre Option kann nicht reaktiviert werden',
          SUBSCRIPTION: 'Ihr Abonnement kann nicht reaktiviert werden'
        }
      },
      NO_SUBSCRIPTION: 'Dieser Tracker hat kein Abonnement.',
      OPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Diese Option ist aktiv und wird am {{date}} für {{period}} zum Preis von {{price}} automatisch verlängert.',
          DESCRIPTION_PAST: 'Diese Option ist aktiv und wird demnächst für {{period}} zum Preis von {{price}} in Rechnung gestellt.',
          TITLE: 'Automatische Verlängerung aktiv'
        },
        ACTIVE_NO_DATE: {
          DESCRIPTION: 'Diese Option ist aktiv.'
        },
        CANCELED: {
          DESCRIPTION: 'Die Verlängerung dieser Option ist deaktiviert. Der Zugriff auf die Funktionen ist bis zum {{date}} weiterhin möglich, aber nach diesem Datum sind sie nicht mehr verfügbar.',
          TITLE: 'Automatische Verlängerung deaktiviert'
        },
        EXPIRED: {
          DESCRIPTION: 'Diese Option ist abgelaufen. Bitte aktivieren Sie sie erneut, um wieder Zugang zu den zugehörigen Funktionen zu erhalten.'
        }
      },
      REACTIVATE: {
        BUTTON: 'Verlängerung reaktivieren'
      },
      RETENTION_OFFERS: {
        BUTTON: {
          ACCEPT: 'Akzeptieren',
          CONTINUE_CANCELLATION: 'Stornierung fortsetzen'
        },
        CREATE_TICKET: {
          BUTTON: 'Rückruf anfordern',
          DESCRIPTION: 'Erstellen Sie eine vorrangige Anfrage, und unser Kundendienst kontaktiert Sie zuerst – keine Warteschlange, schnelle und persönliche Antwort.',
          TITLE: 'Brauchen Sie Hilfe?\nEin Berater ruft Sie vorrangig zurück'
        },
        FREE_MONTHS: {
          DESCRIPTION: 'Wenn unser erstes Angebot nicht Ihren Erwartungen entspricht, möchten wir Ihnen ein zweites Angebot nur für Sie machen: <strong>{{free_months}} Monate Abonnement kostenlos!</strong>\n\nSie schützen {{tracker_name}} also weiterhin kostenlos bis zum {{next_charge_at_with_free_months}}.',
          TITLE: '{{free_months}} Monate gratis!'
        },
        UPGRADE: {
          BUTTON: 'Sparen Sie {{savings}} mit einem Klick',
          DESCRIPTION: 'Da wir sehr traurig wären, wenn {{tracker_name}} nicht mehr täglich geschützt wäre, bieten wir Ihnen ein exklusives Angebot: <strong>{{savings_amount}} Ersparnis</strong> auf Ihr <strong>{{upgrade_offer_title}}</strong>.\n\nIhr Abonnement kostet dann <strong>{{upgrade_amount}}, also {{upgrade_amount_monthly}}</strong>.\n\nDieses Angebot gilt ab dem {{next_charge_at}}, dem Verlängerungsdatum Ihres aktuellen Abonnements.',
          TITLE: '-{{discount_ratio}}% auf Ihr {{upgrade_offer_title}}'
        }
      },
      SUBSCRIBE_AGAIN: {
        BUTTON: 'Erneut abonnieren'
      },
      SUBSCRIPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Ihr Abonnement wird am {{date}} automatisch für {{period}} zu {{price}} verlängert.',
          DESCRIPTION_PAST: 'Ihr Abonnement wird demnächst für {{period}} zum Preis von {{price}} in Rechnung gestellt.',
          TITLE: 'Automatische Verlängerung aktiv'
        },
        CANCELED: {
          DESCRIPTION: 'Ihr Abonnement ist bis zum {{date}} aktiv, wird jedoch nicht automatisch verlängert.\nNach diesem Datum wird Ihr Tracker nicht mehr funktionieren.',
          TITLE: 'Automatische Verlängerung deaktiviert'
        },
        EXPIRED: {
          DESCRIPTION: 'Ihr Abonnement ist abgelaufen.\nSie müssen ein neues Abonnement abschließen, um diesen Tracker nutzen zu können.'
        }
      },
      TITLE: 'Abonnement(s) und Optionen',
      TRACKER_SUBSCRIPTIONS_OPTIONS: {
        TITLE: 'Abonnement und Optionen von {{name}}'
      }
    },
    MONEY_BACK: 'Alle Abonnements werden sofort in Rechnung gestellt, können jedoch innerhalb von 15 Tagen gekündigt werden, wobei der gezahlte Betrag in voller Höhe zurückerstattet wird.',
    MONTH: 'Monat',
    ONLY: 'nur',
    PAYMENTS_LIST: {
      NO_PAYMENTS: {
        TITLE: 'Keine Zahlung wurde vorgenommen.'
      },
      SUBTITLE: 'Sehen Sie unten Ihre letzten Zahlungen ein.\nKlicken Sie auf eine davon, um die Rechnung herunterzuladen.',
      TITLE: 'Rechnungen'
    },
    PAYMENT_INFO: 'Geld-zurück-Garantie: 15 Tage, um Ihren Tracker auszuprobieren.',
    PAYMENT_SUBHEADLINE: 'Wählen Sie eine Zahlungsmethode, um Ihr Abonnement zu bezahlen und Ihren Tracker zu aktivieren.',
    PAYMENT_TITLE: 'Wählen Sie Ihre Zahlungsmethode aus.',
    PAYMENT_TITLE2: 'Registreer uw betaalmethode',
    PENDING_PAGE: {
      BUTTON: 'Abbrechen',
      TEXT: 'Die Zahlungsbestätigung läuft ...',
      TIMEOUT_TEXT: 'Die Zahlungsbestätigung scheint länger zu dauern als erwartet.',
      TITLE: 'Zahlung läuft'
    },
    PERIOD: {
      MONTH_one: '{{period}} Monat',
      MONTH_other: '{{period}} Monate',
      YEAR_one: '{{period}} Jahr',
      YEAR_other: '{{period}} Jahre'
    },
    PREPAYED: '{{price}} einmalig bezahlt',
    PREPAYED_DATE: '{{price}} einmalig bezahlt am {{date}}',
    PRICE_MONTH_SAVED: 'oder {{price}}/Monat',
    SECONDE_PAGE: {
      BUTTON: 'Zur Zahlung fortfahren'
    },
    SECOND_PAGE: {
      BASKET: {
        TEXT: {
          premium_pack: 'Erster Monat kostenlos, dann',
          warranty: 'Die Zahlung ist monatlich.'
        },
        TOTAL: 'Gesamtbetrag inklusive Steuern'
      },
      OPTION_CHOICE: {
        CHIP: '1. Monat kostenlos',
        TEXT: {
          premium_pack: 'Schalten Sie exklusive Funktionen frei: Superlive bis zu 30 Minuten, zusätzliche Kartenansichten, ein anderer Taschenlampenstil oder sogar SMS-Benachrichtigungen.',
          warranty: 'Bevorzugter Support sowie Ersatz Ihres Trackers im Falle von Verlust, Beschädigung oder Diebstahl – ganz ohne Nachweis.\nFalls Ihr Haustier trotz seines Trackers verschwindet, unterstützt Sie unser Team mit Hilfsmitteln zur Suche, damit Sie Ihr Tier wiederfinden können.'
        },
        TITLE: {
          premium_pack: 'Premium-Paket',
          warranty: 'Sorglos-Paket'
        }
      },
      SUBTITLE: 'Die Optionen sind unverbindlich und können jederzeit über Ihre mobile App oder Ihren Kundenbereich gekündigt werden.',
      TITLE: 'Wählen Sie Ihre Optionen'
    },
    SUBSCRIPTION_TITLE: {
      MONTH_one: 'Monatliches Abonnement',
      MONTH_other: '{{period}}-Monats-Abonnement',
      YEAR_one: 'Jahresabonnement',
      YEAR_other: '{{period}}-Jahres-Abonnement'
    },
    SUCCESS_PAGE: {
      BUTTON: 'Zurück zur App',
      TEXT: 'Klicken Sie auf die Schaltfläche unten, um Ihren Tracker zu verwenden.',
      TEXT_ASYNC: 'Die Abbuchung erfolgt in den nächsten Tagen.\n\n⚠️ Wenn Ihre Bank die Zahlung ablehnt, wird der Tracker deaktiviert.\n\nKlicken Sie auf die Schaltfläche unten, um Ihren Tracker zu verwenden.',
      TITLE: 'Zahlung erfasst'
    },
    SUMMARY: 'Zusammenfassung',
    THIRD_PAGE: {
      BUTTON: 'Bestätigen und bezahlen',
      MODAL: {
        ERROR: 'Der Aktionscode ist ungültig',
        TITLE: 'Aktionscode'
      },
      NO_PROVIDER: 'Keine Zahlungsmethode verfügbar',
      PAYMENT_CHOICE: {
        BANK: 'Lastschrift',
        CARD: 'Kreditkarte',
        TITLE: 'Wählen Sie Ihre Zahlungsmethode'
      },
      SUBTITLE: 'Wählen Sie eine Zahlungsmethode, um Ihr Abonnement zu bezahlen und Ihren Tracker zu aktivieren.'
    },
    TUNNEL: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Bevorzugter Support sowie Ersatz Ihres Trackers im Falle von Verlust, Beschädigung oder Diebstahl – ganz ohne Nachweis.',
        DESCRIPTION2: 'Falls Ihr Haustier trotz seines Trackers verschwindet, unterstützt Sie unser Team mit Hilfsmitteln zur Suche, damit Sie Ihr Tier wiederfinden können.',
        TITLE: 'Sorglos-Paket'
      }
    },
    UNKNOWN_PAGE: {
      BUTTON: 'Zurück zur Anwendung',
      TEXT: 'Die Anwendung befindet sich in einem unerwarteten Zustand.',
      TITLE: 'Unbekannter Schritt'
    }
  },
  subscriptionAlert: {
    ACTIVATE_AUTO_RENEWAL: 'Automatische Verlängerung wieder aktivieren',
    AUTO_RENEWAL_ADVICE: 'Wir empfehlen Ihnen, die automatische Verlängerung zu aktivieren, wenn Sie Ihr Abonnement verlängern möchten.',
    AUTO_RENEWAL_NOTICE: '<1>Achtung!</1> Ihr Abonnement für den {{trackerName}} Tracker läuft aus und die automatische Verlängerung ist deaktiviert.',
    CONTINUE_BUTTON: 'Fortfahren',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
      UPDATE_SUCCESS: 'Erfolgreich aktualisiert'
    },
    REMIND_LATER: 'Mich später daran erinnern',
    SUPPORT_TEXT: 'Wenn Sie Fragen haben oder glauben, dass es sich hierbei um einen Fehler handelt, wenden Sie sich bitte an unseren <1>Kundenservice.</1>',
    TRIAL_CASE: {
      SUBSCRIBE_BUTTON: 'Ein Abonnement abschließen',
      TRIAL_IS_OVER: 'Ihre Testphase ist nun beendet',
      TRIAL_IS_OVER_ADVICE: 'Wir hoffen, dass Ihr Test erfolgreich war! Um das Produkt weiterhin nutzen zu können, müssen Sie nun ein Abonnement abschließen.'
    }
  },
  subscriptionOptionsSelection: {
    CANCEL_WARNING_MODAL_HEADLINE: 'Möchten Sie diese Option wirklich deaktivieren?',
    CANCEL_WARNING_SMS: 'Wenn Sie diese Option deaktivieren, erhalten Sie keine Alarmbenachrichtigungen per SMS.',
    CANCEL_WARNING_WARRANTY: 'Wenn Sie diese Option deaktivieren, verlieren Sie den zusätzlichen Schutz durch die Kombiversicherung.',
    EXPLANATION: 'Die Optionen sind standardmäßig aktiviert, aber Sie können diese durch einfaches Anklicken deaktivieren.',
    EXPLANATION2: 'And cancellation is possible at any time.',
    EXPLANATION3: 'Es werden keine Zahlungen durchgeführt.',
    HINT: 'Sie können jederzeit eine Option aktivieren oder deaktivieren.',
    MAIN_HEADLINE: 'Wählen Sie Ihre Optionen aus.',
    SUBMIT_BUTTON: 'Bestätigen'
  },
  subscriptionPayment: {
    ERRORS: {
      UNKNOWN: 'Während der Zahlung ist ein Problem aufgetreten, bitte versuchen Sie es erneut.'
    },
    GIFT_CARD: {
      EXPLANATION: 'Geben Sie den Code ein, der auf der Rückseite der in Ihrem Tracker enthaltenen Karte geschrieben ist.',
      I_HAVE_ONE: 'Ich habe eine Geschenkkarte',
      NEED_HELP: 'Brauchen Sie Hilfe beim Thema Geschenkkarten?',
      TITLE: 'Nutzen Sie Ihr Geschenk',
      USE: 'Benutzen'
    },
    HEADLINE: 'Zusammenfassung vor der Zahlung',
    PROMOCODE_TEXT: 'Ich habe einen Gutscheincode :',
    PROMO_CODE: 'Promo-Code',
    PROMO_CODE_GIFT_CARD: 'Geschenkkarte',
    SATISFIED_OR_REFUNDED: 'Unsere Garantie: 100% zufrieden oder Geld zurück',
    SATISFIED_OR_REFUNDED_DESCRIPTION: 'Profitieren Sie von einem 30-tägigen, risikofreien Testzeitraum – wenn Sie nicht zufrieden sind, erstatten wir Ihnen Ihr Geld zurück.',
    SELECT_PAYMENT_MEAN: 'Wählen Sie die von Ihnen gewünschte Zahlungsmethode vor dem Bezahlen und Aktivieren Ihres Abonnements aus.',
    SUBMIT_BUTTON: 'Abonnement bezahlen',
    SUBMIT_BUTTON2: 'Den Tracker aktivieren',
    SUMMARY: 'Ihre Auswahl im Überblick'
  },
  subscriptionProcess: {
    GIFT_CARD_EXPLANATION: 'Geben Sie Ihre bevorzugte Zahlungsmethode an, um Ihren Tracker kostenlos zu aktivieren.',
    GIFT_CARD_EXPLANATION2: 'Diese Information ist aus rechtlichen Gründen im Zusammenhang mit der Verwendung von SIM-Karten erforderlich.',
    RETURN_TO_APP: 'Zur Anwendung zurückkehren',
    RETURN_TO_MAP: 'Zurück zur Karte',
    RETURN_TO_TRACKERS: 'Zurück zur Karte',
    STEPS: [
      'Tracker',
      'Abo',
      'Optionen',
      'Zusammenfassung'
    ]
  },
  subscriptionSelection: {
    BEST_OFFER: 'BESTES ANGEBOT',
    CANCELABLE_AFTER_THREE_MONTHS: 'Kündigung nach Ablauf der ersten drei Monate jederzeit möglich',
    CANCEL_ANYTIME: 'Kündigung jederzeit möglich',
    COMMITMENT_TEXT: 'Jederzeit kündbar nach der Mindestbindungsdauer von 3 Monaten.',
    FEATURES: '',
    FEATURES_HEADLINE: 'Alle Abos enthalten:',
    HEADLINE: 'Wählen Sie Ihr Abo aus.',
    MIN_THREE_MONTHS: 'Drei Monate Mindestvertragslaufzeit',
    MONEY_BACK: 'Alle Abos werden sofort in Rechnung gestellt, können aber innerhalb von 30 Tagen widerrufen werden. In diesem Fall wird der gezahlte Betrag vollständig zurückerstattet.',
    PAYMENT_MEANS: 'Zahlung mittels Bankeinzug und Kreditkarte',
    REFUNDED_INFO: 'Wir erstatten das Abonnement bedingungslos zurück.',
    REFUNDED_TEXT: '30 Tage Probezeit: zufrieden oder Geld zurück.',
    SIM_CARD_WARNING: 'Eine SIM-Karte ist bereits fest in Ihren Tracker integriert. Dies erklärt, warum das Abschließen eines Abonnements notwendig ist (zur Deckung der anfallenden Nutzungsgebühren nämlich).',
    SUBMIT_BUTTON: 'Bestätigen',
    XMAS_OFFER: {
      BODY: 'Wir sind jedoch verpflichtet, Sie jetzt zu veranlassen, Ihr zukünftiges Abonnement zu wählen (aus Sicherheitsgründen, denn das Produkt ist mit einer SIM-Karte ausgestattet). Sie werden nicht vor Ablauf der 6 gratis Monate belastet und können dieses Abonnement jederzeit bis zu einem Monat vor dem Datum des Inkrafttretens kündigen.',
      TITLE: 'Ihr Tracker hat 6 Monate Abo vorausbezahlt.'
    },
    features: [
      '30 Tage Zufriedenheitsgarantie',
      'Uneingeschränkte GPS-Ortung',
      'Push-Benachrichtigungen (App) und E-Mail-Benachrichtigungen',
      '10 Minuten Sprachanruf-Guthaben pro Monat'
    ]
  },
  subscriptioncarousel: {
    CARDSBLOCK_1YEAR_PAYMENT: 'Zahlung von {{total_price}} jährlich.',
    CARDSBLOCK_1YEAR_TITLE: '1-Jahres Vorauszahlung',
    CARDSBLOCK_2YEARS_PAYMENT: 'Zahlung von {{total_price}} alle zwei Jahre.',
    CARDSBLOCK_2YEARS_TITLE: '2-Jahres Vorauszahlung',
    CARDSBLOCK_5YEARS_PAYMENT: 'Zahlung von {{total_price}} alle fünf Jahre.',
    CARDSBLOCK_5YEARS_TITLE: '5-Jahres Vorauszahlung',
    CARDSBLOCK_BADGE_GUARANTEE: 'Zufrieden oder Geld zurück',
    CARDSBLOCK_BADGE_POPULAR: 'Beliebtes Angebot',
    CARDSBLOCK_GUARANTEE: 'Zufrieden oder Geld zurück: Sie haben 30 Tage Widerrufsrecht.',
    CARDSBLOCK_MONTHLY_PAYMENT: 'Monatliche Zahlung ohne Bindung.',
    CARDSBLOCK_MONTHLY_TITLE: 'Monatliches Abonnement',
    CARDSBLOCK_PERMONTH: '{{price}} / Monat',
    CARDSBLOCK_SEEMORE: 'Weitere Abonnements anzeigen'
  },
  subscriptions: {
    BASE: 'Abo',
    CANCEL_MODAL: {
      HEADLINE: 'Möchten Sie die automatische Verlängerung Ihres Abos aufheben?',
      HINT: 'Ihr Abo bleibt bis zum {{date}} gültig, wird jedoch nicht automatisch verlängert.\nNach diesem Datum werden Sie Ihren Tracker nicht mehr orten können.'
    },
    CHANGE_PLAN: {
      ADD_OPTIONS: 'Option hinzufügen',
      EXPLANATION: 'Der Abowechsel erfolgt am Ende der aktuellen Laufzeit.',
      HEADLINE: 'Abo wechseln?'
    },
    DETAILS: {
      ACTIVATE_BUTTON: {
        LABEL: 'Abo aktivieren'
      },
      ACTIVE_CASE: {
        MANAGE_BUTTON: 'Abo verwalten',
        RENEWAL_INFO: 'Ihr Abonnement wird automatisch am {{date}} zum Preis von {{price}} verlängert.'
      },
      CANCELED: {
        EXPIRED_MAIN: 'Ihr Abonnement ist abgelaufen. Reaktivieren Sie dieses, um Ihren Tracker orten zu können.',
        EXPIRED_SEC: 'Abgelaufen',
        UNCANCEL_BUTTON_LABEL: 'Automatische Verlängerung des Abos aktivieren',
        WILL_EXPIRE_DAYS: 'Läuft in {{count}} Tag ab',
        WILL_EXPIRE_DAYS_plural: 'Läuft in {{count}} Tagen ab',
        WILL_EXPIRE_MAIN: 'Die automatische Verlängerung des Abos ist aufgehoben. Es läuft am {{date}} ab.'
      },
      CANCEL_RESILLIATION: 'Abbrechen der Stornierungsanfrage',
      NEW_CASE: {
        INFO_TEXT: 'Wir sind auf ein Problem mit Ihrer Zahlung gestoßen. Bitte versuchen Sie es erneut oder ändern Sie Ihre Zahlungsdaten.',
        PAY_BUTTON: 'Zahlen und aktivieren',
        WAITING_TEXT: 'Wir bearbeiten gerade Ihre Zahlung für das Abonnement für diesen Tracker.'
      },
      NO_SUB: {
        INFO_TEXT: 'Aktivieren Sie das Abo, um mit der Benutzung Ihres Trackers zu beginnen.'
      },
      RESILLIATION_ASKED: 'Stornierung beantragt',
      SUBSCRIBE_BUTTON: {
        LABEL: 'Ein Abonnement abschließen'
      },
      SUPPORT_TEXT: 'Haben Sie Schwierigkeiten, Ihr Tracker zu aktivieren? Wenden Sie sich an unseren <1>Kundenservice</1>.',
      TRIAL_PERIOD_CASE: {
        END_INFO: 'Ihre Testphase endet am {{ date }}'
      }
    },
    OFFERS: {
      SAVINGS: 'sparen Sie {{price}}',
      SAVING_PER_YEAR: 'Sparen Sie {{amount}} pro Jahr'
    },
    OFFERS_TEXT: {
      MOST_POPULAR: 'Das Beliebteste',
      ONE_MONTH: {
        INFO: 'Unverbindlich, jederzeit kündbar',
        TITLE: 'Formel 1 Monat'
      },
      ONE_YEAR: {
        INFO: '15 Tage Probezeit zusätzlich: 30 Tage insgesamt.',
        TITLE: 'Formel 1 Jahr'
      },
      THREE_YEAR: {
        INFO: '1 Jahr zusätzliche Herstellergarantie: insgesamt 3 Jahre',
        INFO2: '3-year manufacturer\'s warranty (instead of two).',
        TITLE: '3-Jahres-Formel'
      }
    },
    OVERVIEW: {
      OPTIONS: 'Details zu den Optionen',
      REG_DETAILS: 'Tracker-Details',
      REPLACE_TRACKER_BUTTON: {
        LABEL: 'Tracker ersetzen'
      },
      SUB_DETAILS: 'Details zum Abo'
    },
    PLAN_NAMES: {
      FALLBACK: 'Abo',
      ONE_MONTH: 'Monatliches Abonnement',
      ONE_YEAR: 'Prepaid-Abonnement (1 Jahr)',
      THREE_YEARS: 'Prepaid-Abonnement (3 Jahre)',
      TRIAL_PERIOD: 'Probezeit',
      TWO_YEARS: '2-Jahresabo'
    },
    STATUS: {
      ACTIVE: 'Abonniert',
      CANCELED: 'Gekündigt',
      INACTIVE: 'Nicht Abonniert',
      NEW: 'Aktiv',
      PENDING: 'Warte'
    },
    TRACKER_DETAILS: {
      REGISTRATION_DATE: 'Aktivierungsdatum',
      WARRANTY: 'Standardgarantie'
    }
  },
  superLive: {
    ACTIVE_TEXT: 'Superlive ist aktiviert.',
    HEADLINE: 'Super-Live-Modus',
    MESSAGES: {
      SUCCESS_ACTIVATED: 'Der Superlive wurde aktiviert – 5 Minuten lang alle {{frequency}} Sekunden ein Standort.'
    },
    TIME: 'Ein Standort alle {{frequency}} Sekunden'
  },
  support: {
    FORM: {
      MESSAGE: {
        LABEL: 'Ihre Nachricht*',
        PLACEHOLDER: ''
      },
      PROBLEM: {
        AVAILABLE_OPTIONS: 'Verfügbare Optionen',
        LABEL: 'Art des Problems*'
      },
      SUBJECT: {
        LABEL: 'Betreff Ihrer Anfrage*',
        PLACEHOLDER: ''
      },
      TRACKER: {
        LABEL: 'Tracker, auf den sich Ihre Anfrage bezieht',
        PLACEHOLDER: 'Wählen Sie den Tracker aus'
      }
    },
    HEADLINE: 'Support',
    HELP_CENTER: 'Hilfe-Center',
    HELP_TEXT: 'Benötigen Sie weitere Hilfe? Besuchen Sie unser Kundencenter, um die Antworten auf Ihre Fragen zu finden. Sie können uns auch mithilfe des untenstehenden Formulars kontaktieren; unser Team antwortet an Werktagen innerhalb von 24 Stunden.',
    MAIN_TEXT: 'Unser Hilfezentrum enthält alle Artikel, die Ihre Fragen beantworten können.',
    MESSAGES: {
      SUBMIT_ERROR: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
      SUBMIT_SUCCESS: 'Nachricht erfolgreich versendet'
    },
    PROBLEM_TYPES: {
      CHARGE: 'Mein Tracker wird nicht normal aufgeladen.',
      DOWNLOAD_APP: 'Ich kann die App nicht herunterladen.',
      GPS_INVALID: 'Mein GPS-Signal wird als ungültig angezeigt.',
      GPS_PRECISION: 'Der GPS-Standort meines Trackers ist nicht korrekt.',
      LEDS_FIXED: 'Beide LED Lichter meines Trackers leuchten konstant.',
      NO_GEOFENCE_ALERTS: 'Ich erhalte Fehlalarme über das Betreten oder Verlassen von Zonen.',
      NO_NOTIFICATIONS: 'Ich erhalte keine Benachrichtigungen.',
      OTHER: 'Anderes',
      SIGN_IN: 'Ich kann mich nicht in meinem persönlichen Bereich anmelden.',
      SUBSCRIPTION: 'Ich habe ein Problem mit meinem Abonnement.',
      TRACKERS_PARAMS: 'Ich kann meinen Tracker nicht konfigurieren.',
      TRACKER_NOT_CONNECTED: 'Mein Tracker wird als nicht verbunden angezeigt.'
    },
    SUBMITTED_TICKET: 'Wir haben Ihre Nachricht erhalten, vielen Dank.\nSie haben eine Bestätigung per E-Mail geschickt bekommen (bitte sehen Sie auch in Ihrem Spam-Ordner nach).',
    SUB_TEXT: 'Sollten Ihnen diese Erklärungen nicht ausreichen, können Sie sich auch an einen Mitarbeiter unseres Serviceteams wenden, der Ihnen innerhalb von 24 Arbeitsstunden antworten wird.',
    TITLE: 'Benötigen Sie weitere Hilfe?',
    URGENT_NUMBER: 'Bei dringenden Anliegen erreichen Sie unseren Kundenservice unter \n+33 187 660 083 (montags bis freitags, 10–12 Uhr und 14–17 Uhr).'
  },
  trackerLeftPanel: {
    CALL: 'Anrufen',
    CTR_ONLY_SECONDS: 'Sie können noch {{SECONDS}} Sekunde(n) in diesem Monat telefonieren.',
    CTR_WITH_MINUTES: 'Sie können noch {{MINUTES}} Minute(n) und {{SECONDS}} Sekunde(n) in diesem Monat telefonieren.',
    FLASH: 'Taschenlampe',
    GOOD_GPS_ACCURACY: 'Hohe GPS-Genauigkeit',
    LAST_POSITION: 'Letzter bekannter Position:',
    MEDIUM_GPS_ACCURACY: 'Mittlere GPS-Genauigkeit',
    OFFLINE: 'Tracker-Verbindung getrennt',
    POOR_GPS_ACCURACY: 'Geringe GPS-Genauigkeit',
    RING: 'Klingeln lassen',
    SMS_AVAILABLE: 'SMS verfügbar : {{SMS_count}}',
    VIBRATE: 'Vibrieren lassen'
  },
  trackerSettings: {
    BUTTONS: {
      LABELS: {
        BUTTON: 'Schaltfläche'
      },
      PLACEHOLDER_BUTTON: 'Geben Sie die Nachricht ein, die über die Taste {{button_number}} versandt werden soll',
      TEXT: 'Konfigurieren Sie die Nachrichten, die jeder Taste zugewiesen werden. Diese Meldung erhalten Sie, wenn eine entsprechende Taste gedrückt wird.'
    },
    CONTACTS: {
      ADD_EMAIL_BUTTON: 'E-Mail-Adresse hinzufügen',
      ADD_PHONE_BUTTON: 'Telefonnummer hinzufügen',
      EMAILS_LABEL: 'E-Mail-Adressen für die E-Mail-Benachrichtungen',
      MAIL: {
        PLACEHOLDER: 'ihre@email.com'
      },
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Kontakte aktualisiert'
      },
      NUMBERS_LABEL: 'Telefonnummern für die SMS-Benachrichtigungen',
      PHONE: {
        PLACEHOLDER: '+4900000000'
      }
    },
    DISPLAY: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten.',
        UPDATE_SUCCESS: 'Einstellungen aktualisiert'
      },
      MODAL: {
        HEADLINE: 'Icon auswählen',
        TEXT: 'Sie können das gewünschte Icon in der untenstehenden Liste auswählen. Es stellt Ihren Tracker auf der Karte dar.'
      },
      TRACKER_ICON: {
        EDIT_TEXT: 'Icon ändern',
        LABEL: 'Tracker-Symbol'
      },
      TRACKER_NAME: {
        LABEL: 'Tracker-Name',
        PLACEHOLDER: 'Name, der auf der Karte angezeigt wird'
      },
      TRACKER_TYPE: {
        CHANGE: 'Tracker-Typ ändern',
        MODIFIED_SUCCESS: 'Erfolgreich modifizierter Trackertyp'
      }
    },
    GENERAL_NAME_OF_THE_TRACKER: 'Name des Trackers',
    GENERAL_TITLE: 'Allgemein',
    GPS_FREQUENCY: {
      '10MIN': '10min',
      '10S': '10s',
      '1MIN': '1min',
      '2MIN': '2min',
      '30S': '30s',
      '3MIN': '3min',
      '5MIN': '5min',
      BATTERY_USAGE: 'Durchschnittliche Akkulaufzeit:',
      BATTERY_USAGE_LEVELS: {
        HIGH: 'Hoch',
        LOW: 'Schwach',
        MEDIUM: 'Mittel'
      },
      GEOFENCE_NOTIFICATIONS: 'Durchschnittliche Reaktionszeit der Zonenalarme:',
      HINT: 'Eine schnellere Frequenz reduziert die Akkulaufzeit, verkürzt aber die Reaktionszeit der Alarme beim Betreten und Verlassen von Zonen. Umgekehrt schont eine langsamere Frequenz den Akku, verlängert aber die Reaktionszeit der Alarme beim Betreten und Verlassen von Zonen.',
      OFF: 'AUS',
      TEXT: 'Wählen Sie das Zeitintervall für GPS-Berichte aus.'
    },
    NOTIFICATION_SETTINGS: {
      APP: 'App',
      BATTERY: {
        HINT: 'Es wird eine Benachrichtigung an alle Kontakte gesendet, wenn der Tracker kaum mehr Batterie hat.',
        TITLE: 'Akku'
      },
      BUTTONS: {
        HINT: 'Nach dem Drücken einer Seitentaste wird eine Benachrichtigung an alle Kontakte gesendet. Die für diese Taste festgelegte Nachricht wird mit der Benachrichtigung gesendet.',
        TITLE: 'Seitentasten'
      },
      GEOFENCES: {
        HINT: 'Es wird eine Benachrichtigung an alle Kontakte gesendet, wenn der Tracker eine festgelegte Zone eintritt oder verlässt.',
        TITLE: 'Sicherheitszonen'
      },
      MAIL: 'E-Mail',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Die Benachrichtigungseinstellungen wurden aktualisiert.'
      },
      POWERSAVINGAREA: {
        HINT: 'Sendet eine Benachrichtigung an alle Kontakte, wenn der Tracker eine eingerichtete Zone betritt oder verlässt.',
        TITLE: 'Energiesparzonen:'
      },
      SMS: 'SMS',
      SOS: {
        HINT: 'Nach dem Drücken der SOS-Taste wird eine Benachrichtigung an alle Kontakte gesendet.',
        TITLE: 'SOS Anruf'
      },
      WARNING: {
        SMS: {
          LINK: 'Klicken Sie hier, um sie zu aktivieren.',
          TEXT: 'Achtung! Wenn Sie Alarme per SMS erhalten möchten, müssen Sie die entsprechende Option aktivieren.'
        }
      }
    },
    REDIRECTION_MESSAGE: 'Sie können diese Einstellungen jederzeit in der Weenect App ändern.',
    SECTION_TITLES: {
      BUTTONS: 'Tasten',
      CONTACTS: 'Kontakte für die Benachrichtigungen',
      DISPLAY: 'Allgemein',
      GPS_FREQUENCY: 'Zeitintervall für GPS-Berichte',
      NOTIFICATION_SETTINGS: 'Art der Benachrichtigung für jeden Alarm',
      SOS: 'SOS-Nummer',
      TRAINING: 'Anrufen'
    },
    TRAINING_SOS: {
      DIRECT_CALL: 'Diese Nummer bei SOS-Warnmeldungen direkt anrufen.',
      INPUT_PLACEHOLDER: '+4900000000',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
        UPDATE_SUCCESS: 'Telefonnummer aktualisiert'
      },
      SOS_TEXT: 'Telefonnummer, die im Falle eines SOS-Alarms angerufen wird',
      TRAINING_TEXT: 'Geben Sie die Telefonnummer an, die der Tracker standardmäßig anruft, wenn die Telefonfunktion in der App benutzt wird. Diese Nummer kann bei jeder Anrufanfrage in der App bearbeitet werden.'
    }
  },
  trackerprofile: {
    AVATAR_PROMPT: 'Foto hinzufügen',
    ERROR_REQUIRED: 'Dieses Feld ist Pflicht',
    NAME_PLACEHOLDER: 'Geben Sie diesem Tracker einen Namen',
    SUBMIT_CTA: 'Weiter',
    SUBTITLE: 'Einige Angaben genügen, um ein passendes Profil zu erstellen',
    TITLE_ANIMAL: 'Passen Sie das Profil Ihres Begleiters an',
    TITLE_HUMAN: 'Passen Sie das Profil Ihres Angehörigen an',
    TYPE_CAT: 'Katze',
    TYPE_CHILD: 'Kind',
    TYPE_DOG: 'Hund',
    TYPE_ELDER: 'Senior',
    TYPE_PLACEHOLDER: 'Wählen Sie den Tracker-Typ'
  },
  trackerregistration: {
    ERROR_ALREADY_LINKED: 'Dieser Tracker ist bereits mit einem Konto verbunden',
    ERROR_INCOMPLETE: 'Die IMEI-Nummer muss 15 Ziffern lang sein',
    ERROR_INVALID: 'Ungültige IMEI-Nummer',
    SECTION_TITLE: 'Geben Sie die Identifikationsnummer des Trackers ein',
    SUBMIT_CTA: 'Ich bestätige die Identifikationsnummer',
    SUBTITLE: 'Sie finden sie auf der Rückseite Ihres Weenect-Trackers, sie besteht aus 15 Ziffern'
  },
  trackers: {
    ADD_TRACKER_BUTTON: {
      LABEL: 'Tracker hinzufügen'
    },
    EXPIRATION: {
      EXPIRED: 'Das Abo für {{tracker}} ist abgelaufen.',
      WILL_EXPIRE: 'Das Abo für {{tracker}} läuft in {{days}} Tagen ab.'
    },
    LINKS: {
      ACTIVITY: 'Aktivitätsverfolgung',
      GEOFENCES: 'Zonen',
      HISTORY: 'Verlauf',
      SETTINGS: 'Einstellungen',
      SUBSCRIPTION: 'Abo'
    }
  },
  trackersPositionRefresh: {
    MESSAGES: {
      NOT_REFRESHED: 'Ihr Tracker konnte die neuen GPS-Standorte nicht abrufen.',
      REFRESHING: 'Bitte warten, eine Update-Anfrage wird gerade bearbeitet.',
      SUCCESS: 'Die GPS-Standorte der Tracker wurden aktualisiert.'
    }
  },
  trackerstatus: {
    AIRPLANE: 'Tracker im Flugzeugmodus',
    BATTERY_OFF: 'Tracker wegen leerer Batterie ausgeschaltet',
    GSM_BAD: 'Schwach',
    GSM_GOOD: 'Gut',
    GSM_MEDIUM: 'Durchschnittlich',
    IN_AIRPLANE_MODE: 'In Flugzeugmodus',
    IN_POWER_SAVING_AREA: 'In Energiesparzone',
    LAST_COMMUNICATION_AGO: 'Letzte kommunikation vor %s',
    LAST_COMMUNICATION_ON: 'Letzte Position am %s',
    LAST_POSITION_AGO: 'Letzte Position vor %s',
    LAST_POSITION_ON: 'Letzte Position am %s',
    NO_BATTERY: 'Akku leer',
    NO_POSITION: 'Kein bekannter Standort',
    NO_SUBSCRIPTION: 'Kein aktives Abonnement',
    OFFLINE: 'Tracker getrennt',
    OFFLINE_GSM: 'Außerhalb des GSM-Netzes',
    OFFLINE_MANUAL: 'Ausgeschaltet manuell',
    ONLINE: 'Tracker verbunden',
    POSITION_BAD: 'Schwach',
    POSITION_GOOD: 'Gut',
    POSITION_MEDIUM: 'Durchschnitt',
    POSITION_WIFI_NO_NAME: 'Nicht identifiziert',
    TURN_OFF: 'Tracker manuell ausgeschaltet'
  },
  trackertab: {
    AIRPLANE_MODE_LABEL: 'Flugzeugmodus',
    NOTIFICATIONS_ALERT_BUTTONS_SUBTITLE: 'Sehen Sie die Nachricht ein, die den Tasten 2 und 3 Ihres Trackers zugewiesen ist. Sie erhalten diese Nachricht, wenn die Taste gedrückt wird.',
    NOTIFICATIONS_ALERT_BUTTONS_TITLE: 'Alarmtasten',
    NOTIFICATIONS_ALERT_ZONES_LABEL: 'Alarmzonen:',
    NOTIFICATIONS_BATTERY_LABEL: 'Akku:',
    NOTIFICATIONS_BUTTON_2_LABEL: 'Taste 2',
    NOTIFICATIONS_BUTTON_3_LABEL: 'Taste 3',
    NOTIFICATIONS_CONTACTS_SUBTITLE: 'Kontakte für Benachrichtigungen',
    NOTIFICATIONS_CREDITS_CALL: 'Sie haben noch {{minutes}} Minute(n) und {{seconds}} Sekunde(n) Telefonzeit für den aktuellen Monat.',
    NOTIFICATIONS_CREDITS_SMS: 'Sie haben noch {{sms}} SMS für den aktuellen Monat.',
    NOTIFICATIONS_CREDITS_TITLE: 'Verbleibende Guthaben',
    NOTIFICATIONS_EMAIL_ADDRESSES_LABEL: 'E-Mail-Adressen',
    NOTIFICATIONS_ENERGY_ZONES_LABEL: 'Energiesparzonen:',
    NOTIFICATIONS_PHONE_NUMBERS_LABEL: 'Telefonnummern',
    NOTIFICATIONS_SIDE_BUTTONS_LABEL: 'Seitentasten:',
    NOTIFICATIONS_SOS_CALL_LABEL: 'SOS-Anruf:',
    NOTIFICATIONS_TYPES_SUBTITLE: 'Benachrichtigungsarten für jede Alarmmeldung',
    PROFIL_ICON_LABEL: 'Tracker-Symbol',
    PROFIL_NAME_LABEL: 'Name des Trackers',
    PROFIL_SOS_PHONE_PLACEHOLDER: 'Telefonnummer, die SOS-Anrufe erhält',
    PROFIL_SOS_PHONE_TITLE: 'SOS-Anruf',
    PROFIL_TRACKER_CAT: 'Katzen-Tracker',
    PROFIL_TRACKER_CHILD: 'Kinder-Tracker',
    PROFIL_TRACKER_DOG: 'Hunde-Tracker',
    PROFIL_TRACKER_ELDER: 'Senioren-Tracker',
    PROFIL_TYPE_LABEL: 'Art des Trackers',
    ZONES_ALERTS_DANGER_SUBTITLE: 'Gefahrenzonen',
    ZONES_ALERTS_MOBILE_ONLY_NOTE: 'Das Ändern und Erstellen von Zonen erfolgt direkt in der Weenect Mobile App.',
    ZONES_ENERGY_MOBILE_ONLY_NOTE: 'Das Ändern, Erstellen von Zonen und Aktivieren des Flugzeugmodus erfolgt direkt in der Weenect Mobile App.',
    ZONE_ACTIVE_STATE: 'Active',
    ZONE_INACTIVE_STATE: 'Deaktiviert'
  },
  transferPage: {
    ADD_TRACKER: 'Ich möchte einen neuen Tracker zu meinem Konto hinzufügen',
    BACK_TO_TRACKERS: 'Zurück zur Karte',
    FIRST_TITLE: 'Was genau möchten Sie tun?',
    FROM_HEADLINE: 'Tracker, der ersetzt werden soll:',
    HEADLINE: 'Einen Tracker ersetzen',
    IMEI_LABEL: 'IMEI-Nummer',
    INFO: 'Das aktuelle Abonnement und die Einstellungen werden nach dem Austausch auf den neuen Tracker übertragen. Der GPS-Positionsverlauf des vorherigen Trackers geht verloren.',
    MESSAGES: {
      ERROR_UNKNOWN: 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
      SUCCESS: 'Neuer Tracker zugewiesen',
      WRONG_TYPE: 'Der Tracker mit dieser IMEI-Nummer entspricht nicht dem Typ Ihres alten Trackers. Bitte wenden Sie sich an unseren Kundenservice.'
    },
    NAME_LABEL: 'Tracker-Name',
    PURCHASE: 'Sie haben noch keinen Weenect-Tracker? <1>Hier können Sie einen kaufen.</1>',
    REPLACE_BUTTON: {
      LABEL: 'Ersetzen'
    },
    REPLACE_TRACKER: 'Ich möchte einen vorhandenen Tracker ersetzen',
    TO_HEADLINE: 'Neuer Tracker:'
  },
  translation: {
    account_payment_sepa_mandate: 'SEPA-Mandat'
  },
  webappDisconnection: {
    BUG: 'Nicht verbunden',
    MANUAL: 'Sie haben Ihren Tracker ausgeschaltet. Drücken Sie die ON-Taste, um das Gerät wieder einzuschalten.',
    NO_BATTERY: 'Ihr Tracker hat sich ausgeschaltet, weil der Akku leer war.',
    NO_SUB: 'Sie haben kein Abonnement für diesen Tracker. Bitte holen Sie sich eines, indem Sie auf die Website gehen'
  },
  weenectangels: {
    CARD_SEE_MORE: 'Mehr anzeigen',
    CARD_STATUS_LOST: 'VERLOREN',
    DETAIL_BREED: 'RASSE',
    DETAIL_CHIPPED: 'GECHIPT',
    DETAIL_COLOR: 'FARBE',
    DETAIL_CTA_WEBSITE: 'Mehr erfahren auf der Webseite',
    DETAIL_EARS: 'OHREN',
    DETAIL_FUR_DRAWING: 'FELLFARBE',
    DETAIL_FUR_SIZE: 'FELL',
    DETAIL_GENDER: 'GESCHLECHT',
    DETAIL_INFO: 'Diese Funktion kann jederzeit in Ihren Einstellungen geändert werden. Klicken Sie hier, um darauf zuzugreifen',
    DETAIL_LOST_ON: 'Verschwunden am {{date}}',
    DETAIL_PHYSICAL_DESCRIPTION: 'AUSSEHEN BESCHREIBUNG',
    DETAIL_REPORTED_ON: 'Gemeldet auf {{site}}',
    DETAIL_SIZE: 'GRÖSSE',
    DETAIL_STATUS_LOST: 'VERLOREN',
    DETAIL_STERILIZED: 'STERILISIERT',
    DETAIL_TATTOOED: 'TÄTOWIERT'
  },
  wifiZones: {
    AIRPLANE_TEXT: 'Achtung: Im Flugzeugmodus können Sie Ihren Tracker, solange er sich in der Energiesparzonen befindet, nicht mehr klingeln oder vibrieren lassen  oder seine Position manuell aktualisieren.',
    DEEP_SLEEP_TITLE: 'Flugzeugmodus',
    DISPLAY_BUTTON: 'Zone auf der Karte anzeigen',
    DISPLAY_TITLE: 'Benachrichtigungen',
    IN_AIRPLANE: '- in Flugzeugmodus',
    IN_OUT_TEXT: 'Ein- und Ausgänge der Zone:',
    LAST_POS_IN_WIFI: 'In der Energiesparzonen seit {{date}} ',
    MAIL_NOTIF: 'Mail Benachrichtigungen',
    NOTIF_TEXT: 'Erhalten Sie eine Benachrichtigung über jeden Ein- und Ausstieg aus dem vordefinierten Bereich',
    POPIN: {
      AIRPLANE: {
        BUTTON_VALIDATE: 'Den Flugzeugmodus verlassen',
        CONTENT: 'Sie können nicht mehr mit Ihrem Tracker kommunizieren, solange er sich in der Energiesparzonen befindet. Wenn Sie die volle Funktionalität wiederherstellen möchten, <strong>schalten Sie den Flugzeugmodus aus und nehmen Sie den Tracker aus der Zone heraus. </strong>',
        TITLE: 'Ihr tracker befindet sich im Flugzeugmodus in der energiesparzone {{wifiName}}'
      },
      BUTTON_CLOSE: 'Später',
      BUTTON_VALIDATE: 'Diese Zone deaktivieren',
      CONTENT: 'In dieser Zone ist das automatische Abrufen der GPS-Positionen Ihres Trackers deaktiviert, da wir wissen, dass es sich in der Zone befindet. Sie können diese Zone jederzeit im Tab "Tracker" deaktivieren.',
      TITLE: 'Ihr tracker befindet sich in der energiesparzone {{wifiName}}.'
    },
    PUSH_NOTIF: 'Push-Benachrichtigungen',
    SMS_NOTIF: 'SMS-Benachrichtigungen',
    TITLE: 'Energiesparzonen',
    ZONE_ACTIVATION: 'Zonenaktivierung'
  }
}
